import { setSanitizedHtml } from 'src/app/common/_helpers/html-sanitizer.util';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../../Services/snapshot-shared-variables.service';
import { SnapshotService } from '../../Services/snapshot.service';
import { UserProjectManagementService } from 'src/app/common/services/user-project-management.service';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { debounceTime, first, Subscription } from 'rxjs';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import * as _ from 'lodash';
import * as domtoimage from 'dom-to-image-more';
import { saveAs } from 'file-saver';
import {
  AlertMessageModel,
  InsightsModel,
  results,
} from 'src/app/common/models/common.model';
import {
  CheckboxSelectionModel,
  COMMON_CONSTANTS,
  COMMON_CONSTANTS_SETTING,
  COMMON_CONSTANTS_SNAPSHOT,
} from 'src/app/common/constants/common-constants';
import { Feature } from 'src/app/common/models/usermanagement.model';
import { CustomVariableService } from 'src/app/common/services/custom-variables.service';
import { CommonChartmoduleService } from '../../Services/common-chartmodule.service';
import {
  ExcelExportReport,
  ExcelExportReportInputs,
} from 'src/app/common/models/excel-export-report.model';
import { LeftpanelComponent } from '../../modules/leftpanel/leftpanel.component';
import { CustomWidgetOutputComponent } from '../custom-widget-output/custom-widget-output.component';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { checkboxSelectionWithParent } from 'src/app/common/models/chatbotexpand.model';
import { BarserviceService } from '../../../snapshot/custom-snapshot-chart-modules/barchart/barchart/barservice.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { LandingService } from 'src/app/core/services/landing.service';


@Component({
  selector: 'app-custom-outputview',
  templateUrl: './custom-outputview.component.html',
  styleUrls: ['./custom-outputview.component.css'],
})
export class CustomOutputviewComponent implements OnInit, OnDestroy {
  hideCharts: boolean = false;
  @Input() isSubmitReset: boolean = false;
  @Input() isIndex: boolean = false;
  showAiAlert = false;
  showNegativeValuesAlert = false;
  negativeValuesAlertMessage = '';
  isApplyBase: boolean = true;
    // Tracks the key of the selected brand (checked radio)
    selectedBrandKey: boolean=false;
multiCohort:boolean=false;  // Brand dropdown state
  brandDropDownToggle: boolean = false;
  brandList: any[] = [];
  brandSelectedValue: string = '';
  hasBrandDependentCharts: boolean = false;
  brandSearchQuery: string = '';

  @ViewChild(forwardRef(() => LeftpanelComponent)) child!: LeftpanelComponent;
  @ViewChild(CustomWidgetOutputComponent)
  customWidgetChild!: CustomWidgetOutputComponent;
  @ViewChild('inforRibbon', { static: false }) inforRibbon:
    | ElementRef
    | undefined;
  @Input() selectedWeight: string = '';
  @Input() outputData: any = {};
  @Input() chartList_Data: any = {};
  @Input() chartData: any = {};
  @Input() sigIndex: string = '';
  @Input() threshold: string = '';
  @Input() isCustom_Calc: boolean = false;

  @Output() pageCounterChanged = new EventEmitter<number>();
  colorPalette =
    this.barService.color1?.length > 0
      ? this.barService.color1
      : this.barService.commonchartmodules.color1;
trendDataResult :any=[];
  // Snapshot of the non-trend (outputArray) data taken right before a trended
  // export fires its trend-only API call. The trend response leaves the non-trend
  // array empty (TP-format mismatch), so this snapshot is used to backfill outputArray.
  private _preExportNonTrendArray: any = null;
  linearGradientsColorPalette = this.barService.linearGradients;
  selectedAudienceBrandObj: any = null;
  globalColorMap: { [key: string]: string } = {};
  globalColorMapLinearGradient: { [key: string]: string } = {};
  CustomBaseOptions:any[]=[];
  //pageCount: any;
  InsightsData: any;
  SnapShotData: any;
  SnapShotInputData: any = [];
  IsEntrypoint: boolean = false;
  innerSelection: any = {};
  docStorageData: any;
  isTriggerFromButton = false;
  isCustomBaseSelected: boolean = false;
  isDocumentRepositoryClick: boolean = false;
  hasDocuments: boolean = false;
  hasUserDefineSaveSelection = true;
  insightsObj: InsightsModel = {
    header: '',
    message: '',
    show: false,
  };
  selectedBrandKeyRef: boolean=false;
  $unSubscribeSubmitData!: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    // sessionStorage.setItem('dataLoaded','true');
    // //Perform an operation if either pageData or widgetData changes
    // if (changes['outputData']) {
    //   this.pageCounter = this._configCustomService.pageCount;
    //   this.SnapShotData=this._configService.standardSnapOutputData;
    //   if (Object.keys(changes['outputData'].currentValue).length != 0) {
    //    this.outputDataRefresh();
    //   }
    // }
    // if(changes['sigIndex'] && this.sigIndex != 'sig'){
    //   if(Object.keys(this.outputData).length > 0){
    //   this.outputDataRefresh();
    //   }
    // }
  }
  outputDataRefresh() {
    this._loaderService.showLoader();
    this.hideCharts = true;
    this.data = [];
    this.gridData = [];
    this.outputPageData = [];
    this.handleSectionOrSubsectionChange();
  }
  outputPageData: any = [];
  datafromLayout: any = [];
  data: any = [];
  pagesConfiguredFromLayout: any;
  totalNumberOfCharts: number = 0;
  columnPerRowCount: number = 0;
  //baseSelected: string = "total base";
  showGlobalDefaultPopup: boolean = false;
  dontShowAgain: boolean = false;

  handleSectionOrSubsectionChange() {
    this.chartList = [];
    this.pageCounter = this._configCustomService.pageCount; //on change of section/subsection move to page 1
    this.disableLeftClick = true;
    this.disableRightClick = false;
    //this.updateNavigationButtonsState();
    let pages = [];
    for (let i = 0; i < this.outputData.pageData.length; i++) {
      pages.push({
        page: this.outputData.pageData[i].key,
        selectedLayout: this.outputData.pageData[i].value, // Default value will be `null`
        disabled: false,
        dropdownOpen: false, // Add a flag to track dropdown state
        layout: [
          { label: 'Select a layout', value: null, selected: false },
          {
            label: '6 Widget Layout',
            value: 6,
            url: '../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png',
            selected: this.outputData.pageData[i].value == 6 ? true : false,
          },
          {
            label: '4 Widget Layout',
            value: 4,
            url: '../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png',
            activeurl:
              '../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png',
            selected: this.outputData.pageData[i].value == 4 ? true : false,
          },
        ],
      });
    }
    this.datafromLayout = pages;

    let sum = 0;
    let count = 0;
    this.datafromLayout.forEach((val: any) => {
      if (val.selectedLayout != null) {
        sum = sum + val.selectedLayout;
        count++;
      }
    });
    //If no. of pages configured in layout is only one then disable right pagination click
    if (count == 1) {
      this.disableRightClick = true;
    }
    //this.totalNumberOfCharts=this.snapShotService.LayoutDiv;
    this.pagesConfiguredFromLayout = count;
    this.totalNumberOfCharts = sum;
    this.columnPerRowCount = sum;

    for (let i = 0; i < this.totalNumberOfCharts; i++) {
      this.chartList.push({
        customizationProperties: '',
        metric: [],
        previewChartPostion: -1,
        widgetParentChartType: '',
        widget_name: '',
        widgetchart_name: '',
      });
    }

    //Adding widget details in chartList
    for (let i = 0; i < this.outputData.widgetData.length; i++) {
      if (this.outputData.widgetData[i].previewChartPostion == 0) {
        continue;
      }
      this.chartList[this.outputData.widgetData[i].previewChartPostion - 1] =
        this.outputData.widgetData[i];

      //this.chartList1[this.outputData.widgetData[i].previewChartPostion - 1] = this.outputData.widgetData[i];
    }
    this.hideCharts = true;
    setTimeout(() => {
      this.createInitialChartList();
      this.outputData =
        (this._configService.selectedcompareacrossOption.includes('Multiple') || 
         this._configService.selectedcompareacrossOption == 'Audience Snapshot')
          ? this.paginatedDataMultiple()
          : this.paginatedData();
      this._configService.InsightsData = this.data;

      if (
        this.data.length == 1 &&
        (this.data[0].widgetchart_name == 'FUNNEL CHART' ||
          this.data[0].widgetchart_name == 'Propeller Chart')
      ) {
        this.prepareGridForMultiFunnel(this.data[0]);
      }

      this.hideCharts = false;
      this._loaderService.hideLoader();
      const skipPopup =
        localStorage.getItem('dontShowGlobalDefaultPopup') === 'true';
      if (
        this._configService.isGlobalDefaultSelectionEnabled &&
        this._configService.showGlobalDefaultPopup &&
        !skipPopup
      ) {
        this.showGlobalDefaultPopup = true;
      }
    }, 1000);
  }

  gridData: any[] = [];
  prepareGridForMultiFunnel(customData: any) {
    customData.metric[0].metric_value[0].data.forEach((d: any) => {
      // this.brandList.push(d.colChild);
      this.gridData.push({
        header: d.colChild,
        data: customData,
      });
    });
  }
async prepareTrendMetricValues() {
  if (!this.itemWithoutTrendItems) return;
  await Promise.all(
    this.itemWithoutTrendItems.map(async (item: any) => {
      if (
        item.widgetchart_name &&
        item.widgetchart_name.toLowerCase() === 'trend as widget' &&
        Array.isArray(item.metric) &&
        item.metric.length > 0
      ) {
        // Await the resolved value
        item.metric[0].metric_value = await this.getTrendData(item);
      }
    })
  );
}
  createInitialChartList() {
    // ;
    // for (let i = 0; i < this.totalNumberOfCharts; i++) {
    //   this.chartList.push({
    //     widgetName: "",
    //     image: ""
    //   });
    // }
    //Based on page number assign this.columnPerRowCount
    let page = this.datafromLayout.filter((item: any) => {
      return JSON.stringify(item).includes('Page ' + this.pageCounter);
    });
    if (page.length > 0) {
      this.columnPerRowCount = page[0].selectedLayout;

      this.gridTempleteColumns = '';
      if (this.columnPerRowCount === 2) {
      this.gridTempleteColumns = '100%'; 
      } 
      else {
        for (let i = 0; i < this.columnPerRowCount / 2; i++) {
          this.gridTempleteColumns +=
            this.calculateValuePerDivision(this.columnPerRowCount / 2) + '% ';
        }
      }
    }
  }
  calculateValuePerDivision(numDivs: any) {
    const k = 99; // considering for 2 always 27.5.So reciprocal method: 27.5=k/2=>55.
    //so now for 3 it will be 55/3 ,for 4 it will be 55/4 and so on....
    return k / numDivs;
  }

  //  chartList: {
  //   widgetName: string,
  //   image: string
  // }[] = [];
  chartList: any[] = [];
  globalItems: any[] = [];
  gridTempleteColumns: string = '';

  settingOptionList = COMMON_CONSTANTS_SETTING;
  isInsightsBtnEnabled: boolean = false;
  isGlobalDefaultSelected = false;
  showLeftPanel = false;
  isfilterSelected = true;
  isSavedSelectionSelected = false;
  isFeaturesSelected = false;
  isCustomVariable = false;
  isCustomReport = false;
  isSubmitClicked: boolean = false;
  isReportIssue: boolean = false;
  showDefaultPanel: boolean = false;
  isInitialLoading: boolean = true;
  showCustomVariable: boolean = false;
  hasTrendline: boolean = false;
  isTrendlineInExportsEnabled: boolean = false;
  AcrossDropdown: any;
  IsPPTDownloadClicked: boolean = false;
  typeSelected: string = '';
  baseTypeSelected: string = '';
  showExportsDownloadsPopup: boolean = false;
  isAcrossdropDown: boolean = false;
  saveSelectionGlobalDefault: any[] = [];
  SnapShot_InsightsData: any = [];
  //sigIndex: string = 'sig';
  InsightsResponse: any = '';
  arktabaccess: boolean = false;
  ShareColumn: string = '';
  BaseColumn: string = '';
  isInsightspopupOpen: boolean = false;
  showSnapshot: boolean = false;
  insightsVal: any;
  selectedDataFormat: string = '';
  isTotalBase: boolean = false;
  isSig: boolean = true;
  isChartView: boolean = true;
  isWeightedLabel: boolean = false;
  isWeightedNumerator: boolean = false;
  isUnWeightedNumerator: boolean = false;
  is_Time_Period_Present: boolean = true;
  isData: boolean = true;
  DefaultDataDropDown: string = 'Data';
  isVerticalGroupBarChartClick: boolean = false;
  isVerticalBarChartClick: boolean = false;
  isVerticalStackChartClick: boolean = false;
  isLineChartClick: boolean = false;
  DefaultSampleSize: string = 'None';
  DefaultReferenceLevel: string = 'None';
  DefaultConfidenceLevel: string = '';
  SignificanceVsReference: string = '';
  isReference: boolean = false;
  selectedIndex: string = '';
  isPairWise: boolean = false;
  isTranspose: boolean = false;
  IndexData: any;
  columnLength: number = 0;
  DefaultWeight: string = '';
  isFilteringActive: boolean = true;
  ReportIssueselectionSummary: string = '';
  confidenceLevelDropDown: boolean = false;
  isRowNesting: boolean = false;
  isColumnNesting: boolean = false;
  is_TransposeBtn: boolean = false;
  filteringAnsBlock: boolean = false;
  AnsBaseBlock: boolean = false;
  is_sigtesting: boolean = false;
  SampleSizeList: any = [];
  is_confidenceLevel: any = [];
  pptExport: any;
  repository: any;
  lowBaseIdentifier: any;
  is_StoryBoard: boolean = false;
  is_Column_Row_Percentage: boolean = false;
  is_indexing: boolean = false;
  is_indexingShow: boolean = false;
  is_chart_visualization: boolean = false;
  aggregatedVariables: any = [];
  configWeights: any;
  isLoadSelectionBtn: boolean = false;
  SampleSizeContainer = false;
  isSampleSizeBlock: boolean = false;
  isWeightedSampleBlock: boolean = false;
  mandatoryVariableMapping: any;
  isSelectAllMetrics: boolean = false;
  isSelectAllMetricsLevel: boolean = false;
  SingleBrandData: any = [];
  BIPSelected: boolean = false;
  widgetString: string = '';
  isCrosstabActive: boolean = false;
  isBrandAnalysisActive: boolean = false;

  sectionSelected(section: string) {
    if (section === 'filter') {
      this.isfilterSelected = true;
      this.isSavedSelectionSelected = false;
      this.isFeaturesSelected = false;
      this.isCreateCustomGroup = false;
      if (!this.isSubmitReset) {
        this.isSubmitReset = false;
      }
      this.isCustomVariable = false;
      this.isCustomReport = false;
    } else if (section === 'savedSelection') {
      this.isfilterSelected = false;
      this.isSavedSelectionSelected = true;
      this.isFeaturesSelected = false;
      this.isCustomVariable = false;
      this.isCreateCustomGroup = false;
      this.isCustomReport = false;
      this.child.LoadSelection(false);
      this.resetLeftpanelWidth();
    } else if (section === 'features') {
      this.isfilterSelected = false;
      this.isSavedSelectionSelected = false;
      this.isFeaturesSelected = true;
      this.isCustomVariable = false;
      this.child.additionalFeaturesOption('Custom Variable');
      this.isCustomReport = true;
      if (!this.isCreateCustomGroup) {
        this.resetLeftpanelWidth();
      }
    }
  }

  IsEntrypointSelected(event: any) {
    this.IsEntrypoint = event;
  }

  onFeaturesSectionClick(section: any) {
    if (section == 'customVariable') {
      this.isCustomVariable = true;
      this.isCustomReport = false;
      this.child.additionalFeaturesOption('Custom Variable');
    } else if (section == 'customReport') {
      this.isCustomVariable = false;
      this.isCustomReport = true;
      this.isCreateCustomGroup = false;
    }
  }
  paginatedData() {
    this.globalColorMap = {};
    this.globalColorMapLinearGradient = {};
    this.outputData = this._configService.standardSnapOutputData; //remove later
    let start = 0;
    if (this.pageCounter == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCounter - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount - 1;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        item.toggleButton = true;
      }
      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputData.find(
                (row: any) =>
                  row.rowChild.includes(metric.option) &&
                  row.widgetNumber == item.widgetNumber &&
                  item.widgetName == row.widgetName
              )
            );
            if (
              this.baseselected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseselected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });
    this._configCustomService.pageCount = this.pageCounter;
    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      let globalColorIndex = 0;
      const metricValues = widget.metric[0].metric_value;
      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          if (this._configService.selectedSnapshotType == 'Single Brand') {
            colorKey = metricValue.option;
          }

          // Assign color consistently across all widgets
          if (!this.globalColorMap[colorKey]) {
            this.globalColorMap[colorKey] = this.colorPalette[globalColorIndex];
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex];
            globalColorIndex++;
          }

          const color = this.globalColorMap[colorKey];
          const colorLinearGradient =
            this.globalColorMapLinearGradient[colorKey];

          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });

    //this._configCustomService.pageCount = this.pageCount;
    this.globalItems = items;
    return items;
  }

  paginatedDataMultiple() {
    this.globalColorMap = {};
    this.globalColorMapLinearGradient = {};
    this.outputData = this._configService.standardSnapOutputData; //remove later
    let start = 0;
    if (this.pageCounter == 0) {
      start = 0;
    } else {
      for (let i = 0; i < this.pageCounter - 1; i++) {
        start = start + this.datafromLayout[i].selectedLayout;
      }
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    const end = start + this.columnPerRowCount;
    let chartlist = this.chartList.slice(start, end);
    let pageCounter = 1;
    let item = chartlist;
    let items = _.cloneDeep(chartlist);

    items.forEach((item: any) => {
      if (item.widgetchart_name == 'Table') {
        let m = JSON.parse(item.customizationProperties);
        item.enableDataBars = m.enableDataBars;
        item.toggleButton = true;
      }

      item.metric.forEach((itemLev1: any) => {
        if (itemLev1.metric_group == '' && itemLev1.metric_value.length > 0) {
          let allMetricsNull = true;
          itemLev1.metric_value.forEach((metric: any) => {
            const outputRow = _.cloneDeep(
              this.outputData.find(
                (row: any) =>
                  row.rowChild.includes(metric.option) &&
                  row.colChild.includes(metric.colChild) &&
                  row.widgetNumber == item.previewChartPostion &&
                  item.widget_name == row.widgetName
              )
            );
            if (
              this.baseselected.toLowerCase() != 'total base'
                ? outputRow?.answerWeightedShare !== null
                : outputRow?.totalWeightedShare !== null
            ) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        } else if (
          itemLev1.metric_group != '' &&
          itemLev1.metric_value.length == 0
        ) {
          let allMetricsNull = true;
          const metrics = this._configService.standardSnapOutputData.filter(
            (row: any) =>
              row.widgetNumber == item.widgetNumber &&
              item.widgetName == row.widgetName
          );
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
              if (
                this.baseselected.toLowerCase() != 'total base'
                  ? metric?.answerWeightedShare !== null
                  : metric?.totalWeightedShare !== null
              ) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        } else if (
          itemLev1.metric_group == '' &&
          itemLev1.metric_value.length == 0
        ) {
          item.metric = [];
        }
      });
    });
    this._configCustomService.pageCount = this.pageCounter;

    items.forEach((widget) => {
      if (!widget.widget_name || !widget.metric || widget.metric.length === 0)
        return;
      let globalColorIndex = 0;
      const metricValues = widget.metric[0].metric_value;

      metricValues.forEach((metricValue: any) => {
        metricValue.data = metricValue.data.map((entry: any) => {
          const colChild = entry.colChild;
          const rowChild = entry.rowChild;
          let colorKey = colChild;
          if (this._configService.selectedSnapshotType == 'Single Brand') {
            colorKey = metricValue.option;
          }

          // Assign color consistently across all widgets
          if (!this.globalColorMap[colorKey]) {
            this.globalColorMap[colorKey] = this.colorPalette[globalColorIndex];
            this.globalColorMapLinearGradient[colorKey] =
              this.linearGradientsColorPalette[globalColorIndex];
            globalColorIndex++;
          }

          const color = this.globalColorMap[colorKey];
          const colorLinearGradient =
            this.globalColorMapLinearGradient[colorKey];

          return {
            ...entry,
            color,
            colorLinearGradient,
          };
        });
      });
    });
    this.globalItems = items;
    return items;
  }

  submitReset($event: any) {
    this.isSubmitReset = $event;
  }

  ResetClicked() {
    this.child.ResetClicked();
  }

  SubmitClicked(isDefaultPanel: boolean = false) {
    this.innerSelection = {};
    if (this._configService.tiggerSelectionSnapshotType) {
      this.child.SubmitClicked(false, isDefaultPanel);
    } else {
      this.innerSelection.displayConfidenceLevel =
        this.y1.DefaultConfidenceLevel;
      this.innerSelection.significanceVsReference =
        this.y1.SignificanceVsReference;
      this.innerSelection.indexVsBrandReference = this.y1.indexVsBrandReference;
      this.innerSelection.isTotalBase = this.y1.isTotalBase;
      this.innerSelection.selectedWeight = this.y1.selectedWeight;
      this.innerSelection.significanceVsBrandReference =
        this.y1.significanceVsBrandReference;
      this.innerSelection.significance = this.y1.significance;
      this.innerSelection.weightSelectedValue = this.weightSelectedValue;
      this.innerSelection.brand = this.selectedSigBrand;
      this.innerSelection.selectedReference = this.selectedReference;
      this.innerSelection.customBaseMetric = this.selectedCustomBaseReference;
      this.child.SubmitClicked(
        false,
        isDefaultPanel,
        false,
        this.innerSelection
      );
    }
    this.y1 = this._configService.passdata ?? this.y1;
    this.updateBaseAvailabilityForCustomPctMeanVariables();
    this.cdr.detectChanges();
    this.getFilteredBrandList();
  }

  // for saved selection
  isUserDefinedListVisible: boolean = true;
  isSharedWithMeListVisible: boolean = false;
  isChangeOfEntryPointConfigured: boolean = true;
  userDefinedSelectionQuery: string = '';
  selectionName = '';
  infoMessage: string = '';
  sharedWithMeSelectionQuery: string = '';
  displayTable: boolean = false;
  columnConfig: any[] = [
    {
      name: 'Selections',
      userDefined_width: '50%',
      imageName: '',
      sharedWithMe_width: '40%',
    },
    {
      name: 'Set as Default',
      userDefined_width: '12%',
      imageClass: 'LoadImage',
      sharedWithMe_width: '13%',
    },
    {
      name: 'Load',
      userDefined_width: '10%',
      imageClass: 'LoadImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Info',
      userDefined_width: '10%',
      imageClass: 'InfoImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Delete',
      userDefined_width: '10%',
      imageClass: 'DeleteImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Share',
      userDefined_width: '10%',
      imageClass: 'ShareImage',
      sharedWithMe_width: '10%',
    },
  ];
  bindBackClickEvent() {
    this.displayTable = false;
  }
  toggleSaveSelectionList(containerName: string) {
    if (containerName == 'userDefined') {
      this.isUserDefinedListVisible = !this.isUserDefinedListVisible;
      this.isSharedWithMeListVisible = false;
    } else if (containerName == 'Shared With Me') {
      this.isUserDefinedListVisible = false;
      this.isSharedWithMeListVisible = !this.isSharedWithMeListVisible;
    }
  }

  selectDefaultLoadOption(
    event: Event,
    option: string,
    object: any,
    scenarioType: string
  ) {
    event.stopPropagation();
    this.selectionName = option;
    if (scenarioType == 'userDefined') {
      var sharedSelectedDefault = this.loadSharedWithMeSavedScenarioData.find(
        (a: any) =>
          a.snapshotType === object.snapshotType &&
          a.snapshotName == object.snapshotName &&
          a.section == object.section &&
          a.shared_details?.[0]?.is_Shared_default &&
          (object.subSection !== 'NA' &&
          object.subSection !== null &&
          object.subSection !== undefined
            ? a.subSection === object.subSection
            : true)
      );
      if (sharedSelectedDefault) {
        sharedSelectedDefault.shared_details[0].is_Shared_default = false;
        this.subscriptions.add(this._configService
          .setDefaultLoadSelection(
            sharedSelectedDefault.study,
            sharedSelectedDefault.client_name,
            sharedSelectedDefault.snapshotName,
            sharedSelectedDefault.snapshotType,
            sharedSelectedDefault.section,
            sharedSelectedDefault.subSection,
            sharedSelectedDefault.selection_name,
            'Shared With Me',
            sharedSelectedDefault.module_id,
            false
          )
          .subscribe((result: results) => {}));
      }
      var selectedDefault = this.loadUserDefinedSavedScenarioData.find(
        (a: any) =>
          a.snapshotType === object.snapshotType &&
          a.snapshotName == object.snapshotName &&
          a.section == object.section &&
          a.is_default &&
          a.module_id !== object.module_id &&
          (object.subSection !== 'NA' &&
          object.subSection !== null &&
          object.subSection !== '' &&
          object.subSection !== undefined
            ? a.subSection === object.subSection
            : true)
      );
      if (selectedDefault) {
        selectedDefault.is_default = false;
        this.subscriptions.add(this._configService
          .setDefaultLoadSelection(
            selectedDefault.study,
            selectedDefault.client_name,
            selectedDefault.snapshotName,
            selectedDefault.snapshotType,
            selectedDefault.section,
            selectedDefault.subSection,
            selectedDefault.selection_name,
            scenarioType,
            selectedDefault.module_id,
            false
          )
          .subscribe((result: results) => {}));
      }

      this.loadUserDefinedSavedScenarioData
        .filter(
          (a: any) =>
            a.snapshotType === object.snapshotType &&
            a.snapshotName == object.snapshotName &&
            a.section == object.section &&
            (object.subSection !== 'NA' &&
            object.subSection !== null &&
            object.subSection !== '' &&
            object.subSection !== undefined
              ? a.subSection === object.subSection
              : true)
        )
        .forEach((row: any) => {
          if (row.selection_name == option) {
            row.is_default = !row.is_default;
            this._configService.isSetDefault = row.is_default;
            this.subscriptions.add(this._configService
              .setDefaultLoadSelection(
                object.study,
                object.client_name,
                object.snapshotName,
                object.snapshotType,
                object.section,
                object.subSection,
                object.selection_name,
                scenarioType,
                object.module_id,
                row.is_default
              )
              .subscribe((result: results) => {}));
          } else {
            row.is_default = false;
          }
        });
    } else {
      var selectedUserDefined = this.loadUserDefinedSavedScenarioData.find(
        (a: any) =>
          a.snapshotType === object.snapshotType &&
          a.snapshotName == object.snapshotName &&
          a.section == object.section &&
          a.is_default &&
          (object.subSection !== 'NA' &&
          object.subSection !== null &&
          object.subSection !== '' &&
          object.subSection !== undefined
            ? a.subSection === object.subSection
            : true)
      );
      if (selectedUserDefined) {
        selectedUserDefined.is_default = false;
        this.subscriptions.add(this._configService
          .setDefaultLoadSelection(
            selectedUserDefined.study,
            selectedUserDefined.client_name,
            selectedUserDefined.snapshotName,
            selectedUserDefined.snapshotType,
            selectedUserDefined.section,
            selectedUserDefined.subSection,
            selectedUserDefined.selection_name,
            'userDefined',
            selectedUserDefined.module_id,
            false
          )
          .subscribe((result: results) => {}));
      }

      var sharedSelectedDefault = this.loadSharedWithMeSavedScenarioData.find(
        (a: any) =>
          a.snapshotType === object.snapshotType &&
          a.snapshotName == object.snapshotName &&
          a.module_id !== object.module_id &&
          a.section == object.section &&
          a.shared_details?.[0]?.is_Shared_default &&
          (object.subSection !== 'NA' &&
          object.subSection !== null &&
          object.subSection !== undefined
            ? a.subSection === object.subSection
            : true)
      );

      if (sharedSelectedDefault) {
        sharedSelectedDefault.shared_details[0].is_Shared_default = false;
        this.subscriptions.add(this._configService
          .setDefaultLoadSelection(
            sharedSelectedDefault.study,
            sharedSelectedDefault.client_name,
            sharedSelectedDefault.snapshotName,
            sharedSelectedDefault.snapshotType,
            sharedSelectedDefault.section,
            sharedSelectedDefault.subSection,
            sharedSelectedDefault.selection_name,
            scenarioType,
            sharedSelectedDefault.module_id,
            false
          )
          .subscribe((result: results) => {}));
      }

      this.loadSharedWithMeSavedScenarioData
        .filter(
          (a: any) =>
            a.snapshotType === object.snapshotType &&
            a.snapshotName == object.snapshotName &&
            a.section == object.section &&
            (object.subSection !== 'NA' &&
            object.subSection !== null &&
            object.subSection !== undefined
              ? a.subSection === object.subSection
              : true)
        )
        .forEach((row: any) => {
          if (row.selection_name == option) {
            row.shared_details[0].is_Shared_default =
              !row.shared_details[0].is_Shared_default;
            this._configService.isSetDefault =
              row.shared_details[0].is_Shared_default;
            this.subscriptions.add(this._configService
              .setDefaultLoadSelection(
                object.study,
                object.client_name,
                object.snapshotName,
                object.snapshotType,
                object.section,
                object.subSection,
                object.selection_name,
                scenarioType,
                object.module_id,
                row.shared_details[0].is_Shared_default
              )
              .subscribe((result: results) => {}));
          } else {
            row.shared_details[0].is_Shared_default = false;
          }
        });
    }
  }

  handleLoadOptionsClick(
    columnName: string,
    row: any,
    scenarioType: string // user defined or shared with me
  ): void {
    this.bindcurrentSavedScenarioData({ currentSavedScenarioData: row });
    if (columnName.toLowerCase() === 'load') {
      sessionStorage.removeItem('dataLoaded');
      this._loaderService.showLoader();

      this.$unSubscribeSubmitData6 = this._configService
        .getSavedScenarioData(
          row.study,
          row.client_name,
          row.snapshotName,
          row.snapshotType,
          row.section,
          row.subSection,
          row.selection_name,
          scenarioType,
          row.module_id
        )
        .subscribe((result: results) => {
          this.onCloseIconClick({
            isLoadClickOutput: false,
          });
          // this.isLoadClick = false;

          this.showLoaderPopUp = false;
          // Response is valid
          if (result.HasValidData) {
            this.bindSelectedScenario({
              selectedScenarioData: JSON.parse(result.Data),
              columnName: '',
            });
          } else {
            this._loaderService.hideLoader();
          }
          //hide the loader
        });
    } else if (columnName.toLowerCase() === 'delete') {
      this.bindDeleteMessage({
        deleteMessage:
          'Confirm to delete "' + row.selection_name + '"  selection',
        selectionType: scenarioType,
      });

      this.updateShowDialog({ isShowDialog: true });
    } else if (columnName.toLowerCase() === 'info') {
      this.displayTable = true;
      this.infoMessage = row.selection_summary;
      // this.infoMessage.emit({ infoMessage: row.selectionSummary });
    } else if (columnName.toLowerCase() == 'share') {
      this.ShareSelection({
        isValidationPass: true,
        selectionName: row.selection_name,
        isShareSelection: true,
        selectionType: scenarioType,
        is_CustomGroup: row.is_CustomGroup,
      });
    }
  }

  //for parent ad output view

  @Input() exportDownloads: boolean = true;

  isCustomGroupClick: boolean = false;
  isCustomReportClick: boolean = false;
  isShareMetric: boolean = false;
  isCreateCustomGroup: boolean = false;
  isUpdateCustomGroup = false;
  isDeleteCustomGroup = false;
  isDuplicateCustomGroup = false;
  isShareCustomGroupPopupClick = false;
  isCustomReportSnapshotClick: boolean = false;
  summaryViewHeader: string = 'Save Selections';
  isSelectionSummaryClick: boolean = true;
  bindCustomGroupFlagsData: any;
  snapshotselected: any = '';
  subsectionselected: any = '';
  sectionselected: any = '';
  is_AI_Integration: boolean = false;
  constructor(
    private barService: BarserviceService,
    private router: Router,
    public _configService: SnapshotService,
    public clientDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private _configData: SnapshotService,
    private _usermanagementService: UserProjectManagementService,
    private _alertService: AlertMessageService,
    private _configCustomService: CustomsnapshotService,
    private commonchartmodules: CommonChartmoduleService,
    private customVariableService: CustomVariableService,
    private _insightsSerive: InsightspopupService,
    private apiService: ChatbotService,
    private renderer: Renderer2,
    private crossTabService: CrosstabService,
    private landingService: LandingService
  ) {
    let sectionName = sessionStorage.getItem('sectionName');
    let subsectionName = sessionStorage.getItem('subsectionName');
    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras.state) {
      const raw = localStorage.getItem('askme_snapshot_redirect');
      if (raw) {
        try {
          const r = JSON.parse(raw);
          this.clientDetails.clientDetails.client_code = r.client_code;
          this.clientDetails.clientDetails.client_name = r.client_code;
          this.clientDetails.clientDetails.study = r.study;
          this.mainStudy = r.main_study || r.study;
          this.snapshotselected = r.snapshotselected || '';
          this.sectionselected = r.sectionselected || '';
          this.subsectionselected = r.subsectionselected || '';
          this._configService.snapshotSelectedName = this.snapshotselected;
          this._configService.selectedSection = this.sectionselected;
          this._configService.selectedSubSection = this.subsectionselected;
          this.landingService.setSelectedClient(r.client_code);
          this.landingService.setSelectedStduy(this.mainStudy);
          this._isAskMeGlobalDefaultForced = false;
          const _extractLast = (v: any): string | null => {
            const s = typeof v === 'string' ? v : (Array.isArray(v) ? v[0] : null);
            if (!s || typeof s !== 'string') return null;
            const parts = s.split('|').map((p: string) => p.trim()).filter((p: string) => p.length > 0);
            return parts.at(-1) || s;
          };
          this._configService.askMePreselection = {
            brand: _extractLast(r.primary_brands),
            timeperiod: _extractLast(r.timeperiod),
            market: _extractLast(r.market),
            filter_audience: r.filter_audience || null,
            metric_filters: r.metric_filters || null
          };
          this._askMeTargetWidgetName = r.widget_name || '';
          localStorage.removeItem('askme_snapshot_redirect');
        } catch {}
      }
    }
    if (navigation?.extras.state) {
      this.clientDetails.clientDetails = navigation?.extras
        .state as SnapshotSharedVariablesService;
      this.mainStudy = navigation?.extras.state['main_study'];

      this.landingService.setSelectedClient(this.clientDetails.clientDetails.client_code);
      this.landingService.setSelectedStduy(this.mainStudy);

      this._configService.SnapshotList = navigation?.extras.state['snapList'];
      this.snapshotselected = navigation?.extras.state['snapshotselected'];
      this.sectionselected = navigation?.extras.state['sectionselected'];
      if (subsectionName || sectionName) {
        this.sectionselected = sectionName;
        this.subsectionselected = subsectionName;
        this.clientDetails.clientDetails.sectionselected = this.sectionselected;
        this.clientDetails.clientDetails.subsectionselected =
          this.subsectionselected;
        this.isAcrossdropDown = navigation?.extras.state['isAcrossdropDown'];
      } else {
        this.sectionselected = navigation?.extras.state['sectionselected'];
        sessionStorage.setItem('sectionName', this.sectionselected);
        this.subsectionselected =
          navigation?.extras.state['subsectionselected'];

        let subSection = this.subsectionselected
          ? this.subsectionselected
          : 'NA';
        sessionStorage.setItem('subsectionName', subSection);

        sessionStorage.setItem('snapshotType', this.snapshotselected);
        this._configService.snapshotTypeSelectedName = this.snapshotselected;
      }

      this.AcrossDropdown = navigation?.extras.state['acrossDropdown'];
      this._configService.snapshotSelectedName = this.snapshotselected;
      this._configService.selectedSection = this.sectionselected;
      this._configService.selectedSubSection = this.subsectionselected;
    }
  }

  $unSubscribeSubmitData1!: Subscription;

  //extra selections declaration
  isSigSelected: any; // Initially Sig div is selected
  isIndexSelected: any; // Initially Index div is not selected
  isSelectionSummary = false;
  significance: any = [];
  significanceSelectedValue = 'None';
  confidenceLevel: any = [];
  confidenceLevelSelectedValue = '';
  baseLevelSelectedValue = 'Answer Base';
  searchQuery: string = '';
  base: any;
  base2: any;
  existingData: any = [];
  moduleList: any = [];
  sigTypeSelected: any = '';
  weight: any = [];
  MainResult: any;
  ConfidenceLevelDropDownToggle: boolean = false;

  BaseDropDownToggle: boolean = false;
  weightDropDownToggle: boolean = false;
  displayConfidenceLevel: string = '';
  configuredDefaultConfidenceLevel: string = '';
  LowBase: any = '';
  insufficientBase: any = '';
  isLoadSelection: boolean = false;
  isDefaultLoad: boolean = false;
  isShareSelectionClick: boolean = false;
  loadUserDefinedSavedScenarioData: any = [];
  loadSharedWithMeSavedScenarioData: any = [];
  loadDefaultSavedScenarioData: any = [];
  selected_client: string = '';
  selected_study: string = '';
  selected_module: string = '';
  shareSelectionUserList: string[] = [];
  currentSavedScenarioData: any; //has only limted data shown in load selection popup
  selectedLoadSelectionObj: any;
  selectedEmailsToShare: string[] = [];
  deleteMessage: string = '';
  loadSelectionType: string = ''; //selection type to delete
  isShowDialog: boolean = false;
  showLoaderPopUp: boolean = false;
  loadCustomGroupUserDefinedData: any;
  loadCustomGroupSharedWithMeData: any;
  loadCustomCalculationUserDefinedData: any;
  loadCustomCalculationSharedWithMeData: any;
  isSavedScenarioSelected: boolean = false;
  _isAskMeGlobalDefaultForced: boolean = false;
  _askMeTargetWidgetName: string = '';
  selectedScenarioData: any;
  dataArray: any[] = [];
  enableSnapshotNonTotalBaseOptions: boolean = true;
  private _hadCustomPctMeanBlockingSnapshotBase = false;
  selectionSummary: string = '';
  output_data: any;
  selectedSigBrand: any;
  additionalCheckList: any;
  selectedBrandFromConfig: any = null;
  selectedSigType: any[] = [];
  stacticText: string = '';
  isAnswerBase: boolean = false;
  showOutput: boolean = true;
  showOutputView: boolean = false;
  //outputData: any;
  exportSelected: any;
  editablePPT = false;
  staticPPT = false;
  excelExport = false;
  weightSelectedValue: any = '';
  referenceDropdownToggle: boolean = false;
  selectedSignificance: any;
  selectedReference: any;
  displaySignificance: any = 'None';
  displayReference: any = 'None';
  displayBrand = false;
  vsBrandArray: any[] = [];
  buttonText: string = 'OK';
  x: any;
  y1: any = {}; //This variable is used to store Ouput object which is used in left panel submit
  allbrands: any;
  selectedAudienceLevel1: any = null;
  selectedAudienceLevel2: any = null;
  selectedAudienceLevel3: any = null;
  selectedAudienceLevel4: any = null;
  refSearchLevel2Query: string = '';
  refSearchLevel3Query: string = '';
  refSearchLevel4Query: string = '';
  refSearchLevel5Query: string = '';
  selectedSigAudienceLevel1: any = null;
  selectedSigAudienceLevel2: any = null;
  selectedSigAudienceLevel3: any = null;
  selectedSigAudienceLevel4: any = null;
  sigSearchLevel2Query: string = '';
  sigSearchLevel3Query: string = '';
  sigSearchLevel4Query: string = '';
  sigSearchLevel5Query: string = '';
  allSigBrands: any;
  allIndexBrands: any; // Separate array for index reference to avoid modifying audience selection
  // Custom Base properties
  displayCustomBaseBrand = false;
  allCustomBaseBrands: any;
  selectedCustomBaseReference: string[] = [];
  customBaseSearchQuery: string = '';
  thresholdIndex: any;
  significanceDropdownToggle: boolean = false;
  significanceVal: any[] = [];
  baseselected = 'Answer Base';
  higherIndexValue: any;
  lowerIndexValue: any;
  indexText: any;
  significanceTypes: any[] = [];
  TrendToggleContainer: boolean = true;
  TrendToggleOn: boolean = false;
  pageCounter: number = 1;
  showsamplesizepopup: boolean = false;
  OutputdataObject: any;
  isSampleSize: boolean = false;
  showSampleSizePop: boolean = false;
  widgetNameToMetricForPopup: { [widgetName: string]: { metric: string; metricdropdownOutput: any } } = {};
  opobject: any = {
    Column: [],
    Row: [],
  };

  popUpTitle: any;
  popUpMessage: any = '';
  showErrorPopUp: boolean = false;

  sampleSizeOutputData: any;

  private subscriptions: Subscription = new Subscription();
  private outputDataSub: Subscription | null = null;
  private loadSelectionSub: Subscription | null = null;
  private _cachedDedupSourceRef: any = null;
  private _cachedDedupOutput: any[] | null = null;
  private _cachedRowByChild: Map<string, any[]> | null = null;
  mainStudy: string = '';
  showSaveSelectionButton: boolean = true;
  sigConBaseToggle = true;
  snapshotName: any;
  additionalList: any;
  subSectionNames: any = [];
  isCustomReports: boolean = true;
  is_brandAnalysis: boolean = true;
  isHelpGuide: boolean = false;

  exportReportInput: ExcelExportReportInputs = {
    report_type: 'CustomReport',
    client_name: '',
    study_name: '',
    customReportType: 'CustomReport',
  };
  funnelChartSelectedBrand: string = '';
  ngOnInit() {
    //--------------------------- General Config datas -----------------
    //this.pageDetailsForSectionSubsection();
    this.checkIsUserAllowed();
    this.commonchartmodules.colortemplate(this.clientDetails?.clientDetails?.client_code);
    let parameter1 = {
      study: this.mainStudy,
      client_name: this.clientDetails.clientDetails.client_code,
      client_code: this.clientDetails.clientDetails.client_code,
      isBrandAnalysis: true,
    };
    this.exportReportInput.client_name =
      this.clientDetails.clientDetails.client_code;
    this.exportReportInput.study_name = this.mainStudy;
    this.subscriptions.add(
      this._configService
        .getGeneralConfigData(parameter1)
        .subscribe((data: any) => {
          if (data.Data != '') {
            let lsORisData = JSON.parse(data.Data);
            this.ImageURL = lsORisData.logoFile.url;
            this._configService.LBthreshold = Number(
              lsORisData.configData.low_base_identifier.find(
                (item: any) => item.key === 'Low Base'
              )?.data_value
            );
            this.LowBase = this._configService.LBthreshold;
            this._configService.ISthreshold = Number(
              lsORisData.configData.low_base_identifier.find(
                (item: any) => item.key === 'Insufficient Base'
              )?.data_value
            );
            this.insufficientBase = this._configService.ISthreshold;
            this.isCrosstabActive = lsORisData.configData.moduledetails?.find((m: any) => m.module_name === 'Crosstab')?.is_active ?? false;
            this.isBrandAnalysisActive = lsORisData.configData.moduledetails?.find((m: any) => m.module_name === 'Brand Analysis')?.is_active ?? false;

            this._configService.weights = lsORisData.configData.weight.filter(
              (m: any) => m.is_selected == true
            );
            if (
              lsORisData.configData.threshold_identifier[0].data_value !=
                undefined ||
              lsORisData.configData.threshold_identifier[0].data_value != null
            ) {
              this._configService.thresholdIndex = Number(
                lsORisData.configData.threshold_identifier[0].data_value
              );
            }
          }
        })
    );
    //--------------------- Custom Widget Library datas --------------------
    let data = {
      clientName: this.clientDetails.clientDetails.client_code,
      snapshotName: this.clientDetails.clientDetails.study,
    };

    this.selected_study = this.clientDetails.clientDetails.study;
    this.selected_client = this.clientDetails.clientDetails.client_code;
    this.checkDocumentAvailability();

    this.showSaveSelectionButton =
      this._configService.outputSnapshotData?.saveselection != null
        ? this._configService.outputSnapshotData?.saveselection?.find(
            (m: any) => m.key === 'Save/Load'
          )?.value ?? false
        : false;

    this.subscriptions.add(
      this._configCustomService
        .getCustomSnapshotWidgetLibrary(data)
        .subscribe((r: any) => {
          if (r.Data) {
            this._configService.widgetAllData = JSON.parse(r.Data);
          } else {
            this._configService.widgetAllData = [];
          }

          this._configService.snapshotProductType = 'custom';
          this._configService.setwidgetVariable(
            this._configService.widgetAllData
          );

          this.existingData = this._configService.widgetAllData;

          //this.selectedTypeFun('Single Brand'); //False trigerring
        })
    );
    this.subscriptions.add(
      this._configCustomService
        .getFunnelChartSelectedItem()
        .subscribe((funnelChartSelectedItem) => {
          if (funnelChartSelectedItem != '') {
            if(this.insightsObj['show'] == true){
              this.funeelChartInsights();
            }
          }
        })
    );

    //---------------------- Module Config Datas -----------------------------
    let data2 = {
      client_code: this.clientDetails.clientDetails.client_code,
      snapshot_name: this.clientDetails.clientDetails.study,
    };
    this.subscriptions.add(
      this._configService.getClientStudyData(data2).subscribe((c) => {
        let data = JSON.parse(c.body.Data);
        this._configService.outputSnapshotData = data;
this.CustomBaseOptions=this._configService.outputSnapshotData.selectedCustomBaseMetric;
        this.snapshotName = data.snapshot_name;
        //this.snapNameNavHeader.emit(data.snapshot_name);
        this.additionalList = data.additional_list;

        const helpGuide = this.additionalList.find((item:any)=>item.key === 'Help Guide');
        this.isHelpGuide = helpGuide ? helpGuide.value : false;

        const staticTimeFrameItem = this.additionalList.find(
          (item: any) => item.key === 'Static Time Frame'
        );

        this._configService.isStaticTimeFrame = staticTimeFrameItem
          ? staticTimeFrameItem.value
          : false;

        //this.snapshotType_details = data.snapshotType_details;
        let studyName = data.study_list[0].study_name;
        this.selected_study = studyName;
        this.selected_client = data.client_name;

        this._configService.staticText =
          data.static_text != null ? data.static_text : '';
        this.stacticText = this._configService.staticText;

        // let compareacross: any = [];
        // this.snapshotType_details.forEach((type: any) => {
        //   compareacross.push({
        //     name: type.snapshot_type,
        //     value: type.snapshot_type,
        //     selected: false,
        //   });
        // });
        this.selectedSigType =
          this._configService.outputSnapshotData?.significance_type;
        this.significanceTypes = []; // reset to prevent accumulation if subscription fires more than once
        for (let i = 0; i < this.selectedSigType.length; i++) {
          this.significanceTypes.push({
            id: i + 1,
            selected: false,
            name: this.selectedSigType[i].key,
            value: this.selectedSigType[i].key,
          });
        }        
        if (!this._configService.decimalPointConfig) {
          const d = data.decimal_point_configuration;
          if (d) {
            this._configService.decimalPointConfig = {
              tabular: d.tabular ?? 'chart',
              charts:  d.charts  ?? 'chart',
              excel:   d.excel   ?? 'chart',
              ppt:     d.ppt     ?? 'chart',
            };
            // Re-render charts with the correct decimal if they are already showing
            if (this.customWidgetChild && this.customWidgetChild.data?.length > 0) {
              this.customWidgetChild.outputDataRefresh();
            }
          }
        }
        this.configuredDefaultConfidenceLevel =
          data?.default_confidence_level ||
          this._configService.outputSnapshotData?.default_confidence_level ||
          '';
      })
    );

    this._configService.setDropdownValue('significance', 'Z-test');

    this.subscriptions.add(this._usermanagementService.variblesForLeftPanelFiltes$.subscribe(
          (model: any) => {
            if (model != null) {
              if (model['operation'] != null && (model['data'] != null && model['data'] != '')) {
                let leftPanelFilters = localStorage.getItem('leftPanelFilters');

                if (model['operation'] == 'delete') {
                  if (leftPanelFilters == null) {
                    let userDefined: any = {
                      deleteRecord: [model['data']],
                      addUpdateRecord: [],
                    };
                    localStorage.setItem(
                      'leftPanelFilters',
                      JSON.stringify(userDefined)
                    );
                  } else {
                    let userDefined: any = JSON.parse(leftPanelFilters);
                    userDefined.deleteRecord.push(model['data']);
                    localStorage.setItem(
                      'leftPanelFilters',
                      JSON.stringify(userDefined)
                    );
                  }
                } else {
                  if (leftPanelFilters == null) {
                    let userDefined: any = {
                      deleteRecord: [],
                      addUpdateRecord: [model['data']],
                    };
                    localStorage.setItem(
                      'leftPanelFilters',
                      JSON.stringify(userDefined)
                    );
                  } else {
                    let userDefined: any = JSON.parse(leftPanelFilters);
                    userDefined.addUpdateRecord.push(model['data']);
                    localStorage.setItem(
                      'leftPanelFilters',
                      JSON.stringify(userDefined)
                    );
                  }
                }
              }
            }
          }
        )
    );
  }
  ImageURL: string = '';

  showContainer: boolean = false;
  showExportContainer: boolean = false;
  toggleContainer() {
    this.showExportContainer = !this.showExportContainer;
    this.showContainer = !this.showContainer;
    this.closeSelectionSummary();
  }

  closeContainer() {
    this.showExportContainer = false;
    this.showContainer = false;
  }

  OnExportClicked(exportType: string, isTrended: boolean) {
    if (exportType == 'ppt') {
      this.IsPPTDownloadClicked = true;
      if (isTrended) {
        // Preserve the current non-trend (snapshot) output before the trended API
        // call overwrites it with empty widgets. Used to backfill outputArray in
        // editablePPTClicked so the trended PPT export isn't missing metrics.
        this._preExportNonTrendArray = _.cloneDeep(
          this._configService.allPageOutputDataWithoutTrend
        );
        let checked = this._configService.checkTrendEnabled(this.existingData);
        this.getOutputData(
          this.typeSelected,
          '',
          this.pageCounter,
          exportType,
          checked
        ).catch((error) => {
          console.error('Error in getOutputData:', error);
        });
      } else {
        this.getOutputData(
          this.typeSelected,
          '',
          this.pageCounter,
          exportType,
          false
        ).catch((error) => {
          console.error('Error in getOutputData:', error);
        });
      }
    } else {
      this.IsPPTDownloadClicked = true;
      if (isTrended) {
        let checked = this._configService.checkTrendEnabled(this.existingData);
        this.getOutputData(
          this.typeSelected,
          '',
          this.pageCounter,
          exportType,
          checked
        ).catch((error) => {
          console.error('Error in getOutputData:', error);
        });
      } else {
        this.getOutputData(
          this.typeSelected,
          '',
          this.pageCounter,
          exportType,
          false
        ).catch((error) => {
          console.error('Error in getOutputData:', error);
        });
      }
    }
  }
  // Get all widgets with widgetchart_name as "Trend as Widget"
getTrendAsWidgets(): any[] {
  if (!this._configService.allPageOutputData || this._configService.allPageOutputData.length === 0) {
    return [];
  }

  const trendWidgets: any[] = [];

  this._configService.allPageOutputData.forEach((pageArray: any[]) => {
    pageArray.forEach((widget: any) => {
      if (widget.widgetchart_name === 'Trend as Widget') {
        trendWidgets.push(widget);
      }
    });
  });

  return trendWidgets;
}
// Check if any widget has widgetchart_name as "Trend as Widget"
hasTrendAsWidget(): boolean {
  if (!this._configService.allPageOutputData || this._configService.allPageOutputData.length === 0) {
    return false;
  }

  // allPageOutputData is an array containing arrays of widgets
  return this._configService.allPageOutputData.some((pageArray: any[]) =>
    pageArray.some((widget: any) =>
      widget.widgetchart_name === 'Trend as Widget'
    )
  );
}

private getTrendWidgets(source: any[] | undefined): any[] {
  return Array.isArray(source)
    ? source.filter(
        w => w.widgetchart_name?.toLowerCase() === 'trend as widget'
      )
    : [];
}
private getTrendWidgetsWithoutTrend(): any[] {
  return this.getTrendWidgets(
    this._configService.allPageOutputDataWithoutTrend?.[0]
  );
}

// Mirrors funnelchart1.component.ts getAudienceDisplayLabel so export matching

private getFunnelAudienceDisplayLabel(colChild: string, allColChilds: string[]): string {
  if (!colChild || !colChild.includes('|')) { return colChild; }
  const parts = colChild.split('|');
  const last = parts[parts.length - 1];
  const dupCount = (allColChilds || []).filter((c: string) => {
    if (!c || !c.includes('|')) { return c === last; }
    const p = c.split('|');
    return p[p.length - 1] === last;
  }).length;
  if (dupCount > 1 && parts.length >= 2) {
    return parts[parts.length - 2] + ' | ' + last;
  }
  return last;
}

// Low-risk hotfix: the editable PPT export engine renders a funnel from the FIRST

private reorderFunnelSelectedBrandForExport(widgets: any[]): any[] {
  if (!Array.isArray(widgets) || widgets.length === 0) { return widgets; }

  // Live per-widget funnel selection from the rendered icon components (current page).
  const iconComps = this.customWidgetChild?.iconComponents?.toArray() ?? [];
  const funnelSelectedByName = new Map<string, string>();
  iconComps.forEach((c: any) => {
    const name = c?.data?.widget_name;
    const isFunnel = (c?.widgetchartname ?? '').toLowerCase() === 'funnel chart';
    const selected = (c?.selectedBrand ?? '').toString().trim();
    if (name && isFunnel && selected) {
      funnelSelectedByName.set(name, selected);
    }
  });
  if (funnelSelectedByName.size === 0) { return widgets; }

  const useAudienceLabel = (this._configService.selectedSnapshotType ?? '')
    .toLowerCase()
    .includes('audience');

  const matchesSelected = (
    colChild: string,
    selected: string,
    allColChilds: string[]
  ): boolean => {
    const cc = (colChild ?? '').toString();
    if (!cc) { return false; }
    const matchValue = useAudienceLabel && cc.includes('|')
      ? this.getFunnelAudienceDisplayLabel(cc, allColChilds)
      : cc;
    if (matchValue === selected || cc === selected) { return true; }
    if (cc.includes('|') && cc.split('|').pop()?.trim() === selected) { return true; }
    return false;
  };

  widgets.forEach((widget: any) => {
    const isFunnel = (widget?.widgetchart_name ?? '').toLowerCase() === 'funnel chart';
    const selected = funnelSelectedByName.get(widget?.widget_name);
    if (!isFunnel || !selected || !Array.isArray(widget?.metric)) { return; }

    widget.metric.forEach((metricGroup: any) => {
      (metricGroup?.metric_value ?? []).forEach((mv: any) => {
        if (!Array.isArray(mv?.data) || mv.data.length <= 1) { return; }
        const allColChilds = mv.data.map((d: any) => d?.colChild);
        const selectedRows = mv.data.filter((d: any) =>
          matchesSelected(d?.colChild, selected, allColChilds)
        );
        // Only reorder when the selection matches some (but not all) rows;
        // keep the original order otherwise so nothing changes unexpectedly.
        if (selectedRows.length > 0 && selectedRows.length < mv.data.length) {
          const rest = mv.data.filter(
            (d: any) => !matchesSelected(d?.colChild, selected, allColChilds)
          );
          mv.data = [...selectedRows, ...rest];
        }
      });
    });
  });

  return widgets;
}


private reversePieRingOrderForExport(widgets: any[]): any[] {
  if (!Array.isArray(widgets) || widgets.length === 0) { return widgets; }

  widgets.forEach((widget: any) => {
    const isMultiRingPie =
      (widget?.widgetchart_name ?? '').toLowerCase() === '05/pie chart';
    if (!isMultiRingPie || !Array.isArray(widget?.metric)) { return; }

    widget.metric.forEach((metricGroup: any) => {
      if (Array.isArray(metricGroup?.metric_value) && metricGroup.metric_value.length > 1) {
        metricGroup.metric_value = [...metricGroup.metric_value].reverse();
      }
    });
  });

  return widgets;
}

  async editablePPTClicked(isTredendDataRequired: boolean = false) {
    this.showContainer = false;
    this.showExportContainer = false;
    this._loaderService.showLoader();

//  let allpageOutputData;
// let allPageOutputDataWithoutTrendArray;
//  let allpageOutputDataWithoutTrend ;
 const hasTrend = this.itemWithoutTrendItems.some((item: any) =>
      item.widgetchart_name && item.widgetchart_name.toLowerCase() === 'trend as widget');
 const trendAsWidgetArray = this._configService.allPageOutputDataWithoutTrend[0].filter(
  (widget: any) => widget.widgetchart_name?.toLowerCase() === 'trend as widget'
);



const withoutTrend = this.getTrendWidgetsWithoutTrend();
const withTrend = this.getTrendWidgets(this.trendDataResult);

// Build quick lookup by widget_name
const trendMap = new Map(
  withTrend.map(w => [w.widget_name, w])
);

// Reference to the ORIGINAL array (do not replace it)
const pageWidgets = this._configService.allPageOutputDataWithoutTrend?.[0];

if (!Array.isArray(pageWidgets)) {
  return;
}

pageWidgets.forEach((pageWidget: any) => {
  const trendWidget = trendMap.get(pageWidget.widget_name);

  if (
    trendWidget &&
    pageWidget.widgetchart_name?.toLowerCase() === 'trend as widget' &&
    pageWidget.metric?.[0] &&
    trendWidget.metric?.[0]
  ) {
    pageWidget.metric[0].metric_value = _.cloneDeep(
      trendWidget.metric[0].metric_value
    );

   
  }
});




// if(hasTrend){
  
//   this._configService.allPageOutputData=this.trendDataResult;
//      const allPageOutputDataArray = _.cloneDeep(
//     this._configService.allPageOutputData
//   );
  
//    allpageOutputData = allPageOutputDataArray;

//    allPageOutputDataWithoutTrendArray = _.cloneDeep(
//     this._configService.allPageOutputDataWithoutTrend[0]
//   );
//    allpageOutputDataWithoutTrend = allPageOutputDataWithoutTrendArray;

//     this._configService.setDropdownValue(
//       'outputArray',
//       JSON.stringify(allpageOutputData)  // â† Trend data goes to outputArray
//     );
//     this._configService.setDropdownValue(
//       'outputTrendArray',
//       JSON.stringify(allpageOutputData)  // â† Non-trend data goes to outputTrendArray
//     );
//   } else {
     let allpageOutputData = _.cloneDeep(
      this._configService.allPageOutputData
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    let allpageOutputDataWithoutTrend = _.cloneDeep(
      this._configService.allPageOutputDataWithoutTrend
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );

    // For a trended export the trend-only API response leaves the non-trend
    // (outputArray) widgets empty because their Level1ColChild uses the trend
    // time-period format and never matches selectedTPforNonTrendView. Backfill
    // those emptied widgets from the pre-export non-trend snapshot so outputArray
    // has data (trend-as-widget widgets, which are non-empty here, are untouched).
    if (
      isTredendDataRequired &&
      Array.isArray(this._preExportNonTrendArray?.[0])
    ) {
      const snapshotByName = new Map<string, any>(
        this._preExportNonTrendArray[0].map((w: any) => [w.widget_name, w])
      );
      allpageOutputDataWithoutTrend = allpageOutputDataWithoutTrend.map(
        (widget: any) => {
          const isEmpty =
            !Array.isArray(widget.metric) ||
            widget.metric.length === 0 ||
            widget.noData === true;
          const snap = snapshotByName.get(widget.widget_name);
          if (
            isEmpty &&
            snap &&
            Array.isArray(snap.metric) &&
            snap.metric.length > 0
          ) {
            return _.cloneDeep(snap);
          }
          return widget;
        }
      );
    }

    const dropdownValues = this._configService.getDropdownValues();
    const isMultiBrand =
      dropdownValues.compareAcross == 'Multiple Brands' 
     ;

    if (isMultiBrand) {
      const expandMetrics = (widgets: any[]): any[] =>
        widgets.flatMap((widget: any) => {
          if (widget.metricdropdownOutput != 1) return [widget];
          const metricValues = widget?.metric?.[0]?.metric_value;
          if (!metricValues || metricValues.length <= 1) return [widget];
          return metricValues.map((mv: any) => ({
            ...widget,
            widget_name: `${widget.widget_name} - ${mv.option}`,
            metric: [{ ...widget.metric[0], metric_value: [mv] }],
          }));
        });
      allpageOutputData = expandMetrics(allpageOutputData);
      allpageOutputDataWithoutTrend = expandMetrics(allpageOutputDataWithoutTrend);
    }
    const htmlToImage = await import('html-to-image');
    const toBlob = htmlToImage.toBlob ?? (htmlToImage as any).default?.toBlob;

    // Find all rendered Propeller Chart icon components on the current page by chart type
    const propellerIconComps = (this.customWidgetChild?.iconComponents?.toArray() ?? [])
      .filter((c: any) => c.widgetchartname?.toLowerCase() === 'propeller chart');

    for (const iconComp of propellerIconComps) {
      const widgetName = iconComp.data?.widget_name;
      const widgetDataIdx = allpageOutputDataWithoutTrend.findIndex(
        (w: any) => w.widget_name === widgetName
      );
      if (widgetDataIdx === -1 || !toBlob) continue;
      try {
          iconComp.showExpandPopup = true;
            this.cdr.detectChanges();
            await new Promise(res => setTimeout(res, 3000));
            const popupEl = document.querySelector('app-output-popup .popup, app-output-popup .popup-snapshot, app-output-popup .multifunnelpopup') as HTMLElement;
            if (popupEl) {
              const captureScaleW = 1.08;
              const captureScaleH = 1.1;
              const baseWidth = popupEl.scrollWidth || popupEl.offsetWidth;
              const baseHeight = popupEl.scrollHeight || popupEl.offsetHeight;
              const captureWidth = Math.ceil(baseWidth * captureScaleW);
              const captureHeight = Math.ceil(baseHeight * captureScaleH);

              const origWidth = popupEl.style.width;
              const origHeight = popupEl.style.height;

              // Temporarily enlarge popup area so html-to-image includes more content.
              popupEl.style.width = `${captureWidth}px`;
              popupEl.style.height = `${captureHeight}px`;
              this.cdr.detectChanges();
              await new Promise(res => setTimeout(res, 250));

              const propBlob: Blob | null = await toBlob(popupEl, {
                cacheBust: true,
                pixelRatio: 2,
                skipAutoScale: true,
                width: captureWidth,
                height: captureHeight,
              } as any);

              popupEl.style.width = origWidth;
              popupEl.style.height = origHeight;

              if (propBlob) {
                const propBase64 = await this.blobToBase64(propBlob);
                allpageOutputDataWithoutTrend[widgetDataIdx].imgString = propBase64.replace('data:image/png;base64,', '');
              }
            }
            iconComp.showExpandPopup = false;
            this.cdr.detectChanges();
            await new Promise(res => setTimeout(res, 1500));
      } catch (err) {
        console.error(`Propeller chart capture failed for widget '${widgetName}':`, err);
      }
    }


    // Put the funnel's selected cohort first so the editable PPT export engine (which
    // consumes the first data entry) renders the user's selection instead of Total Sample.
    allpageOutputDataWithoutTrend = this.reorderFunnelSelectedBrandForExport(
      allpageOutputDataWithoutTrend
    );
    allpageOutputData = this.reorderFunnelSelectedBrandForExport(allpageOutputData);

    // Align the multi-ring pie/donut ring order in the editable PPT with the UI.
    allpageOutputDataWithoutTrend = this.reversePieRingOrderForExport(
      allpageOutputDataWithoutTrend
    );
    allpageOutputData = this.reversePieRingOrderForExport(allpageOutputData);

    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(allpageOutputDataWithoutTrend)
    );
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(allpageOutputData)
    );
  // }
    this._configService.setDropdownValue('product', 'custom');
    // outputTrendArrayforExcel

    this._configService.getDropdownValues().staticText =
      this._configService.staticText;
    let data = _.cloneDeep(this._configService.getDropdownValues());
    data.isAggregatedData = this._configService.isAggregatedData;
    data.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    data.isRespondentLevel = this._configService.isRespondentLevel;
    const rawBrand =this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand?.[0]?.option;
    data.audienceSelectedBrand = rawBrand ? rawBrand.substring(rawBrand.lastIndexOf('|') + 1).trim() : null;
    data.isMultiCohort = this._configService?.multiCohort;

    let newCustomizationData: any;
    if (
      this._configService.newCustomizationData != null &&
      this._configService.newCustomizationData != undefined
    ) {
      newCustomizationData = this._configService.newCustomizationData;
    }

    if (
      data.compareAcross == 'Multiple Brands' ||
      data.compareAcross == 'Multiple Markets' || data.compareAcross == 'Audience Snapshot'
    ) {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
      let formetterdata = [];

      if (data.outputArray != null) {
        let outputArray = JSON.parse(data.outputArray);
        outputArray.forEach((itm: any) => {
          if (newCustomizationData != null) {
            let customization = _.filter(
              newCustomizationData,
              (x) => x.widget_name == itm.widget_name
            );
            if (customization != null && customization.length > 0) {
              itm.customizationProperties =
                customization[0].customizationProperties;
            }
          }
        });

        data.outputArray = JSON.stringify(
          JSON.parse(JSON.stringify(outputArray))
        );
      }
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat =outputTrendArray[i];
        let custumization = JSON.parse(
          currentwightdat.customizationProperties || '{}'
        );
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let currentmetricdata = currentwightdat.metric[x].metric_value[j];

            for (let k = 0; k < currentmetricdata.data.length; k++) {
              let obj: any = {};
              obj.widget_name = currentwightdat.widget_name;
              obj.widgetchart_name = currentwightdat.widgetchart_name;
              obj.roundoffvalue = custumization.decimalRoundOff;
              obj.option = currentmetricdata.option;
              _.extend(obj, currentmetricdata.data[k]);
              formetterdata.push(obj);
            }
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify(formetterdata);
    } else {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      let formetterdata = [];
      if (data.outputArray != null) {
        let outputArray = JSON.parse(data.outputArray);
        outputArray.forEach((itm: any) => {
          if (newCustomizationData != null) {
            let customization = _.filter(
              newCustomizationData,
              (x) => x.widget_name == itm.widget_name
            );
            if (customization != null && customization.length > 0) {
              itm.customizationProperties =
                customization[0].customizationProperties;
            }
          }
        });

        data.outputArray = JSON.stringify(
          JSON.parse(JSON.stringify(outputArray))
        );
      }
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let custumization = JSON.parse(
              currentwightdat.customizationProperties || '{}'
            );
            if (newCustomizationData != null) {
              let customization = _.filter(
                newCustomizationData,
                (x) => x.widget_name == currentwightdat.widget_name
              );
              if (customization != null && customization.length > 0) {
                outputTrendArray[i].customizationProperties =
                  customization[0].customizationProperties;
              }
            }

            outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(
              outputTrendArray[i].metric[x].metric_value[j].data,
              _.isEqual
            );
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray]);
    }

    if (this.significanceSelectedValue != 'None') {
      //data.confidenceLevel = this.confidenceLevelSelectedValue;
      data.confidenceLevel = this.displayConfidenceLevel;
      //data.confedenceValue = this.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.colorpalate = JSON.stringify(this.commonchartmodules.color1);
    data.globalColorMap = JSON.stringify(this.globalColorMap);
    data.isMultiCohort=this._configService.multiCohort;
    data.selectedWeight = this.weightSelectedValue;
    // let data1=_.cloneDeep(this._configService.getDropdownValues());
    let element = document.getElementById('preview_body');
    // if (element != undefined) {
    //   html2canvas(element, {
    //     useCORS: true,
    //     allowTaint: true,
    //   }).then((canvas) => {
    //     let imgString = canvas.toDataURL('image/png'); //convert the canvas as image
    //     imgString = imgString.replace('data:image/png;base64,', '');

    //     this.subscriptions.add(
    //       this._configService.callPptExport(imgString, data).subscribe(
    //         (pptBlob: Blob) => {
    //           // Snapshot_ClientName_SnapshotName_Timestamp.pptx
    //           let fileName = this._configService.getDropdownValues().clientName + '_' + this._configService.getDropdownValues().snapshotName + '_' + this.getCurrentDateTime() + '.pptx';
    //           this.downloadPPTFile(pptBlob, fileName);
    //           this.usageDataLog("Editable PPT Export");
    //           let paginationElement = document.getElementById("pagination-div");
    //           if (paginationElement) {
    //             paginationElement.style.visibility = "visible";
    //           }
    //           this._loaderService.hideLoader();
    //           this.showExportContainer = false;
    //           this.showContainer = false;
    //         },
    //         (error) => {
    //           this.errorheaderTitle = 'Error';
    //           this.popUpTitle = "Error";
    //           //this.showPopUp = false;
    //           this.popUpMessage = "Some Error Occured..!";
    //           this.showErrorPopUp = true;
    //           let paginationElement = document.getElementById("pagination-div");
    //           if (paginationElement) {
    //             paginationElement.style.visibility = "visible";
    //           }
    //           this._loaderService.hideLoader()
    //         }
    //     ));
    //   });
    // }

    let imgString = '';
    data.significance = this._configService.getDropdownValues().significance;
    this.subscriptions.add(
      this._configService
        .callPptExport(imgString, data, isTredendDataRequired)
        .subscribe(
          (pptBlob: Blob) => {
            // Snapshot_ClientName_SnapshotName_Timestamp.pptx
            let fileName =
              this._configService.getDropdownValues().clientName +
              '_' +
              this._configService.getDropdownValues().snapshotName +
              '_' +
              this.getCurrentDateTime() +
              '.pptx';
            this.downloadPPTFile(pptBlob, fileName);
            this.usageDataLog('Editable PPT Export');
            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            this._loaderService.hideLoader();
            this.showExportContainer = false;
            this.showContainer = false;
          },
          (error) => {
            this.errorheaderTitle = 'Error';
            this.popUpTitle = 'Error';
            //this.showPopUp = false;
            this.popUpMessage = 'Some Error Occured..!';
            this.showErrorPopUp = true;
            let paginationElement = document.getElementById('pagination-div');
            if (paginationElement) {
              paginationElement.style.visibility = 'visible';
            }
            this._loaderService.hideLoader();
          }
        )
    );
  }

  // usageDataLog(feature: string) {
  //   let summarytext = '';
  //   if (this._configService.selectionSummaryTextTitle != undefined && this._configService.selectionSummaryTextTitle != null) {
  //     // summarytext = this.summaryText?.nativeElement.innerText;
  //     summarytext = this._configService.selectionSummaryTextTitle
  //   }
  //   this._usermanagementService.UsageData(
  //     '3',
  //     this._configService.getDropdownValues().clientName,
  //     this._configService.getDropdownValues().studyName,
  //     feature,
  //     summarytext,
  //     this._configService.getDropdownValues().snapshotName
  //   );
  // }

  // getCurrentDateTime() {
  //   const now = new Date();

  //   const year = now.getFullYear();
  //   const month = String(now.getMonth() + 1).padStart(2, '0');
  //   const day = String(now.getDate()).padStart(2, '0');
  //   const hours = String(now.getHours()).padStart(2, '0');
  //   const minutes = String(now.getMinutes()).padStart(2, '0');
  //   const seconds = String(now.getSeconds()).padStart(2, '0');

  //   const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
  //   return formattedDateTime;
  // }

  // screengrabPPTClicked() {
  //   this.showContainer = false;
  //   this.showExportContainer = false;
  //   this.captureScreenshot();
  // }  

  screengrabPPTClicked() {
  this.showContainer = false;
  this.showExportContainer = false;
this.IsPPTDownloadClicked = true;
  this.getOutputData(
    this.typeSelected,
    '',
    this.pageCounter,
    '',
    false
  ).then(() => {
    this.captureScreenshot();
  });
}
  // Old code kept for reference.
  // captureScreenshot() {
  //   this._loaderService.showLoader();
  //   this.closeDropdown();
  //   let paginationElement = document.getElementById("pagination-div");
  //   if (paginationElement) {
  //     paginationElement.style.visibility = "hidden";
  //   }
  //   this._configService.setDropdownValue('product', 'custom');
  //   let allpageOutputData = _.cloneDeep(this._configService.allPageOutputData)[0].sort((a: any, b: any) => a.previewChartPostion - b.previewChartPostion);
  //   let allpageOutputDataWithoutTrend = _.cloneDeep(this._configService.allPageOutputDataWithoutTrend)[0].sort((a: any, b: any) => a.previewChartPostion - b.previewChartPostion);
  //   let data = this._configService.getDropdownValues();
  //   this._configService.setDropdownValue('outputTrendArray', JSON.stringify(allpageOutputData));
  //   if (data.compareAcross == "Multiple Brands" || data.compareAcross == "Multiple Markets") {
  //     let outputTrendArray = JSON.parse(data.outputTrendArray);
  //     outputTrendArray = _.sortBy(outputTrendArray, "previewChartPostion")
  //     let formetterdata = [];
  //     for (let i = 0; i < outputTrendArray.length; i++) {
  //       let currentwightdat = outputTrendArray[i];
  //       let custumization = JSON.parse(currentwightdat.customizationProperties || "{}");
  //       for (let x = 0; x < currentwightdat.metric.length; x++) {
  //         for (let j = 0; j < currentwightdat.metric[x].metric_value.length; j++) {
  //           let currentmetricdata = currentwightdat.metric[x].metric_value[j];
  //           for (let k = 0; k < currentmetricdata.data.length; k++) {
  //             let obj: any = {};
  //             obj.widget_name = currentwightdat.widget_name;
  //             obj.widgetchart_name = currentwightdat.widgetchart_name;
  //             obj.roundoffvalue = custumization.decimalRoundOff;
  //             obj.option = currentmetricdata.option;
  //             _.extend(obj, currentmetricdata.data[k]);
  //             formetterdata.push(obj);
  //           }
  //         }
  //       }
  //     }
  //     data.outputTrendArrayforExcel = JSON.stringify(formetterdata);

  //   }
  //   else {
  //     let outputTrendArray = JSON.parse(data.outputTrendArray);
  //     let formetterdata = [];
  //     for (let i = 0; i < outputTrendArray.length; i++) {
  //       let currentwightdat = outputTrendArray[i];
  //       for (let x = 0; x < currentwightdat.metric.length; x++) {
  //         for (let j = 0; j < currentwightdat.metric[x].metric_value.length; j++) {
  //           let currentmetricdata = currentwightdat.metric[x].metric_value[j];
  //           outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(outputTrendArray[i].metric[x].metric_value[j].data, _.isEqual)
  //         }
  //       }
  //     }
  //     data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray])
  //   }
  //   data.compareacrossmultiplesection = data.selectionSummary.split('||')[0].trim().split(':').slice(1).map((part: any) => part.trim()).join(' | ');
  //   this._configService.setDropdownValue('outputArray', JSON.stringify(allpageOutputData));
  //   let element = document.getElementById("preview_body");
  //   if (element != undefined) {
  //     html2canvas(element, {
  //       useCORS: true,
  //       allowTaint: true,
  //     }).then((canvas) => {

  //       let imgString = canvas.toDataURL('image/png'); //convert the canvas as image
  //       imgString = imgString.replace('data:image/png;base64,', '');

  //       return this._configService.exportPPT(imgString, "Snapshot/PreparePPT", data.selectionSummary, data).subscribe(
  //         (response) => {

  //           let datetimeFormat = this.getCurrentDateTime();
  //           //Snapshot_UnEditable_ClientName_SnapshotName_SnapshotType_Timestamp.pptx
  //           let fileName =

  //             'Snapshot' + '_' + 'UnEditable' + '_' +
  //             data.clientName +
  //             '_' +
  //             data.snapshotName + '_' +
  //             data.compareAcross + '_' +
  //             datetimeFormat +
  //             '.pptx';

  //           // Trigger file download

  //           this.downloadFile(response, fileName);

  //           this._loaderService.hideLoader();
  //           let paginationElement = document.getElementById("pagination-div");
  //           if (paginationElement) {
  //             paginationElement.style.visibility = "visible";
  //           }

  //           this.usageDataLog("Uneditable PPT Export");
  //           this.showExportContainer = false;
  //           this.showContainer = false;

  //           //return response;
  //         }
  //       );
  //     });
  //   }
  // }




  async captureScreenshot() {
    this._loaderService.showLoader();
    this.closeDropdown();

    let paginationElement = document.getElementById('pagination-div');
    if (paginationElement) {
      paginationElement.style.visibility = 'hidden';
    }

    this._configService.setDropdownValue('product', 'custom');

    const normalizeArray = (data: any): any[] => {
      const cloned = _.cloneDeep(data);
      return Array.isArray(cloned[0]) ? cloned[0] : cloned;
    };

      const allpageOutputDataPromise = Promise.resolve().then(() =>
        normalizeArray(this._configService.allPageOutputData).sort(
          (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
        )
      );
      
      const allpageOutputDataWithoutTrendPromise = Promise.resolve().then(() =>
        normalizeArray(this._configService.allPageOutputDataWithoutTrend).sort(
          (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
        )
      );

    const [allpageOutputData, allpageOutputDataWithoutTrend] =
      await Promise.all([
        allpageOutputDataPromise,
        allpageOutputDataWithoutTrendPromise,
      ]);

    let data = this._configService.getDropdownValues();
    if (
  (!data.confidenceLevel || data.confidenceLevel === 'None') &&
  this.displayConfidenceLevel
) {
  data.confidenceLevel = this.displayConfidenceLevel;
}
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(allpageOutputData)
    ); 

    const processMultiple = async () => {
      let outputTrendArray = _.sortBy(
        JSON.parse(data.outputTrendArray),
        'previewChartPostion'
      );
      let formetterdata: any[] = [];

      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        let custumization = JSON.parse(
          currentwightdat.customizationProperties || '{}'
        );

        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let currentmetricdata = currentwightdat.metric[x].metric_value[j];

            for (let k = 0; k < currentmetricdata.data.length; k++) {
              let obj: any = {
                widget_name: currentwightdat.widget_name,
                widgetchart_name: currentwightdat.widgetchart_name,
                roundoffvalue: custumization.decimalRoundOff,
                option: currentmetricdata.option,
              };
              _.extend(obj, currentmetricdata.data[k]);
              formetterdata.push(obj);
            }
          }
        }

        if (i % 5 === 0) await new Promise((res) => setTimeout(res, 0));
      }
      data.outputTrendArrayforExcel = JSON.stringify(formetterdata);
    };

    const processSingle = async () => {
      let outputTrendArray = JSON.parse(data.outputTrendArray);

      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let metricVal = currentwightdat.metric[x].metric_value[j];
            metricVal.data = _.uniqWith(metricVal.data, _.isEqual);
          }
        }
        if (i % 5 === 0) await new Promise((res) => setTimeout(res, 0));
      }

      data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray]);
    };

    if (
      data.compareAcross === 'Multiple Brands' ||
      data.compareAcross === 'Multiple Markets' ||
      data.compareAcross === 'Audience Snapshot'
    ) {
      await processMultiple();
    } else {
      await processSingle();
    }

    data.compareacrossmultiplesection = data.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');

    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(allpageOutputData)
    );

    await new Promise((res) => requestAnimationFrame(() => res(null)));

    let element = document.getElementById('preview_body');
    if (element) {
      try {
        const htmlToImage = await import('html-to-image');
        const toBlob = htmlToImage.toBlob ?? (htmlToImage as any).default?.toBlob;
        if (!toBlob) throw new Error('html-to-image `toBlob` not available');

        const blob: Blob | null = await toBlob(element, {
          cacheBust: true,
          pixelRatio: 1,
          skipAutoScale: true,
        } as any);

        if (!blob) throw new Error('Failed to generate image via html-to-image');

        const base64 = await this.blobToBase64(blob);
        const imgString = base64.replace('data:image/png;base64,', '');

        this.subscriptions.add(this._configService
          .exportPPT(imgString, 'Snapshot/PreparePPT', data.selectionSummary, data)       
          .subscribe({
            next: (response: any) => {
              let datetimeFormat = this.getCurrentDateTime();
              let fileName = `Snapshot_UnEditable_${data.clientName}_${data.snapshotName}_${data.compareAcross}_${datetimeFormat}.pptx`;

              this.downloadFile(response, fileName);
              this._loaderService.hideLoader();

              let paginationElement = document.getElementById('pagination-div');
              if (paginationElement) {
                paginationElement.style.visibility = 'visible';
              }

              this.usageDataLog('Uneditable PPT Export');
              this.showExportContainer = false;
              this.showContainer = false;
            },
            error: (err: any) => {
              this._loaderService.hideLoader();
            },
          }));         
      } catch (err) {
        this._loaderService.hideLoader();
      }
    }
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  //Grabs the screenshot of element and converts it into base64 string

  // excelexportClicked() {
  //   // this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputData));
  //   this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputDataWithoutTrend));
  //   this._configService.setDropdownValue('outputTrendArray', JSON.stringify(this._configService.allPageOutputData));
  //   this.handleExcelExportClick();
  // }

  selectedStudy: any;
  // handleExcelExportClick() {
  //   //;

  //   let data = this._configService.getDropdownValues();
  //   if (this.significanceSelectedValue != 'None') {
  //     data.confidenceLevel = this.confidenceLevelSelectedValue;
  //   }
  //   else {
  //     data.confidenceLevel = 'None';
  //   }
  //   this.Loader.showLoader();
  //   this.subscriptions.add(
  //     this._configData
  //       .exportToExcel(data)
  //       .subscribe(
  //         (excelBlob: Blob) => {
  //           //;
  //           let datetimeFormat = this.getCurrentDateTime();
  //           let fileName =
  //             'Snapshot' + '_' +
  //             data.clientName +
  //             '_' +
  //             data.snapshotName + '_' +
  //             data.compareAcross + '_' +
  //             datetimeFormat +
  //             '.xlsx';
  //           // Trigger file download
  //           this.downloadFile(excelBlob, fileName);
  //           this.Loader.hideLoader();
  //           this.usageDataLog("Excel Export");
  //         },
  //         (error) => {
  //           console.error('Error exporting to Excel', error);
  //           //this.errorPopup('Something went wrong, please try again');
  //           this.Loader.hideLoader();
  //         }
  //       )
  //   );

  // }

  // downloadFile(data: Blob, filename: string) {

  //   try {
  //     // Ensure the data is a Blob
  //     if (!(data instanceof Blob)) {
  //       throw new Error('Provided data is not a Blob.');
  //     }

  //     // Use FileSaver.js to save the file
  //     saveAs(data, filename);
  //     this.Loader.hideLoader();

  //   } catch (error) {
  //     console.error('Failed to download file:', error);
  //   }
  // }

  private downloadPPTFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // MIME type for PPTX
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // Trigger download
    a.click();
    document.body.appendChild(a);
    // setTimeout(()=>{
    //   a.click();
    // },100)
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  OnSelectionBtnClick(): void {
    this.summaryViewHeader = 'Selection Summary';
    this.isSelectionSummaryClick = false;
    this.isSaveSelectionClick = true;
    this.showSelectionSummary = true;
    this.panelState = this.panelState === 'closed' ? 'open' : 'closed';
  }

  selectionSummaryBlock(): void {
    this.isSelectionSummary = !this.isSelectionSummary;
    const infoRibbonDiv = document.querySelector(
      '.InfoRibbonTextCompleteSummary'
    ) as HTMLDivElement;
    const infoRibbonDiv1 = document.querySelector(
      '.InfoRibbonText'
    ) as HTMLDivElement;

    if (this.isSelectionSummary) {
      if (infoRibbonDiv1 != null) {
        infoRibbonDiv1.classList.add('DN');
      }
      if (infoRibbonDiv != null) {
        infoRibbonDiv.classList.remove('DN');
      }
    } else {
      if (infoRibbonDiv1 != null) {
        infoRibbonDiv1.classList.remove('DN');
      }
      if (infoRibbonDiv != null) {
        infoRibbonDiv.classList.add('DN');
      }
    }

    // if (infoRibbonDiv != null) {
    //   infoRibbonDiv.innerHTML = this._configService.selectionSummaryText;
    //   infoRibbonDiv.title = this._configService.selectionSummaryTextTitle;
    // }

    // if (infoRibbonDiv1 != null) {
    //   infoRibbonDiv1.innerHTML = this._configService.selectionSummaryText;
    //   infoRibbonDiv1.title = this._configService.selectionSummaryTextTitle;
    // }
  }

  closeDropdown() {
    this.showContainer = false;
    this.showExportContainer = false;
  }

  closeSelectionSummary() {
    const infoRibbonDiv = document.querySelector(
      '.InfoRibbonTextCompleteSummary'
    ) as HTMLDivElement;
    const infoRibbonDiv1 = document.querySelector(
      '.InfoRibbonText'
    ) as HTMLDivElement;
    if (infoRibbonDiv1 != null) {
      infoRibbonDiv1.classList.remove('DN');
    }
    if (infoRibbonDiv != null) {
      infoRibbonDiv.classList.add('DN');
    }
  }

  select(block: string, event: Event) {
    this.isInsightspopupOpen = false;
     this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
    this.insightsVal = undefined;
    this.insightsObj['show'] = false;
    this.insightsObj['message'] = '';
    this.insightsObj['header'] = '';
    this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
    // ;
    //this.isSigSelected = !this.isSigSelected;
    // if (block == this.sigTypeSelected) {
    //   return;
    // }
    this.displayConfidenceLevel = 'None';
    this.sigTypeSelected = block;
    if (block == 'sig') {
      //reset indexing serach box
     
      this.searchQuery = '';
      this.significanceSelectedValue = 'None';
      //reseting completing indexing code once clicked on sig after index
      this.selectedSignificance = 'None';
      this.referenceDropdownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.y1 = this._configService.passdata;
      this.y1.indexVsBrandReference = [];
      this.y1.significanceVsBrandReference = [];
      this._configService.IndexSelected = false;
      this._configService.isIndexSelected = false; //So that in chart dataLabelStyle==index should not be true;
      this.displayReference = 'None';
      for (let i = 0; i < this.allbrands.length; i++) {
        this.allbrands[i].isSelected = false;
      }
      this.selectedReference = 'None';

      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      const defaultCl = this.applyConfiguredDefaultConfidenceSelection();
      this.y1.DefaultConfidenceLevel = defaultCl;
      // Keep displayed confidence as None until a significance type is chosen
      this.displayConfidenceLevel = 'None';
      //this.displayConfidenceLevel = this.y1.DefaultConfidenceLevel;

      this._configService.setDropdownValue('significance', 'Z-test');
      this._configService.setDropdownValue(
        'selectedIndex',
        this.displayReference
      );

      this._loaderService.showLoader();
      this.getOutputData('sig', '', this.pageCounter).catch((error) => {
        this._loaderService.hideLoader();
        console.error('Error in getOutputData:', error);
      });

      this.isSigSelected = true;
      this.isIndexSelected = false;
      this.sigTypeDropdown = true;
      this.sigConBaseToggle = true;

      //updating selection summary
      let temp = this._configService.selectionSummaryText.split(
        `<span class="summary-label">Index: </span>`
      );
      this._configService.selectionSummaryText = temp[0];

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Index: ');
      this._configService.selectionSummaryTextTitle = tempTitle[0];
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        'Significance: ' +
        this.displaySignificance +
        ' || Base: ' +
        this.baseselected;
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="summary-label">Significance: </span>` +
        this.displaySignificance +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Base: </span>` +
        this.baseselected;

      this.UpdateSignificanceSummary();
      this.sigIndex = block;
    } else if (block == 'index') {
      //To reset significance
      this.displaySignificance = 'None';
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.selectedSignificance = 'None';
      this.significanceSelectedValue = 'None';
      this.y1.significance = 'None';
      this.y1.DefaultConfidenceLevel = 'None';
      this._configService.IndexSelected = true;
      this._configService.updateSignificanceValue('None');
      this._configService.updateConfedenceValue('None');
      this.y1.SignificanceVsReference = '';
      this.y1.significanceVsBrandReference = [];
      this.displayBrand = false;
      this.allSigBrands = this.allSigBrands.map((item: any) => {
        item.isSelected = false;
        return item;
      });
      this.allbrands = this.allbrands.map((item: any) => {
        item.isSelected = false;
        if (item.MetricOption == 'None') {
          item.isSelected = true;
        }
        return item;
      });
      //this._configService.setDropdownValue('baseType', "Total Base");
      this._configService.setDropdownValue('significance', 'None');
      this._configService.setDropdownValue('SignificanceVsReference', 'None');
      this.isIndexSelected = true;
      this.isSigSelected = false;
      this.sigTypeDropdown = false;
      this.sigConBaseToggle = false;

      this.UpdateIndexSummary();
      this.sigIndex = block;
    }
    event.stopPropagation();
  }

  UpdateSignificanceSummary() {
    let signi =
      this.displaySignificance +
      (this.displaySignificance == 'Reference'
        ? ': ' +
          (this.selectedSigBrand == undefined
            ? ''
            : this.selectedSigBrand.MetricOption)
        : '');

    if (this._configService.selectionSummaryText.includes('Significance: ')) {
      let temp = this._configService.selectionSummaryText.split(
        'Significance: </span>'
      );

      if (this.displaySignificance == 'None') {
        this._configService.selectionSummaryText =
          temp[0] +
          'Significance: </span>' +
          signi +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Base: </span>` +
          this.baseselected +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Weight: </span>` +
          this.weightSelectedValue;
      } else {
        if (temp.length > 2) {
          let tempt = temp[1]?.split('<span');
          tempt[0] = signi;
          this._configService.selectionSummaryText =
            temp[0] +
            'Significance: </span>' +
            tempt.join('<span') +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Base: </span>` +
            this.baseselected +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Weight: </span>` +
            this.weightSelectedValue;
        } else {
          this._configService.selectionSummaryText =
            temp[0] +
            'Significance: </span>' +
            signi +
            "<span class='grey-separator'> ||  </span>" +
            `<span class="summary-label">Confidence Level: </span>` +
            this.y1.DefaultConfidenceLevel +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Base: </span>` +
            this.baseselected +
            `<span class="grey-separator"> ||  </span>` +
            `<span class="summary-label">Weight: </span>` +
            this.weightSelectedValue;
        }
      }
    } else {
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Significance: </span>` +
        signi;
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Confidence Level: </span>` +
        this.y1.DefaultConfidenceLevel +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Base: </span>` +
        this.baseselected +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Weight: </span>` +
        this.weightSelectedValue;
    }

    if (
      this._configService.selectionSummaryTextTitle.includes('Significance: ')
    ) {
      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Significance: ');

      if (this.displaySignificance == 'None') {
        this._configService.selectionSummaryTextTitle =
          tempTitle[0] +
          'Significance: ' +
          signi +
          ' || Base: ' +
          this.baseselected +
          ' || Weight: ' +
          this.weightSelectedValue;
      } else {
        if (tempTitle.length > 2) {
          let temptTitle = tempTitle[1]?.split(' || ');
          temptTitle[0] = signi;
          this._configService.selectionSummaryTextTitle =
            tempTitle[0] +
            'Significance: ' +
            temptTitle.join(' || ') +
            '|| Confidence Level: ' +
            this.y1.DefaultConfidenceLevel +
            ' || Base: ' +
            this.baseselected +
            ' || Weight: ' +
            this.weightSelectedValue;
        } else {
          this._configService.selectionSummaryTextTitle =
            tempTitle[0] +
            'Significance: ' +
            signi +
            ' || Confidence Level: ' +
            this.y1.DefaultConfidenceLevel +
            ' || Base: ' +
            this.baseselected +
            ' || Weight: ' +
            this.weightSelectedValue;
        }
      }
    } else {
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        ' || Significance: ' +
        signi;
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        ' || Confidence Level: ' +
        this.y1.DefaultConfidenceLevel +
        ' || Base: ' +
        this.baseselected +
        ' || Weight: ' +
        this.weightSelectedValue;
    }

    this.UpdateSelectionSummary();
  }

  Summary() {
    const content =
      this.inforRibbon != undefined
        ? this.inforRibbon.nativeElement.textContent
        : '';
    return content;
  }

  private refreshSelectionSummaryFromLeftPanel(): void {
    if (this.child?.UpdateSelectionSummary) {
      this.child.UpdateSelectionSummary();
    }
  }

  UpdateSelectionSummary() {
    this.isSubmitClicked = true;
    const infoRibbonTextValuesDiv = document.querySelector(
      '.InforRibbonTextValues'
    ) as HTMLDivElement;

    const summaryHtml = this._configService.selectionSummaryText;
    const summaryTitle = this._configService.selectionSummaryTextTitle;

    if (this.inforRibbon) {
      setSanitizedHtml(this.inforRibbon.nativeElement, summaryHtml);
      this.inforRibbon.nativeElement.title = summaryTitle;
    }

    if (infoRibbonTextValuesDiv != null) {
      setSanitizedHtml(infoRibbonTextValuesDiv, summaryHtml);
      infoRibbonTextValuesDiv.title = summaryTitle;
    }

    this._configService.setDropdownValue('selectionSummary', summaryTitle);
  }

  UpdateIndexSummary() {
    let temp = this._configService.selectionSummaryText.split(
      'Significance: </span>'
    );
    let index = this.displayReference;
    const _baseDisplay = (this.baseselected === 'Multiple' && this.selectedCustomBaseReference.length > 1)
      ? 'Multiple (' + this.selectedCustomBaseReference.join(', ') + ')'
      : this.baseselected;

    this._configService.selectionSummaryText =
      temp[0] +
      (this._configService.isSemiAggregatedData ||
      this._configService.isAggregatedData
        ? `<span class="grey-separator"> ||  </span>`
        : '') +
      'Index: </span>' +
      index +
      (!this._configService.isSemiAggregatedData &&
      !this._configService.isAggregatedData
        ? `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Base: </span>` +
          _baseDisplay +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Weight: </span>` +
          this.weightSelectedValue
        : '');

    let tempTitle =
      this._configService.selectionSummaryTextTitle.split('Significance: ');
    this._configService.selectionSummaryTextTitle =
      tempTitle[0] +
      (this._configService.isSemiAggregatedData ||
      this._configService.isAggregatedData
        ? ` || `
        : '') +
      'Index: ' +
      index +
      (!this._configService.isSemiAggregatedData &&
      !this._configService.isAggregatedData
        ? ' || Base: ' +
          _baseDisplay +
          ' || Weight: ' +
          this.weightSelectedValue
        : '');

    this.UpdateSelectionSummary();
  }

  UpdateBaseSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes('Base: ')) {
      let temp =
        this._configService.selectionSummaryText.split('Base: </span>');

      let temp1 = temp[1]?.split(' Base');
      temp1[0] = this.baseselected == "Multiple" ? "Multiple (" + this.selectedCustomBaseReference.join(', ') +")" : this.baseselected;
      this._configService.selectionSummaryText =
        temp[0] +
        'Base: </span>' +
        temp1[0] +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Weight: </span>` +
        this.weightSelectedValue;

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Base: ');

      let tempTitle1 = tempTitle[1]?.split(' Base');
      tempTitle1[0] = this.baseselected == "Multiple" ? "Multiple (" + this.selectedCustomBaseReference.join(', ') +")" : this.baseselected;
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] +
        'Base: ' +
        tempTitle1[0] +
        ' || Weight: ' +
        this.weightSelectedValue;
    }

    this.UpdateSelectionSummary();
  }

  UpdateWeightSummary() {
    // update the summary text and the title for this.baseSelected
    if (this._configService.selectionSummaryText.includes('Weight: ')) {
      let temp =
        this._configService.selectionSummaryText.split('Weight: </span>');

      let temp1 = temp[1]?.split(' Weight');
      temp1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryText =
        temp[0] + 'Weight: </span>' + temp1[0];

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split('Weight: ');

      let tempTitle1 = tempTitle[1]?.split(' Weight');
      tempTitle1[0] = this.weightSelectedValue;
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] + 'Weight: ' + tempTitle1[0];
    }

    this.UpdateSelectionSummary();
  }

  previusParameters: any;
  getOutputData(
    type: string,
    isBaseType: string,
    pageNumber: number = 1,
    exportType: string = '',
    isTredendDataRequired: boolean = false,
    isDefaultPanel: boolean = false
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (isDefaultPanel) {
        this.y1.widegtconfigdetails.section =
          sessionStorage.getItem('sectionName');
        this.y1.widegtconfigdetails.subSection =
          sessionStorage.getItem('subsectionName');
      }

      this.previusParameters = {
        type: type,
        isBaseType: isBaseType,
      };

      this.typeSelected = type;
      this.baseTypeSelected = isBaseType;
      
      const previewSource =
        this.y1.previewData ?? this.y1.dataModel ?? this._configService.finalLeftPanelInputSelectedObject?.previewData ?? {};
     
      // Always include audienceSelectedBrand if it's set (for Audience Snapshot)
      let mergedPreviewData = { ...previewSource };
      if (this._configService.selectedcompareacrossOption === 'Audience Snapshot' && this.y1.previewData && this.y1.previewData['Audiencebrand']) {
        // If y1.previewData already has 'Audience brand' array, use it
        mergedPreviewData['Audiencebrand'] = this.y1.previewData['Audiencebrand'];
      }
      
      this._loaderService.showLoader();
      let finalLeftPanelSubmitObject = {
         previewData: mergedPreviewData, 
        selectedClient: this.y1.selected_client,
        selectedStudy: this.y1.selected_study,
        significance: this.y1.significance,
        isFilteringActive: this.y1.isFilteringActive,
        DefaultConfidenceLevel: this.y1.DefaultConfidenceLevel,
        isTotalBase: this.y1.isTotalBase,
        selectedWeight: this.y1.selectedWeight,
        weightColumnName: this.y1.weightColumnName,
        isBoostFactor: this.y1.isBoostFactor,
        SignificanceVsReference: this.y1.SignificanceVsReference,
        columnLength: this.y1.columnLength,
        dataArray: this.y1.dataArray,
        isBrandAnalysis: this.y1.isBrandAnalysis,
        isAggregatedData: this.y1.isAggregatedData,
        isSemiAggregatedData: this.y1.isSemiAggregatedData,
        isRespondentLevel: this.y1.isRespondentLevel,
        aggregatedVariables: this.y1.aggregatedVariables,
        istimePeriodWave: this.y1.istimePeriodWave,
        widegtconfigdetails: this.y1.widegtconfigdetails,
        indexVsBrandReference: this.y1.indexVsBrandReference,
        significanceVsBrandReference: this.y1.significanceVsBrandReference,
        isTrend: this._configService.checkTrendEnabled(this.existingData),
        widgetPageData: this._configService.widgetPageData,
        pageDetails: this._configService.widgetPageData,
        widgetDetails: this.widgetData,
        LeftPanelSelectedAudience: this.y1?.LeftPanelSelectedAudience,
        page: pageNumber,
        customBaseMetric: !this.y1.isTotalBase ? this.y1.customBaseMetric : null,
        multiCohort: this._configService.multiCohort
      };

      this._configService.finalLeftPanelSubmitObject =
        finalLeftPanelSubmitObject;
      this.updateBaseAvailabilityForCustomPctMeanVariables();

      if (isBaseType == '') {
        // Cancel any in-flight request so rapid base clicks don't stack up
        if (this.outputDataSub) {
          this.outputDataSub.unsubscribe();
          this.outputDataSub = null;
        }
        this.outputDataSub = this._configService
            .getOutPutData(
              finalLeftPanelSubmitObject.previewData,
              this.y1.selectedClient,
              this.y1.selectedStudy,
              this.y1.significance,
              this.y1.isFilteringActive,
              this.y1.DefaultConfidenceLevel,
              this.y1.isTotalBase,
              this.y1.selectedWeight,
              this.y1.weightColumnName,
              this.y1.isBoostFactor,
              this.y1.SignificanceVsReference,
              this.y1.columnLength,
              this.y1.dataArray,
              this.y1.isBrandAnalysis,
              this.y1.isAggregatedData,
              this.y1.isSemiAggregatedData,
              this.y1.isRespondentLevel,
              this.y1.aggregatedVariables,
              this.y1.istimePeriodWave,
              this.y1.widegtconfigdetails,
              this.y1.indexVsBrandReference,
              this.y1.significanceVsBrandReference,
              isTredendDataRequired,
              this._configService.widgetPageData,
              this._configService.widgetData,
              pageNumber,
              isTredendDataRequired ? true : false,
              !this.y1.isTotalBase ? this.y1.customBaseMetric : null,
                    this._configService.multiCohort,
            )
            .subscribe({
              next: (result) => {
                if (
                  result.Data != null &&
                  result.Data != undefined &&
                  result.Data != ''
                ) {
                  let opData = JSON.parse(result.Data);
                  this.MainResult = opData;
                  const sortedOPdata = opData.sort(
                    (a: any, b: any) => a.widgetNumber - b.widgetNumber
                  );

                  if (type == 'reference') {
                    let dataForRef = _.cloneDeep(
                      sortedOPdata.filter((item: any) =>
                        this.y1.LeftPanelSelectedTimePeriod.some(
                          (period: any) => item.Level1ColChild?.includes(period)
                        )
                      )
                    );
                    let selectedSig =
                      this.y1.significanceVsBrandReference.length > 0;
                    this.referenceCalculation(sortedOPdata, selectedSig);
                if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        } else {
          this._loaderService.hideLoader();
        }
      
                  } else if (type == 'sig') {
                    let dataForRef = _.cloneDeep(
                      sortedOPdata.filter((item: any) =>
                        this.y1.LeftPanelSelectedTimePeriod.some(
                          (period: any) => item.Level1ColChild?.includes(period)
                        )
                      )
                    );
                    let selectedSig =
                      this.y1.significanceVsBrandReference.length > 0;
                    let selectedIndex =
                      this.y1.indexVsBrandReference?.length > 0;
                    if (selectedSig || selectedIndex) {
                      this.referenceCalculation(sortedOPdata, selectedSig);
                    } else {
                      this._configService.standardSnapOutputData = sortedOPdata;
                      if (typeof window !== undefined) {
                        (window as any)['jsonobject'] = sortedOPdata;
                      }
                    }
                    //this.afterSubmit();
                      this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData() so the
        // spinner stays active until ALL processing (including trend API) completes.
      });
                  } else if (type == 'significance') {
                    let dataForRef = _.cloneDeep(
                      sortedOPdata.filter((item: any) =>
                        this.y1.LeftPanelSelectedTimePeriod.some(
                          (period: any) => item.Level1ColChild?.includes(period)
                        )
                      )
                    );
                    this._configService.standardSnapOutputData = sortedOPdata;
                    if (typeof window !== undefined) {
                      (window as any)['jsonobject'] = sortedOPdata;
                    }
                   // this.afterSubmit();
                     this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
                  }
                   else if (type == 'confidence') {
                    let dataForRef = _.cloneDeep(
                      sortedOPdata.filter((item: any) =>
                        this.y1.LeftPanelSelectedTimePeriod.some(
                          (period: any) => item.Level1ColChild?.includes(period)
                        )
                      )
                    );
                    this._configService.standardSnapOutputData = sortedOPdata;
                    if (typeof window !== undefined) {
                      (window as any)['jsonobject'] = sortedOPdata;
                    }
                    //this.afterSubmit();
                      this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
                  }
                  else if (type == 'weight') {
                    this._configService.standardSnapOutputData = sortedOPdata;
                    if (typeof window !== undefined) {
                      (window as any)['jsonobject'] = sortedOPdata;
                    }
                    //this.afterSubmit();
                      this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
                    // let selectedSig =
                    //   this.y1.significanceVsBrandReference.length > 0;
                    // this.referenceCalculation(sortedOPdata, selectedSig);
                  } else if (type == '') {
                    this._configService.standardSnapOutputData = sortedOPdata;
                    if (typeof window !== undefined) {
                      (window as any)['jsonobject'] = sortedOPdata;
                    }
                    //this.afterSubmit();
                      this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });

                  }

                  // if (exportType == 'ppt') {
                  //   this.editablePPTClicked(isTredendDataRequired);
                  // } else if (exportType == 'excel') {
                  //   this.excelexportClicked();
                  // } else {
                  //   this._loaderService.hideLoader();
                  // }

                  resolve(sortedOPdata);
                } else {
                  //No Output Data
                  this._loaderService.hideLoader();
                  resolve(null);
                }
              },
              error: (error) => {
                this._loaderService.hideLoader();
                reject(error);
              },
            });
      } else {
        if (
          this.MainResult != null &&
          this.MainResult != undefined &&
          this.MainResult != ''
        ) {
          let opData = this.MainResult;
          const sortedOPdata = opData.sort(
            (a: any, b: any) => a.widgetNumber - b.widgetNumber
          );

          if (type == 'reference') {
            let dataForRef = sortedOPdata.filter((item: any) =>
              this.y1.LeftPanelSelectedTimePeriod.some((period: any) =>
                item.Level1ColChild?.includes(period)
              )
            );
            let selectedSig = this.y1.significanceVsBrandReference.length > 0;
            this.referenceCalculation(sortedOPdata, selectedSig);
                if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        } else {
          this._loaderService.hideLoader();
        }
     
          } else if (type == 'sig') {
            let dataForRef = sortedOPdata.filter((item: any) =>
              this.y1.LeftPanelSelectedTimePeriod.some((period: any) =>
                item.Level1ColChild?.includes(period)
              )
            );
            this._configService.standardSnapOutputData = sortedOPdata;
            let selectedSig = this.y1.significanceVsBrandReference.length > 0;
            this.referenceCalculation(sortedOPdata, selectedSig);
           // this.afterSubmit();
             this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
          } else if (type == 'significance') {
            let dataForRef = sortedOPdata.filter((item: any) =>
              this.y1.LeftPanelSelectedTimePeriod.some((period: any) =>
                item.Level1ColChild?.includes(period)
              )
            );
            this._configService.standardSnapOutputData = sortedOPdata;
           // this.afterSubmit();
             this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
          } else if (type == 'weight') {
            this._configService.standardSnapOutputData = sortedOPdata;
            // let selectedSig = this.y1.significanceVsBrandReference.length > 0;
            // this.referenceCalculation(sortedOPdata, selectedSig);
          //  this.afterSubmit();
            this.afterSubmit().then(() => {
        if (exportType == 'ppt') {
          this.editablePPTClicked(isTredendDataRequired);
        } else if (exportType == 'excel') {
          this.excelexportClicked();
        }
        // hideLoader is owned by afterSubmit()/getWithTrendData()
      });
          }
          // if (exportType == 'ppt') {
          //   this.editablePPTClicked(isTredendDataRequired);
          // } else if (exportType == 'excel') {
          //   this.excelexportClicked();
          // } else {
          //   this._loaderService.hideLoader();
          // }

          resolve(sortedOPdata);
        } else {
          this._loaderService.hideLoader();
          resolve(null);
        }
      }
    });
  }

  getOutputDataForSampleSize(pageNumber: number = 1) {
    this.subscriptions.add(
    this._configService
        .getOutPutData(
          this._configService.finalLeftPanelSubmitObject?.previewData ?? this.y1.previewData ?? this.y1.dataModel ?? {},
          this.y1.selectedClient,
          this.y1.selectedStudy,
          this.y1.significance,
          this.y1.isFilteringActive,
          this.y1.DefaultConfidenceLevel,
          this.y1.isTotalBase,
          this.y1.selectedWeight,
          this.y1.weightColumnName,
          this.y1.isBoostFactor,
          this.y1.SignificanceVsReference,
          this.y1.columnLength,
          this.y1.dataArray,
          this.y1.isBrandAnalysis,
          this.y1.isAggregatedData,
          this.y1.isSemiAggregatedData,
          this.y1.isRespondentLevel,
          this.y1.aggregatedVariables,
          this.y1.istimePeriodWave,
          this.y1.widegtconfigdetails,
          this.y1.indexVsBrandReference,
          this.y1.significanceVsBrandReference,
          this._configService.checkTrendEnabled(this.existingData),
          this._configService.widgetPageData,
          this._configService.widgetData,
          pageNumber,
          true
        )
        .subscribe((result) => {
          if (
            result.Data != null &&
            result.Data != undefined &&
            result.Data != ''
          ) {
            let opData = JSON.parse(result.Data);
            this.MainResult = opData;
            const sortedOPdata = opData.sort(
              (a: any, b: any) => a.widgetNumber - b.widgetNumber
            );
            this._configService.standardSnapOutputData = sortedOPdata;
            if (typeof window !== undefined) {
              (window as any)['jsonobject'] = sortedOPdata;
            }
            this.afterSubmitforSampleSize();
            // this.onPaginateCall(this.pageEvents);

            this._loaderService.hideLoader();
          } else {
            //No Output Data
            this._loaderService.hideLoader();
          }
        })
    );
  }

  confidenceDropDownClick(SelectedValue: string) {
    this.DefaultConfidenceLevel = SelectedValue;
    this.confidenceLevelDropDown = false;
    this.DefaultDataDropDown = 'Data';
    //this.createTable(true, Feature.ConfidenceLevel, false);
  }

  // toggleSigBlock(block: string): void {
  //     if (block === 'Sig') {
  //       this.isSig = true;
  //       this.isIndex = false;
  //       this.isChartView = true;
  //       this.isSampleSize = false;
  //       this.isWeightedLabel = false;
  //       this.isWeightedNumerator = false;
  //       this.isUnWeightedNumerator = false;
  //       //this.createTable(false, Feature.CrosstabOutput, false);
  //       // this.sampleSizeDropdown=true;
  //       this.is_Time_Period_Present = true;
  //       this.manipulateIndexData();
  //     } else if (block === 'Index') { 
  //       this.displayTable = true;
  //       this.isData = true;
  //       this.isWeightedNumerator = false;
  //       this.isUnWeightedNumerator = false;
  //       this.DefaultDataDropDown = 'Data';
  //       this.isVerticalGroupBarChartClick = false;
  //       this.isVerticalBarChartClick = false;
  //       this.isVerticalStackChartClick = false;
  //       this.isLineChartClick = false;
  //       this.isSig = false;
  //       this.isIndex = true;
  //       this.isChartView = false;
  //       this.DefaultReferenceLevel = 'None';
  //       this.DefaultSampleSize = 'None';
  //       this.DefaultConfidenceLevel = 'None';
  //       this.SignificanceVsReference = '';
  //       this.isReference = false;
  //       this.selectedIndex = '';
  //       this.isPairWise = false;
  //       if (this.isTranspose) {
  //         this.isTranspose = false;
  //         //this.reverseTranspose();
  //       }
  //       this.manipulateIndexData();
  //       //this.IndexData = this.getLastLevelColumnNestingValues();
  //     }
  //   }

  getLastLevelColumnNestingValues() {
    var indexData;
    if (this.OutputdataObject.Column.length > 0) {
      if (this.OutputdataObject['Column'][0]['Data'].length > 0) {
        let firstLevelLength =
          this.OutputdataObject['Column'][0]['Data'].length;

        if (firstLevelLength > 0) {
          let level0 =
            this.OutputdataObject['Column'][0]['Data'][firstLevelLength - 1];
          if (level0.NestedArray.length > 0) {
            let secondLevelLength = level0.NestedArray.length;
            if (secondLevelLength > 0) {
              let level1 = level0.NestedArray[secondLevelLength - 1];

              if (level1.NestedArray.length > 0) {
                let finalData =
                  this.OutputdataObject['Column'][0]['Data'][
                    firstLevelLength - 1
                  ].NestedArray[secondLevelLength - 1].NestedArray;
                indexData = finalData;
                this.columnLength = 2;
              } else {
                indexData = level0.NestedArray;
                this.columnLength = 1;
              }
            }
          } else {
            indexData = this.OutputdataObject['Column'][0]['Data'];
            this.columnLength = 0;
          }
        }
      }
    }

    return indexData;
  }

  manipulateIndexData() {
    let level = 0;
    if (this.outputData.ColNesting.length > 0) {
      level = this.outputData.ColNesting.length;
    }
    let selectedIndexData = this.outputData.filter((x: any) => {
      if (level == 1) return x.Level1ColChild == this.selectedIndex;
      else if (level == 2) return x.Level2ColChild == this.selectedIndex;
      else return x.colChild == this.selectedIndex;
    });
    if (selectedIndexData.length > 0) {
      selectedIndexData = JSON.parse(JSON.stringify(selectedIndexData));
      selectedIndexData.forEach((item: any) => {
        let indexData = this.outputData.filter((x: any) => {
          if (level == 1) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild
            );
          } else if (level == 2) {
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild &&
              x.colChild == item.colChild &&
              x.Level1ColChild == item.Level1ColChild
            );
          } else
            return (
              x.rowChild == item.rowChild &&
              x.Level2RowChild == item.Level2RowChild &&
              x.Level1RowChild == item.Level1RowChild
            );
        });
        if (indexData.length > 0) {
          indexData.forEach((indexItem: any) => {
            if (this.selectedWeight == 'Unweighted') {
              indexItem.totalUnweightedShare = isNaN(
                indexItem.totalUnweightedShare / item.totalUnweightedShare
              )
                ? null
                : isFinite(
                    indexItem.totalUnweightedShare / item.totalUnweightedShare
                  )
                ? indexItem.totalUnweightedShare / item.totalUnweightedShare
                : null;
              indexItem.answerUnweightedShare = isNaN(
                indexItem.answerUnweightedShare / item.answerUnweightedShare
              )
                ? null
                : isFinite(
                    indexItem.answerUnweightedShare / item.answerUnweightedShare
                  )
                ? indexItem.answerUnweightedShare / item.answerUnweightedShare
                : null;
              indexItem.totalUnweightedShare_Index =
                indexItem.totalUnweightedShare;
              indexItem.answerUnweightedShare_Index =
                indexItem.answerUnweightedShare;
            } else {
              indexItem.totalWeightedShare = isNaN(
                indexItem.totalWeightedShare / item.totalWeightedShare
              )
                ? null
                : isFinite(
                    indexItem.totalWeightedShare / item.totalWeightedShare
                  )
                ? indexItem.totalWeightedShare / item.totalWeightedShare
                : null;
              indexItem.answerWeightedShare = isNaN(
                indexItem.answerWeightedShare / item.answerWeightedShare
              )
                ? null
                : isFinite(
                    indexItem.answerWeightedShare / item.answerWeightedShare
                  )
                ? indexItem.answerWeightedShare / item.answerWeightedShare
                : null;
              indexItem.totalWeightedShare_Index = indexItem.totalWeightedShare;
              indexItem.answerWeightedShare_Index =
                indexItem.answerWeightedShare;
            }
          });
        }
      });
    }
  }

  handleCheckboxClick(event: MouseEvent) {
    // Check if the checkbox was clicked
    if (
      event.target instanceof HTMLInputElement &&
      event.target.type === 'checkbox'
    ) {
      // If the checkbox was clicked, don't call variableExpand()
      return;
    }
  }

  selectedType: string = '';
  filteredWidgetSelection: any;
  selectedTypeFun2(data: any) {
    this.selectedType = data;
    const sectionNav = document.querySelector('app-header-section-list');
    if (sectionNav) {
      sectionNav?.classList.remove('NN');
    }

    this.filteredWidgetSelection = this.existingData.snapshotType.filter(
      (item: any) => {
        //for Multiple Brands if else condition will come based on snapshotType
        return (
          item.snapshotType_name == this.selectedType &&
          item.section.filter(
            (s: any) =>
              s.section_name != 'NA' &&
              s.subsection.filter((ss: any) => ss.subsection_name != 'NA')
          )
        );
      }
    );

    this.moduleList = [];
    this.filteredWidgetSelection[0].section.forEach((element: any) => {
      this.moduleList.push({ name: element.section_name, isSelected: false });
    });

    const sessionSection = sessionStorage.getItem('sectionName');
    this.moduleList.forEach((item: any) => {
      if (item.name === sessionSection) {
        item.isSelected = true;
      }
    });

    // this.moduleList[0].isSelected = true;

    //Subsection
    let selectedSection = this.moduleList.filter(
      (item: any) => item.isSelected == true
    )[0]?.name;
    let subSections = this.filteredWidgetSelection[0].section.filter(
      (item: any) => item.section_name == selectedSection
    )[0]?.subsection;
    if (subSections) {
      subSections.forEach((element: any) => {
        this.subSectionNames.push({
          name: element.subsection_name,
          isSelected: false,
        });
      });
    }
    // this.subSectionNames[0].isSelected = true;

    //To get pagedetails for selected section and subsection
    this.pageDetailsForSectionSubsection();
  }

  receivedModifiedList(data: any) {
    this.moduleList = _.cloneDeep(data);

    //Subsection
    this.subSectionNames = [];
    let selectedSection = this.moduleList.filter(
      (item: any) => item.isSelected == true
    )[0].name;
    let subSections = this.filteredWidgetSelection[0].section.filter(
      (item: any) => item.section_name == selectedSection
    )[0].subsection;
    subSections.forEach((element: any) => {
      this.subSectionNames.push({
        name: element.subsection_name,
        isSelected: false,
      });
    });
    this.subSectionNames[0].isSelected = true;
    // this._configData.pageCounter.next(1);
    // this._configData.page2ToggleSubject.next(1);
    // this.filteredWidgetSelection = this.filteredWidgetSelection;

    //To get pagedetails for selected section and subsection
    //this.pageDetailsForSectionSubsection();
  }

  OnSubSectionClick(item: any) {
    for (let i = 0; i < this.subSectionNames.length; i++) {
      if (this.subSectionNames[i].name == item.name) {
        item.isSelected = true;
      } else {
        this.subSectionNames[i].isSelected = false;
      }
    }

    //To get pagedetails for selected section and subsection
    this.pageDetailsForSectionSubsection();
  }

  output_details: any = {};
  pageData: any;
  widgetData: any;

  pageDetailsForSectionSubsection() {
    let selectedSectionData = this.moduleList.find(
      (item: any) => item.isSelected
    );
    let selectedSectionName = selectedSectionData
      ? selectedSectionData.name
      : null;
    if (this._configService.selectedSection) {
      selectedSectionName = this._configService.selectedSection;
    }
    let selectedSubsectionData = this.subSectionNames.find(
      (item: any) => item.isSelected
    );
    let selectedSubsectionName = selectedSubsectionData
      ? selectedSubsectionData.name
      : 'NA';
    if (
      this._configService.selectedSubSection &&
      this._configService.selectedSubSection != 'undefined'
    ) {
      selectedSubsectionName = this._configService.selectedSubSection;
    }
    let x = this.filteredWidgetSelection[0];
    let pageDetails = [];
    let widgetDetails = [];

    for (let i = 0; i < x.section.length; i++) {
      if (x.section[i].section_name == selectedSectionName) {
        for (let j = 0; j < x.section[i].subsection.length; j++) {
          if (
            x.section[i].subsection[j].subsection_name ==
              selectedSubsectionName ||
            (selectedSubsectionName == null &&
              x.section[i].subsection[j].subsection_name == '')
          ) {
            pageDetails = x.section[i].subsection[j].page_details;
            widgetDetails = x.section[i].subsection[j].widget_detail;
          }
        }
      }
    }

    // this.output_details = {
    //   pageData: pageDetails,
    //   widgetData: widgetDetails
    // };

    // Apply page optimization based on widget count
    let widgetCount = widgetDetails ? widgetDetails.length : 0;

    // Enhanced widget counting: consider both configured widgets and actual output widgets
    let enhancedWidgetCount = this.calculateEnhancedWidgetCount(widgetDetails, widgetCount);

    let optimizedPageDetails = this.optimizePageLayout(pageDetails, enhancedWidgetCount);

    // Log optimization results for debugging
    this.logOptimizationResults(pageDetails, optimizedPageDetails, enhancedWidgetCount);



    this.pageData = optimizedPageDetails;
    this.widgetData = _.sortBy(widgetDetails, 'previewChartPostion');

    // Update service with optimized page data for consistency across the application
    this._configService.widgetPageData = optimizedPageDetails;
    this._configService.widgetData = this.widgetData;

    // Also update the custom service if it has page data
    if (this._configCustomService && this._configCustomService.dataFromPageDetailForPreview) {
      this._configCustomService.dataFromPageDetailForPreview = optimizedPageDetails;
    }
  }

  private getConfiguredWidgetsWithDataState(): any[] {
    const widgetNamesWithData = new Set(
      (Array.isArray(this.outputData) ? this.outputData : [])
        .map((item: any) => item.widgetName)
        .filter((widgetName: any) => widgetName != null)
    );

    return _.cloneDeep(Array.isArray(this.widgetData) ? this.widgetData : []).map(
      (widget: any) => {
        if (!widgetNamesWithData.has(widget.widget_name)) {
          // Keep the configured position, but let the view render its no-data state.
          widget.metric = [];
          widget.noData = true;
          widget.noDataAvailble = true;
          widget.widgetNotConfigured = false;
        }
        return widget;
      }
    );
  }

  item: any;
  items: any;
  itemWithoutTrend: any;
  itemWithoutTrendItems: any;

   async afterSubmit() {

    // Keep SnapshotService base in sync with the base used to build widget metric.data.
    if (this.baseselected === 'Total Base' || this.baseselected === 'Answer Base') {
      this._configService.setDropdownValue('baseType', this.baseselected);
      this.isTotalBase = this.baseselected.toLowerCase() === 'total base';
      if (this.y1) {
        this.y1.isTotalBase = this.isTotalBase;
      }
    }

    this.isInsightspopupOpen = false;
     this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
    this.insightsVal = undefined;
    this.insightsObj['show'] = false;
    this.insightsObj['message'] = '';
    this.insightsObj['header'] = '';
    this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
    //this.outputData = this._configCustomService.SampleOutputArray; // change later
    this.outputData = this._configService.standardSnapOutputData;
    // Cache base type once to avoid repeated toLowerCase() in hot loops
    const isTotalBase = this.baseselected.toLowerCase() === 'total base';
    // Pre-build Map for O(1) sortId lookup instead of O(N) find() per comparison
    const brandSortMap = new Map<string, number>(
      (this._configService.brandSortId || []).map((item: any) => [item.name, item.sortId])
    );
    if (
      this._configService.selectedcompareacrossOption == 'Multiple Brands' ||
      this._configService.selectedcompareacrossOption == 'Multiple Markets'
    ) {
      this._configService.standardSnapOutputData.sort((a: any, b: any) => {
        const sortIdA = a.colChild ? brandSortMap.get(a.colChild.split('|')[1]) ?? Infinity : Infinity;
        const sortIdB = b.colChild ? brandSortMap.get(b.colChild.split('|')[1]) ?? Infinity : Infinity;
        return sortIdA - sortIdB;
      });
    }

    // Cache dedup + rowByChild: base type changes reuse the same standardSnapOutputData reference,
    // so we skip the expensive JSON.stringify/parse and Map rebuild on repeat calls.
    const _dedupSrc = this._configService.standardSnapOutputData;
    if (_dedupSrc !== this._cachedDedupSourceRef) {
      // Adding this code to remove duplicates
      this.outputData = Array.from(
        new Set(
          this.outputData
            .map((item: any) => {
              try {
                return JSON.stringify(item);
              } catch (err) {
                return null; // Return a placeholder for problematic items
              }
            })
            .filter((item: any) => item !== null) // Remove null placeholders
        )
      )
        .map((item: any) => {
          try {
            return JSON.parse(item);
          } catch (err) {
            return null; // Handle any parsing errors
          }
        })
        .filter((item) => item !== null); // Remove null placeholders again

      // Build rowByChild Map once per data refresh
      const _newRowByChild = new Map<string, any[]>();
      for (const row of this.outputData) {
        const key = row.rowChild as string;
        const existing = _newRowByChild.get(key);
        if (existing) existing.push(row);
        else _newRowByChild.set(key, [row]);
      }
      this._cachedDedupSourceRef = _dedupSrc;
      this._cachedDedupOutput = this.outputData;
      this._cachedRowByChild = _newRowByChild;
    } else {
      this.outputData = this._cachedDedupOutput!;
    }
    let arr: any[] = [];
    let arrWithoutTrend: any[] = [];
    let metricsAvailable: any[] = [];
    // this.items = this.output_details.widgetData;
    // if(this.widgetData.length>0){
    //   this.widgetData.forEach((w:any)=>{
    //     if(w.metric.length>0){
    //       w.metric.forEach((m:any)=>{
    //         m.metric_value=JSON.parse(m.metric_value[0]);
    //       })
    //     }
    //   })
    // }

    let finalWidgetData = this.getConfiguredWidgetsWithDataState();
    
    // Add audience as metric if metric is missing
    finalWidgetData.forEach((widget: any) => {

  // BRAND dependent metric
  if (
    !widget.metric &&
    Array.isArray(widget.brand) &&
    widget.brand.length > 0
  ) {
    widget.metric = [
      {
        metric_option: 'Brand',
        metric_value: [
          JSON.stringify(
            widget.brand.map((br: any) => ({
              option: br.option,
              selectOrder: br.selectOrder,
              typeofmetric: 'BRAND',
              data: []
            }))
          )
        ],
        metric_group: ''
      }
    ];
  }

  // AUDIENCE dependent metric (fallback)
  else if (
    !widget.metric &&
    Array.isArray(widget.audience) &&
    widget.audience.length > 0
  ) {
    widget.metric = [
      {
        metric_option: 'Audience',
        metric_value: [
          JSON.stringify(
            widget.audience.map((aud: any) => ({
              option: aud.option,
              selectOrder: aud.selectOrder,
              typeofmetric: 'AUDIENCE',
               isInnerCircle: aud.isInnerCircle || false,
              data: []
            }))
          )
        ],
        metric_group: ''
      }
    ];
  }

});
    this.items = structuredClone(finalWidgetData);
    this.checkAndSetupBrandDropdown();

    const rowByChild = this._cachedRowByChild!;

    if (this._configService.selectedcompareacrossOption.includes('Multiple') ) {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }

            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);
            
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                // Metrics with the same label can exist in multiple widgets.
                // Keep only this widget's rows so they are not rendered as
                // additional numeric/category bars.
                const outputRow: any[] = (rowByChild.get(metric.option) ?? [])
                  .filter((row: any) => row.widgetName === item.widget_name);

                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const colA = this.resolveColChild(a);
                    const colB = this.resolveColChild(b);
                    const sortIdA = colA ? brandSortMap.get(colA.split('|')[1]) ?? Infinity : Infinity;
                    const sortIdB = colB ? brandSortMap.get(colB.split('|')[1]) ?? Infinity : Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: (this.shouldUseMetricAsSeriesLabel(metricsAvailable.length)
                      && !this._configService.selectedcompareacrossOption.includes('Multiple'))
                      ? null
                      : this.resolveColChild(row),
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs: isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY: isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value: isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });

                if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                  metric.data = this._configService.sortTrendTimeporiodData(
                    metric.data
                  );
                }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (item.widgetchart_name != 'Table') {
                let maxmetriclimit = JSON.parse(
                  item?.customizationProperties
                )?.maxMetricLimit;
                if (maxmetriclimit != undefined) {
                  result = result.slice(0, maxmetriclimit);
                }
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                      metricsAvailable[index].data =
                        this._configService.sortTrendTimeporiodData(
                          metricsAvailable[index].data
                        );
                    }

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
      //To trigger ngOnchnages of widget-output component
      // this.output_details = {
      //   ...this.output_details,
      //   widgetData: arr
      // };
      // this.output_details = {
      //   pageData: this.pageData,
      //   widgetData: this.items
      // };

      //Trend Data Code:
      this.itemWithoutTrendItems = structuredClone(finalWidgetData);
      let brands: string[] = _.uniq(
        this.outputData.map((metric: any) => metric.colChild)
      );
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }

            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);

            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);
              let resultBrands = this.checkBrands(brands);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                // this.outputData.forEach((row: any) => {
                //   // if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView) {
                //   //   outputRow.push(row);
                //   // }
                //   if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == "Month|Jun_2023") {
                //     outputRow.push(row);
                //   }
                // })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));

                // this.outputData.forEach((row: any) => {
                //   if (row.rowChild == metric.option ) {  //&& item.widget_name == row.widgetName
                //     outputRow.push(row);
                //     return true; //removr this later
                //   }
                //   return false; //removr this later
                // })

                // for (const row of this.outputData) {
                //   if (
                //     row.rowChild === metric.option &&
                //     item.widget_name === row.widgetName &&
                //     (this._configService.isStaticTimeFrame ||
                //       (this._configService.selectedTPforNonTrendView ?? '') ===
                //         (row.Level1ColChild ?? ''))
                //   ) {
                //     // && item.widget_name === row.widgetName
                //     outputRow.push(row);
                //     // break;  // Breaks out of the loop once the condition is met
                //   }
                // }
const isAudienceSnapshot =
  this._configService.selectedSnapshotType === 'Audience Snapshot';

for (const row of this.outputData) {

  const timePeriod = isAudienceSnapshot
    ? row.Level1ColChild
    : (row.Level1ColChild || row.colChild);

  if (
    row.rowChild === metric.option &&
    item.widget_name === row.widgetName &&
    (
      this._configService.isStaticTimeFrame ||
      !timePeriod ||
      this._configService.selectedTPforNonTrendView === timePeriod
    )
  ) {
    outputRow.push(row);
  }
}
                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA = a.colChild ? brandSortMap.get(a.colChild.split('|')[1]) ?? Infinity : Infinity;
                    const sortIdB = b.colChild ? brandSortMap.get(b.colChild.split('|')[1]) ?? Infinity : Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: this.resolveColChild(row, resultBrands),
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                  //   allMetricsNull = false;
                  // }
                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              //const metrics = this.outputData.filter((row: any) => item.widget_name == row.widgetName && this._configService.selectedTPforNonTrendView == row.Level1ColChild);
              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name === row.widgetName &&
                  (this._configService.selectedTPforNonTrendView ?? '') ===
                    (row.Level1ColChild ?? '')
              );
              // const metrics = this.outputData.filter((row: any) => item.widgetName == row.widget_name && row.Level1ColChild == this._configService.selectedTPforNonTrendView);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              // if (result.slice(0, 6).length > 0) {
              //   //result.slice(0, 6)
              //   result.forEach((metric: any, index: number) => {
              let maxmetriclimit = JSON.parse(item?.customizationProperties)?.maxMetricLimit;
let limitedResult = (item.widgetchart_name !== 'Table' && maxmetriclimit != undefined)
    ? result.slice(0, maxmetriclimit)
    : result;
if (limitedResult.length > 0) {
    limitedResult.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    } else {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }

            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);

            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);
console.log("output data", this.outputData);
              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {
                if (
                  row.rowChild == metric.option
                ) {
                    //&& item.widget_name == row.widgetName
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));

                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });

                if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                  metric.data = this._configService.sortTrendTimeporiodData(
                    metric.data
                  );
                }
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              console.log("output data", this.outputData);
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              // if (result.length > 0) {
              //   result.forEach((metric: any, index: number) => {
              let maxmetriclimit = JSON.parse(item?.customizationProperties)?.maxMetricLimit;
              if (maxmetriclimit == null || maxmetriclimit === undefined) {
    const chartEntry = this._configCustomService.ChartPropertiesOptionSelection?.find(
        (c: any) => c.Chart?.trim().toLowerCase() === item.widgetchart_name?.trim().toLowerCase()
    );
    maxmetriclimit = chartEntry?.MaxMetricLimit;
}
let limitedResult = (item.widgetchart_name !== 'Table' && maxmetriclimit != undefined)
    ? result.slice(0, maxmetriclimit)
    : result;
if (limitedResult.length > 0) {
    limitedResult.forEach((metric: any, index: number) => {

                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                      metricsAvailable[index].data =
                        this._configService.sortTrendTimeporiodData(
                          metricsAvailable[index].data
                        );
                    }
                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
      //To trigger ngOnchnages of widget-output component
      // this.output_details = {
      //   ...this.output_details,
      //   widgetData: arr
      // };
      // this.output_details = {
      //   pageData: this.pageData,
      //   widgetData: this.items
      // };

      //Trend Data Code:
      this.itemWithoutTrendItems = structuredClone(finalWidgetData);
      if (this.itemWithoutTrendItems) {
        this.itemWithoutTrendItems.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }

            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);

            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];
              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );
              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                // this.outputData.forEach((row: any) => {
                //   // if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == this._configService.selectedTPforNonTrendView) {
                //   //   outputRow.push(row);
                //   // }
                //   if (row.rowChild == metric.option && item.widget_name == row.widgetName && row.Level1ColChild == "Month|Jun_2023") {
                //     outputRow.push(row);
                //   }
                // })
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));

                // this.outputData.forEach((row: any) => {
                //   if (row.rowChild == metric.option ) {  //&& item.widget_name == row.widgetName
                //     outputRow.push(row);
                //     return true; //removr this later
                //   }
                //   return false; //removr this later
                // })

                // for (const row of this.outputData) {
                //   // if (row.rowChild === metric.option && item.widget_name === row.widgetName && this._configService.selectedTPforNonTrendView == row.Level1ColChild) {  // && item.widget_name === row.widgetName
                //   //   outputRow.push(row);
                //   //   // break;  // Breaks out of the loop once the condition is met
                //   // }
                //   if (
                //     row.rowChild === metric.option &&
                //     item.widget_name === row.widgetName &&
                //     (this._configService.isStaticTimeFrame ||
                //       (this._configService.selectedTPforNonTrendView ?? '') ===
                //         (row.Level1ColChild ?? ''))
                //   ) {
                //     outputRow.push(row);
                //   }
                // }
const isAudienceSnapshot =
  this._configService.selectedSnapshotType === 'Audience Snapshot';

for (const row of this.outputData) {

  const timePeriod = isAudienceSnapshot
    ? row.Level1ColChild
    : (row.Level1ColChild || row.colChild);

  if (
    row.rowChild === metric.option &&
    item.widget_name === row.widgetName &&
    (
      this._configService.isStaticTimeFrame ||
      !timePeriod ||
      this._configService.selectedTPforNonTrendView === timePeriod
    )
  ) {
    outputRow.push(row);
  }
}
                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                  //   allMetricsNull = false;
                  // }
                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              // const metrics = this.outputData.filter((row: any) => item.widget_name == row.widgetName && this._configService.selectedTPforNonTrendView == row.Level1ColChild);

              const metrics = this.outputData.filter(
                (row: any) =>
                  item.widget_name === row.widgetName &&
                  (this._configService.selectedTPforNonTrendView ?? '') ===
                    (row.Level1ColChild ?? '')
              );
              // const metrics = this.outputData.filter((row: any) => item.widgetName == row.widget_name && row.Level1ColChild == this._configService.selectedTPforNonTrendView);

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (item.widgetchart_name != 'Table') {
                let maxmetriclimit = JSON.parse(
                  item?.customizationProperties
                )?.maxMetricLimit;
                if (maxmetriclimit != undefined) {
                  result = result.slice(0, maxmetriclimit);
                }
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    option: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }

            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arrWithoutTrend.push(this.itemWithoutTrendItems);
    }
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    this._configService.itemWithTrendData = arr;
 if (!this.IsPPTDownloadClicked) {
  //   // Create a new array for widget data
  //   const widgetDataPromises = this.itemWithoutTrendItems.map((item: any) => {
  //     if (
  //       item.widgetchart_name &&
  //       item.widgetchart_name.toLowerCase() === 'trend as widget' &&
  //       Array.isArray(item.metric) &&
  //       item.metric.length > 0
  //     ) {
  //       return {
  //         ...item,
  //         metric: [
  //           {
  //             ...item.metric[0],
  //             metric_value: []
  //           },
  //           ...item.metric.slice(1)
  //         ],
  //         _pendingTrendData: this.getTrendData(item) // âœ… No await here, just store the promise
  //       };
  //     }
  //     return item;
  //   });

  // // Process trend data after promises resolve
  //  const resolvedWidgetData = await Promise.all(
  //     widgetDataPromises.map(async (w: any) => {
  //       if (w._pendingTrendData) {
  //         try {
  //           w.metric[0].metric_value = await w._pendingTrendData;
  //           delete w._pendingTrendData;
  //         } catch (error) {
  //           console.error('Error resolving trend data:', error);
  //         }
  //       }
  //       return w;
  //     })
  //   );
    // Compute trend flags for export menu visibility.
    this.hasTrendline =
      Array.isArray(this.itemWithoutTrendItems) &&
      this.itemWithoutTrendItems.some(
        (widget: any) => {
          // Trend as Widget
          if (widget.widgetchart_name?.toLowerCase() === 'trend as widget') {
            return true;
          }
          // Trend view: Trendline flag in customizationProperties
          try {
            const props = JSON.parse(widget.customizationProperties);
            return (
              props.Trendline === true || props.TrendlineinExports === true ||
              (props.additionalGroup &&
                props.additionalGroup.Trendline === true)
            );
          } catch { return false; }
        }
      );

    this.isTrendlineInExportsEnabled =
      Array.isArray(this.itemWithoutTrendItems) &&
      this.itemWithoutTrendItems.some((widget: any) => {
        try {
          const props = JSON.parse(widget.customizationProperties);
          return props.TrendlineinExports === true;
        } catch {
          return false;
        }
      });

    //storing converted output to a service variable
    this._configService.allPageOutputData = arr;
    this._configService.allPageOutputDataWithoutTrend = arrWithoutTrend;
    // this.isSubmitClicked = true;
    this.IsPPTDownloadClicked = false;
    this.checkNegativeValuesAlert();

    const hasTrend = this.itemWithoutTrendItems.some((item: any) =>
      item.widgetchart_name && item.widgetchart_name.toLowerCase() === 'trend as widget');
    if (hasTrend) {
      // Defer setting output_details until getWithTrendData completes so charts
      // never flash a blank intermediate state between the two API calls.
      // The loader stays active throughout both calls.
      this.getWithTrendData(this.itemWithoutTrendItems);
    } else {
      this.output_details = {
        pageData: this.pageData,
        widgetData: this.itemWithoutTrendItems
      };
      this._configService.output_details = this.output_details;
      this._loaderService.hideLoader();
    }
    this._isAskMeGlobalDefaultForced = false;
} else {
    this.IsPPTDownloadClicked = false;
  }

  }

  getWithTrendData(trendItemWidgets: any): void {
      this._loaderService.showLoader();
      const brandSortMap = new Map<string, number>(
        (this._configService.brandSortId || []).map((item: any) => [item.name, item.sortId])
      );
      this.subscriptions.add(this._configService.getOutPutData(
        this._configService.finalLeftPanelSubmitObject.previewData,
        this._configService.getDropdownValues()?.clientName,
        this._configService.getDropdownValues()?.studyName,
        this._configService.finalLeftPanelSubmitObject.significance,
        this._configService.finalLeftPanelSubmitObject.isFilteringActive,
        this._configService.finalLeftPanelSubmitObject.DefaultConfidenceLevel,
        this._configService.finalLeftPanelSubmitObject.isTotalBase,
        this._configService.finalLeftPanelSubmitObject.selectedWeight,
        this._configService.finalLeftPanelSubmitObject.weightColumnName,
        this._configService.finalLeftPanelSubmitObject.isBoostFactor,
        this._configService.finalLeftPanelSubmitObject.SignificanceVsReference,
        this._configService.finalLeftPanelSubmitObject.columnLength,
        this._configService.finalLeftPanelSubmitObject.dataArray,
        this._configService.finalLeftPanelSubmitObject.isBrandAnalysis,
        this._configService.finalLeftPanelSubmitObject.isAggregatedData,
        this._configService.finalLeftPanelSubmitObject.isSemiAggregatedData,
        this._configService.finalLeftPanelSubmitObject.isRespondentLevel,
        this._configService.finalLeftPanelSubmitObject.aggregatedVariables,
        this._configService.finalLeftPanelSubmitObject.istimePeriodWave,
        this._configService.finalLeftPanelSubmitObject.widegtconfigdetails,
        this._configService.finalLeftPanelSubmitObject.indexVsBrandReference,
        this._configService.finalLeftPanelSubmitObject.significanceVsBrandReference,
        true,
        this._configService.widgetPageData,
        trendItemWidgets,
        this._configService.finalLeftPanelInputSelectedObject.page,
        false, // isSampleSizeCall
        this._configService.finalLeftPanelSubmitObject.customBaseMetric, // customBaseMetric
        this._configService.multiCohort
      ).subscribe(
        (result) => {
          if (result.Data != null && result.Data != undefined && result.Data != "") {
            let opData = JSON.parse(result.Data);

            opData.forEach((d: any) => {
              if (d.Level1ColChild?.startsWith('Time Period|')) {
                d.Level1ColChild = d.Level1ColChild.replace('Time Period|', '');
              }
            });

            // Find the reference brand's data for each metric
            let referenceDataMap: any = {};
            let baseselected = this._configService.getDropdownValues()?.baseType;
            let referenceBrand = this._configService.getDropdownValues()?.selectedIndex;

            opData.forEach((item: any) => {
              if (item.colChild && item.colChild.includes(referenceBrand)) {
                let key = "";
                if (item.isCustomGroup || item.isCustomCalculation) {
                  key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
                } else {
                  key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
                }

                if (this._configService.weightSelected === "Unweighted") {
                  referenceDataMap[key] = baseselected.toLowerCase() !== "total base"
                    ? item.answerUnweightedShare
                    : item.totalUnweightedShare;
                } else {
                  referenceDataMap[key] = baseselected.toLowerCase() !== "total base"
                    ? item.answerWeightedShare
                    : item.totalWeightedShare;
                }
              }
            });

            // Add NA for null or 0 values
            Object.keys(referenceDataMap).forEach(key => {
              if (referenceDataMap[key] === null || referenceDataMap[key] === 0) {
                referenceDataMap[key] = "NA";
              }
            });

            // Map data with index calculations
            let newArr = opData.map((item: any) => {
              let key = "";
              if (item.isCustomGroup || item.isCustomCalculation) {
                key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
              } else {
                key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
              }

              const referenceValue = referenceDataMap[key];

              if (referenceValue !== undefined) {
                if (this._configService.weightSelected === "Weighted" ||
                  this._configService.weightSelected == "Weight 1" ||
                  this._configService.weightSelected == "weightB") {
                  return {
                    ...item,
                    totalWeightedShareIndex: referenceValue === "NA"
                      ? null
                      : baseselected.toLowerCase() === "total base"
                        ? (item.totalWeightedShare / referenceValue) * 100
                        : item.totalWeightedShare,
                    answerWeightedShareIndex: referenceValue === "NA"
                      ? null
                      : baseselected.toLowerCase() !== "total base"
                        ? (item.answerWeightedShare / referenceValue) * 100
                        : item.answerWeightedShare,
                    ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
                  };
                } else if (this._configService.weightSelected === "Unweighted") {
                  return {
                    ...item,
                    totalWeightedShareIndex: referenceValue === "NA"
                      ? null
                      : baseselected.toLowerCase() === "total base"
                        ? (item.totalUnweightedShare / referenceValue) * 100
                        : item.totalUnweightedShare,
                    answerWeightedShareIndex: referenceValue === "NA"
                      ? null
                      : baseselected.toLowerCase() !== "total base"
                        ? (item.answerUnweightedShare / referenceValue) * 100
                        : item.answerUnweightedShare,
                    ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
                  };
                }
              }
              return item;
            });

            this._configService.trendOutputDbCallData = opData;

            // For Audience Snapshot, the API returns an extra "index reference" row (matched via
            // referenceBrand/colChild) used only to calculate the index â€” exclude it from the trend
            // chart's data unless the user also explicitly selected that audience for display.
            const isAudienceSnapshotTrend = this._configService.selectedcompareacrossOption === 'Audience Snapshot';
            const audienceRefColChildTrend: string = isAudienceSnapshotTrend
              ? (newArr.find((item: any) => item.colChild && referenceBrand && item.colChild.includes(referenceBrand))?.colChild ?? '')
              : '';
            const nonEmptyAudienceTrend = (this.selectedAudience || []).filter((val: string) => val?.trim() !== '');
            const referenceAlsoSelectedForDisplayTrend = !!audienceRefColChildTrend && nonEmptyAudienceTrend.includes(referenceBrand);

            this.itemWithoutTrendItems.map((item: any) => {
                if (item.widgetchart_name && item.widgetchart_name.toLowerCase() === 'trend as widget'
                    && Array.isArray(item.metric) && item.metric.length > 0)
                {

                  let widgetData = newArr.filter((x: any) => x.widgetChartType
                    && x.widgetChartType.toLowerCase() === 'trend as widget'
                    && x.widgetName == item.widget_name
                    && !(isAudienceSnapshotTrend && !referenceAlsoSelectedForDisplayTrend
                        && audienceRefColChildTrend && x.colChild === audienceRefColChildTrend));

                const metricValueCount = item.metric?.[0]?.metric_value?.length ?? 0;
                item.metric.forEach((metric: any) => {
                  metric.metric_value.forEach((mv: any) => {
                    let opDataMetric = widgetData.filter((d: any) =>
                      d.rowChild === mv.option ||
                      (d.rowChild && d.rowChild.includes('|') && d.rowChild.substring(d.rowChild.indexOf('|') + 1) === mv.option)
                    );
                    opDataMetric = opDataMetric.map((d: any) => {
                      const isTotalBase = this._configService.getDropdownValues()?.baseType?.toLowerCase() === 'total base';
                      return {
                        ...d,
                        data: this._configService.weightToggle(
                          this._configService.getDropdownValues()?.baseType,
                          this._configService.weightSelected,
                          d
                        ),
                        data2: this._configService.weightToggleIndex(
                          this._configService.getDropdownValues()?.baseType,
                          this._configService.weightSelected,
                          d
                        ),
                        lvl1Child: d.Level1ColChild,
                        colChild: (this.shouldUseMetricAsSeriesLabel(metricValueCount)
                          && !this._configService.selectedcompareacrossOption.includes('Multiple Brands'))
                          ? null
                          : this.resolveColChild(d),
                        rowChild: d.rowChild,
                        baseValueforLSorIs: isTotalBase
                          ? d.totalUnweightedBase
                          : d.answerUnweightedBase,
                      };
                    });

                    if (opDataMetric) {
                      // Sort by brand order to keep legend consistent with non-trend widgets
                      if (brandSortMap.size > 0) {
                        opDataMetric = opDataMetric.slice().sort((a: any, b: any) => {
                          const colA = this.resolveColChild(a);
                          const colB = this.resolveColChild(b);
                          const sortIdA = brandSortMap.get((colA || '').split('|')[1]) ?? Infinity;
                          const sortIdB = brandSortMap.get((colB || '').split('|')[1]) ?? Infinity;
                          return sortIdA - sortIdB;
                        });
                      }
                      mv.data = opDataMetric;
                      this._configService.sortTrendTimeporiodData(mv.data);
                    }
                  });
                });

                    return {
                    ...item,
                    widgetchart_name: 'Line Chart',
                    metric: [
                      {
                        ...item.metric[0],
                        metric_value: [item.metric[0].metric_value]
                      },
                      ...item.metric.slice(1)
                    ]
                  };
                }
                return item;
              });

            this.trendDataResult = this.itemWithoutTrendItems;

            // Now that trend data is populated, set output_details for the first time.
            // This ensures charts render once with complete data (no blank intermediate state).
            this.output_details = {
              pageData: this.pageData,
              widgetData: this.itemWithoutTrendItems
            };
            this._configService.output_details = this.output_details;
 if (typeof window !== undefined) {
        (window as any)['trendData'] = this.trendDataResult;
      }
this._configService.allPageOutputData=this.trendDataResult;
            // // Process trend data after promises resolve
            //  const resolvedWidgetData = await Promise.all(
            //     widgetDataPromises.map(async (w: any) => {
            //       if (w._pendingTrendData) {
            //         try {
            //           w.metric[0].metric_value = await w._pendingTrendData;
            //           delete w._pendingTrendData;
            //         } catch (error) {
            //           console.error('Error resolving trend data:', error);
            //         }
            //       }
            //       return w;
            //     })
            //   );

            // let m = _.cloneDeep(
            //   this._configService.itemWithTrendData[0].find(
            //     (d: any) => d.widgetchart_name == 'Trend as Widget'
            //   )
            // );

            // if (m) {
            //   m.widgetchart_name = 'Line Chart';

            //   m.metric.forEach((metric: any) => {
            //     metric.metric_value.forEach((mv: any) => {
            //       let opDataMetric = newArr;
            //       opDataMetric = opDataMetric.map((d: any) => {
            //         return {
            //           ...d,
            //           data: this._configService.weightToggle(
            //             this._configService.getDropdownValues()?.baseType,
            //             this._configService.weightSelected,
            //             d
            //           ),
            //           data2: this._configService.weightToggleIndex(
            //             this._configService.getDropdownValues()?.baseType,
            //             this._configService.weightSelected,
            //             d
            //           ),
            //           lvl1Child: d.Level1ColChild,
            //           colChild: d.colChild,
            //           rowChild: d.rowChild
            //         };
            //       });

            //       if (opDataMetric) {
            //         mv.data = opDataMetric;
            //         this._configService.sortTrendTimeporiodData(mv.data);
            //       }
            //     });
            //   });

            //   this.trendDataResult = m;
            //   // Resolve with the metric_value array
            //   //resolve(m.metric[0].metric_value);
            // } else {
            //   //reject('Trend widget not found');
            // }
          } else {
            //reject('No data returned from API');
          }
          this._loaderService.hideLoader();
        },
        (error) => {
          console.error('Error fetching trend data:', error);
          // Still show whatever data we have so the screen isn't permanently blank.
          this.output_details = {
            pageData: this.pageData,
            widgetData: this.itemWithoutTrendItems
          };
          this._configService.output_details = this.output_details;
          this._loaderService.hideLoader();
          //reject(error);
        }
      ));
}

 async getTrendData(item: any): Promise<any> {
      this._loaderService.showLoader();
  return new Promise((resolve, reject) => {
    this._configService.getOutPutData(
      this._configService.finalLeftPanelSubmitObject.previewData,
      this._configService.getDropdownValues()?.clientName,
      this._configService.getDropdownValues()?.studyName,
      this._configService.finalLeftPanelSubmitObject.significance,
      this._configService.finalLeftPanelSubmitObject.isFilteringActive,
      this._configService.finalLeftPanelSubmitObject.DefaultConfidenceLevel,
      this._configService.finalLeftPanelSubmitObject.isTotalBase,
      this._configService.finalLeftPanelSubmitObject.selectedWeight,
      this._configService.finalLeftPanelSubmitObject.weightColumnName,
      this._configService.finalLeftPanelSubmitObject.isBoostFactor,
      this._configService.finalLeftPanelSubmitObject.SignificanceVsReference,
      this._configService.finalLeftPanelSubmitObject.columnLength,
      this._configService.finalLeftPanelSubmitObject.dataArray,
      this._configService.finalLeftPanelSubmitObject.isBrandAnalysis,
      this._configService.finalLeftPanelSubmitObject.isAggregatedData,
      this._configService.finalLeftPanelSubmitObject.isSemiAggregatedData,
      this._configService.finalLeftPanelSubmitObject.isRespondentLevel,
      this._configService.finalLeftPanelSubmitObject.aggregatedVariables,
      this._configService.finalLeftPanelSubmitObject.istimePeriodWave,
      this._configService.finalLeftPanelSubmitObject.widegtconfigdetails,
      this._configService.finalLeftPanelSubmitObject.indexVsBrandReference,
      this._configService.finalLeftPanelSubmitObject.significanceVsBrandReference,
      true,
      this._configService.widgetPageData,
      this.widgetData,
      this._configService.finalLeftPanelInputSelectedObject.page,
      false, // isSampleSizeCall
      this._configService.finalLeftPanelSubmitObject.customBaseMetric,
      this._configService.multiCohort
    ).subscribe(
      (result) => {
        if (result.Data != null && result.Data != undefined && result.Data != "") {
          let opData = JSON.parse(result.Data);

          opData.forEach((d: any) => {
            if (d.Level1ColChild?.startsWith('Time Period|')) {
              d.Level1ColChild = d.Level1ColChild.replace('Time Period|', '');
            }
          });

          // Find the reference brand's data for each metric
          let referenceDataMap: any = {};
          let baseselected = this._configService.getDropdownValues()?.baseType;
          let referenceBrand = this._configService.getDropdownValues()?.selectedIndex;

          opData.forEach((item: any) => {
            if (item.colChild.includes(referenceBrand)) {
              let key = "";
              if (item.isCustomGroup || item.isCustomCalculation) {
                key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
              } else {
                key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
              }

              if (this._configService.weightSelected === "Unweighted") {
                referenceDataMap[key] = baseselected.toLowerCase() !== "total base"
                  ? item.answerUnweightedShare
                  : item.totalUnweightedShare;
              } else {
                referenceDataMap[key] = baseselected.toLowerCase() !== "total base"
                  ? item.answerWeightedShare
                  : item.totalWeightedShare;
              }
            }
          });

          // Add NA for null or 0 values
          Object.keys(referenceDataMap).forEach(key => {
            if (referenceDataMap[key] === null || referenceDataMap[key] === 0) {
              referenceDataMap[key] = "NA";
            }
          });

          // Map data with index calculations
          let newArr = opData.map((item: any) => {
            let key = "";
            if (item.isCustomGroup || item.isCustomCalculation) {
              key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
            } else {
              key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
            }

            const referenceValue = referenceDataMap[key];

            if (referenceValue !== undefined) {
              if (this._configService.weightSelected === "Weighted" ||
                this._configService.weightSelected == "Weight 1" ||
                this._configService.weightSelected == "weightB") {
                return {
                  ...item,
                  totalWeightedShareIndex: referenceValue === "NA"
                    ? null
                    : baseselected.toLowerCase() === "total base"
                      ? (item.totalWeightedShare / referenceValue) * 100
                      : item.totalWeightedShare,
                  answerWeightedShareIndex: referenceValue === "NA"
                    ? null
                    : baseselected.toLowerCase() !== "total base"
                      ? (item.answerWeightedShare / referenceValue) * 100
                      : item.answerWeightedShare,
                  ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
                };
              } else if (this._configService.weightSelected === "Unweighted") {
                return {
                  ...item,
                  totalWeightedShareIndex: referenceValue === "NA"
                    ? null
                    : baseselected.toLowerCase() === "total base"
                      ? (item.totalUnweightedShare / referenceValue) * 100
                      : item.totalUnweightedShare,
                  answerWeightedShareIndex: referenceValue === "NA"
                    ? null
                    : baseselected.toLowerCase() !== "total base"
                      ? (item.answerUnweightedShare / referenceValue) * 100
                      : item.answerUnweightedShare,
                  ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
                };
              }
            }
            return item;
          });

          this._configService.trendOutputDbCallData = opData;

          let m = _.cloneDeep(
            this._configService.itemWithTrendData[0].find(
              (d: any) => d.widgetchart_name == 'Trend as Widget'
            )
          );

          if (m) {
            m.widgetchart_name = 'Line Chart';

            m.metric.forEach((metric: any) => {
              metric.metric_value.forEach((mv: any) => {
                let opDataMetric = newArr;
                opDataMetric = opDataMetric.map((d: any) => {
                  return {
                    ...d,
                    data: this._configService.weightToggle(
                      this._configService.getDropdownValues()?.baseType,
                      this._configService.weightSelected,
                      d
                    ),
                    data2: this._configService.weightToggleIndex(
                      this._configService.getDropdownValues()?.baseType,
                      this._configService.weightSelected,
                      d
                    ),
                    lvl1Child: d.Level1ColChild,
                    colChild: d.colChild,
                    rowChild: d.rowChild
                  };
                });

                if (opDataMetric) {
                  mv.data = opDataMetric;
                  this._configService.sortTrendTimeporiodData(mv.data);
                }
              });
            });

            this.trendDataResult = m;
            // Resolve with the metric_value array
            resolve(m.metric[0].metric_value);
          } else {
            reject('Trend widget not found');
          }
        } else {
          reject('No data returned from API');
        }
        this._loaderService.hideLoader();
      },
      (error) => {
        console.error('Error fetching trend data:', error);
        this._loaderService.hideLoader();
        reject(error);
      }
    );
  });

}
  afterSubmitforSampleSize() {
    this.outputData = this._configService.standardSnapOutputData;
    const isTotalBase = this.baseselected.toLowerCase() === 'total base';
    const brandSortMap = new Map<string, number>(
      (this._configService.brandSortId || []).map((item: any) => [item.name, item.sortId])
    );
    if (
      this._configService.selectedcompareacrossOption == 'Multiple Brands' ||
      this._configService.selectedcompareacrossOption == 'Multiple Markets' ||
      this._configService.selectedcompareacrossOption == 'Audience Snapshot'
    ) {
      this._configService.standardSnapOutputData.sort((a: any, b: any) => {
        const sortIdA = brandSortMap.get(a.colChild.split('|')[1]) ?? Infinity;
        const sortIdB = brandSortMap.get(b.colChild.split('|')[1]) ?? Infinity;
        return sortIdA - sortIdB;
      });
    }

    // Adding this code to remove duplicates
    const _dedupSrc_ss = this._configService.standardSnapOutputData;
    if (_dedupSrc_ss !== this._cachedDedupSourceRef) {
      this.outputData = Array.from(
        new Set(
          this.outputData
            .map((item: any) => {
              try {
                return JSON.stringify(item);
              } catch (err) {
                return null; // Return a placeholder for problematic items
              }
            })
            .filter((item: any) => item !== null) // Remove null placeholders
        )
      )
        .map((item: any) => {
          try {
            return JSON.parse(item);
          } catch (err) {
            return null; // Handle any parsing errors
          }
        })
        .filter((item) => item !== null); // Remove null placeholders again
      this._cachedDedupSourceRef = _dedupSrc_ss;
      this._cachedDedupOutput = this.outputData;
    } else {
      this.outputData = this._cachedDedupOutput!;
    }
    let arr: any[] = [];

    let finalWidgetData = this.getConfiguredWidgetsWithDataState();
    this.items = structuredClone(finalWidgetData);

    if (this._configService.selectedcompareacrossOption.includes('Multiple') || 
        this._configService.selectedcompareacrossOption == 'Audience Snapshot') {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);

              const rowByChild_ss = new Map<string, any[]>();
              this.outputData.forEach((row: any) => {
                if (row.widgetName !== item.widget_name) {
                    return;
                  }
                const key = row.rowChild;
                if (!rowByChild_ss.has(key)) rowByChild_ss.set(key, []);
                rowByChild_ss.get(key)!.push(row);
              });

              metricsAvailable.forEach((metric: any) => {
              let outputRow: any[] = (rowByChild_ss.get(metric.option) ?? []).filter(
                (row: any) =>
                  this._configService.isStaticTimeFrame ||
                  (this._configService.selectedTPforNonTrendView ?? '') ===
                    (row.Level1ColChild ?? '')
              );
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));

                if (
                  this._configService.selectedcompareacrossOption ==
                  'Multiple Brands'
                ) {
                  outputRow.sort((a: any, b: any) => {
                    const sortIdA = brandSortMap.get(a.colChild.split('|')[1]) ?? Infinity;
                    const sortIdB = brandSortMap.get(b.colChild.split('|')[1]) ?? Infinity;
                    return sortIdA - sortIdB;
                  });
                }

                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
  totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });

                if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                  metric.data = this._configService.sortTrendTimeporiodData(
                    metric.data
                  );
                }
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              let result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (item.widgetchart_name != 'Table') {
                let maxmetriclimit = JSON.parse(
                  item?.customizationProperties
                )?.maxMetricLimit;
                if (maxmetriclimit != undefined) {
                  result = result.slice(0, maxmetriclimit);
                }
              }

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
   totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                      metricsAvailable[index].data =
                        this._configService.sortTrendTimeporiodData(
                          metricsAvailable[index].data
                        );
                    }
                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
    } else {
      if (this.items) {
        this.items.forEach((item: any) => {
          item.metric.forEach((itemLev1: any) => {
            let metricsAvailable = JSON.parse(itemLev1.metric_value[0] || '[]');

            if (!Array.isArray(metricsAvailable)) {
              metricsAvailable = [];
            }
            metricsAvailable = this.mergeAdditionalKpiIntoMetrics(metricsAvailable, item);
            if (itemLev1.metric_group == '' && metricsAvailable.length > 0) {
              let allMetricsNull = true;
              // let x:any[]=[]
              // x=[...this.outputData,...this.outputData];

              let metrics = metricsAvailable.map(
                (metric: any) => metric.option
              );

              let result = this.checkMetrics(metrics);

              metricsAvailable.forEach((metric: any) => {
                let outputRow: any[] = [];
                this.outputData.forEach((row: any) => {

                if (
                  row.rowChild == metric.option &&
                  item.widget_name === row.widgetName &&
                  (this._configService.isStaticTimeFrame ||
                    (this._configService.selectedTPforNonTrendView ?? '') ===
                      (row.Level1ColChild ?? ''))
                ) {
                    //&& item.widget_name == row.widgetName
                    outputRow.push(row);
                    return true;
                  }
                  return false;
                });
                //const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild == metric.metricName && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));

                metric.option = this.handlemetricname(metric.option, result);

                metric.data = [];
                outputRow.forEach((row: any) => {
                  metric.data.push({
                    // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                    data: this._configService.weightToggle(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    // data: row.totalWeightedShare,
                    data2: this._configService.weightToggleIndex(
                      this.baseselected,
                      this._configService.weightSelected,
                      row
                    ),
                    lvl1Child: row.Level1ColChild,
                    colChild: row.colChild,
                    rowChild: row.rowChild,
                    isMultiPunch: row.isMultiPunch,
                    isShowDerived : row.isShowDerived,
                    totalUnweightedBase: row.totalUnweightedBase,
                    totalUnweightedShare: row.totalUnweightedShare,
                    totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                    totalWeightedShare: row.totalWeightedShare,
                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                    answerUnweightedBase: row.answerUnweightedBase,
                    answerUnweightedShare: row.answerUnweightedShare,
                    answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                    answerWeightedShare: row.answerWeightedShare,
                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                    changeVsPY_Answer: row.changeVsPY_Answer,
                    changeVsPY_Total: row.changeVsPY_Total,
                    Level1ColResponseCode: row.Level1ColResponseCode,
                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                    CalculationType: row.CalculationType,
                    CalculationTypeIndex: row.CalculationTypeIndex,
                    baseValueforLSorIs:
                      isTotalBase
                        ? row.totalUnweightedBase
                        : row.answerUnweightedBase,
                    // baseValueforLSorIs: row.totalUnweightedBase,
                    changeVsPY:
                      isTotalBase
                        ? row.changeVsPY_Total
                        : row.changeVsPY_Answer,
                    // changeVsPY: row.changeVsPY_Total,
                    Significance_Value:
                      isTotalBase
                        ? row.Significance_Total
                        : row.Significance_Answer,
                    CurrentNumeratorUnWeighted_Total:
                      row.CurrentNumeratorUnWeighted_Total,
                    totalWeightedNumerator:
                      row.totalWeightedNumerator,
                    CurrentNumeratorUnWeighted_Answer:
                      row.CurrentNumeratorUnWeighted_Answer,
                    answerWeightedNumerator:
                      row.answerWeightedNumerator,

                    // Significance_Value: row.Significance_Total
                  });

                  if (
                    row.totalWeightedShare !== null ||
                    row.totalUnweightedShare !== null
                  ) {
                    allMetricsNull = false;
                  }
                });

                if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                  metric.data = this._configService.sortTrendTimeporiodData(
                    metric.data
                  );
                }
                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }

                // if (metric.data !== null) {
                //   allMetricsNull = false;
                // }
              });
              if (allMetricsNull) {
                item.metric = [];
                item.noData = true;
                item.noDataAvailble = true;
              } else {
                item.noDataAvailble = false;
              }
            } else if (
              itemLev1.metric_group != '' &&
              metricsAvailable.length == 0
            ) {
              let allMetricsNull = true;
              // let x: any[] = [];
              // x = [...this.outputData, ...this.outputData];
              const metrics = this.outputData.filter(
                (row: any) => item.widget_name == row.widgetName
              );

              const groupedByRowChild = metrics.reduce((acc: any, obj: any) => {
                const key = obj.rowChild || 'undefined';
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});

              const result = Object.keys(groupedByRowChild).map((key) => ({
                name: key,
                value: groupedByRowChild[key],
              }));

              if (result.length > 0) {
                result.forEach((metric: any, index: number) => {
                  metricsAvailable.push({
                    is_brandanalysis: 0,
                    metricName: this.handlemetricname(metric.name, 1),
                    selectorder: index + 1,
                    data: [],
                  });

                  metric.value.forEach((row: any) => {
                    metricsAvailable[index].data.push({
                      // data: this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare : row.totalWeightedShare,
                      data: this._configService.weightToggle(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      // data: row.totalWeightedShare,
                      data2: this._configService.weightToggleIndex(
                        this.baseselected,
                        this._configService.weightSelected,
                        row
                      ),
                      lvl1Child: row.Level1ColChild,
                      colChild: row.colChild,
                      rowChild: row.rowChild,
                      isMultiPunch: row.isMultiPunch,
                      isShowDerived : row.isShowDerived,
                      totalUnweightedBase: row.totalUnweightedBase,
                      totalUnweightedShare: row.totalUnweightedShare,
                      totalWeightedBase: this._configService.getWeightedBase('total base', this.weight, row),
                      totalWeightedShare: row.totalWeightedShare,
                      totalWeightedShareIndex: row.totalWeightedShareIndex,
                      answerUnweightedBase: row.answerUnweightedBase,
                      answerUnweightedShare: row.answerUnweightedShare,
                      answerWeightedBase: this._configService.getWeightedBase('answer base', this.weight, row),
                      answerWeightedShare: row.answerWeightedShare,
                      answerWeightedShareIndex: row.answerWeightedShareIndex,
                      changeVsPY_Answer: row.changeVsPY_Answer,
                      changeVsPY_Total: row.changeVsPY_Total,
                      Level1ColResponseCode: row.Level1ColResponseCode,
                      Level1NestColVariableCode: row.Level1NestColVariableCode,
                      CalculationType: row.CalculationType,
                      CalculationTypeIndex: row.CalculationTypeIndex,
                      baseValueforLSorIs:
                        isTotalBase
                          ? row.totalUnweightedBase
                          : row.answerUnweightedBase,
                      // baseValueforLSorIs: row.totalUnweightedBase,
                      changeVsPY:
                        isTotalBase
                          ? row.changeVsPY_Total
                          : row.changeVsPY_Answer,
                      // changeVsPY: row.changeVsPY_Total,
                      Significance_Value:
                        isTotalBase
                          ? row.Significance_Total
                          : row.Significance_Answer,
                      CurrentNumeratorUnWeighted_Total:
                        row.CurrentNumeratorUnWeighted_Total,
                      totalWeightedNumerator:
                        row.totalWeightedNumerator,
                      CurrentNumeratorUnWeighted_Answer:
                        row.CurrentNumeratorUnWeighted_Answer,
                      answerWeightedNumerator:
                        row.answerWeightedNumerator,

                      // Significance_Value: row.Significance_Total
                    });

                    if (this.y1.LeftPanelSelectedTimePeriod.length > 0) {
                      metricsAvailable[index].data =
                        this._configService.sortTrendTimeporiodData(
                          metricsAvailable[index].data
                        );
                    }
                    // if (this.baseselected.toLowerCase() != "total base" ? row.answerWeightedShare != null : row.totalWeightedShare !== null) {
                    //   allMetricsNull = false;
                    // }
                    if (
                      row.totalWeightedShare !== null ||
                      row.totalUnweightedShare !== null
                    ) {
                      allMetricsNull = false;
                    }
                  });
                });

                if (allMetricsNull) {
                  item.metric = [];
                  item.noData = true;
                  item.noDataAvailble = true;
                } else {
                  item.noDataAvailble = false;
                }
              }
            }
            itemLev1.metric_value = metricsAvailable;
          });
          if (
            item.noDataAvailble != null &&
            item.noDataAvailble != undefined &&
            item.noDataAvailble == false
          ) {
            item.widgetNotConfigured = item.metric.length > 0 ? false : true;
          } else {
            if (
              item.noDataAvailble == null ||
              item.noDataAvailble == undefined
            ) {
              item.widgetNotConfigured = item.metric.length > 0 ? false : true;
            } else {
              item.widgetNotConfigured = false;
            }
          }
        });
      }
      arr.push(this.items);
    }

    this._configService.itemWithTrendData = arr;
    this.prepareSampleSizePopup();
    this._loaderService.hideLoader();
  }

  private mergeAdditionalKpiIntoMetrics(metricsAvailable: any[], widget: any): any[] {
    const extra = widget?.additionalKPI;
    if (!Array.isArray(extra) || extra.length === 0) {
      return metricsAvailable;
    }
    const kpiBlock = extra.find((k: any) => {
      const opt = k?.kpi_option;
      if (opt == null) {
        return false;
      }
      // Align with chart-output bindCustomization / save payload
      return String(opt).replace(' : ', '') === 'Additional KPI';
    });

    if (!kpiBlock?.kpi_value?.length) {
      return metricsAvailable;
    }

    let kpiList: any[] = [];
    try {
      const raw = kpiBlock.kpi_value[0];
      kpiList =
        typeof raw === 'string'
          ? JSON.parse(raw || '[]')
          : Array.isArray(raw)
            ? raw
            : [];
    } catch {
      return metricsAvailable;
    }

    if (!Array.isArray(kpiList) || kpiList.length === 0) {
      return metricsAvailable;
    }

    const merged = [...metricsAvailable];
    let maxOrder = merged.reduce(
      (m, x) => Math.max(m, Number(x?.selectOrder) || 0),
      0
    );
    for (const kpi of kpiList) {
      const opt = kpi?.option;
      if (opt == null || opt === '') {
        continue;
      }
      const existingIndex = merged.findIndex((m) => m.option === opt);
      if (existingIndex !== -1) {
        // Already in the standard metrics list â€” mark it as the KPI overlay
        merged[existingIndex] = { ...merged[existingIndex], isAdditionalKPI: true };
        continue;
      }
          merged.push({
        ...kpi,
        selectOrder:
         
             ++maxOrder,
        data: Array.isArray(kpi.data) ? kpi.data : [],
        isAdditionalKPI: true,   // â† ADD THIS
      });
      
    }
    return merged;
  }
 

  checkBrands(metrics: string[]): number {
    let hasDelimiter = metrics.some((metric) => metric != null && metric.includes('|'));
    if (!hasDelimiter) return 0;

    let firstParts = metrics.filter((metric) => metric != null).map((metric) => metric.split('|')[0]);
    let uniqueFirstParts = Array.from(new Set(firstParts));

    if (uniqueFirstParts.length === 1) {
      return 1;
    } else if (
      uniqueFirstParts.every((part) => part[0] === uniqueFirstParts[0][0])
    ) {
      return 2;
    } else {
      return 3;
    }
  }

  checkMetrics(metrics: string[]): number {
    let hasDelimiter = metrics.some((metric) => metric.includes('|'));
    if (!hasDelimiter) return 0;

    let firstParts = metrics.map((metric) => metric.split('|')[0]);
    let uniqueFirstParts = Array.from(new Set(firstParts));

    if (uniqueFirstParts.length === 1) {
      return 1;
    } else if (
      uniqueFirstParts.every((part) => part[0] === uniqueFirstParts[0][0])
    ) {
      return 2;
    } else {
      return 3;
    }
  }
  handlemetricname(metricName: any, type: number = 0) {
    if (type == 0) return metricName; // No delimiter
    else if (type == 1) {
      const parts = metricName.split('|'); // for showing only the last part (without delimiter)
      
      // sometimes we can have metric name with multiple delimiters like:
      // product level consideration | consumer mobile | t2b
      // in such cases the option name would be `consumer mobile | t2b` instead of just t2b.
      return parts.slice(1).join('|');  // everything after first segment
    }

    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }

  handleBrandName(metricName: any, type: number = 0) {
    if (type == 0) return metricName; // No delimiter
    else if (type == 1) {
      const parts = metricName.split('|'); // for showing only the last part (without delimiter)
      return parts[1];
    }

    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }

  private shouldUseMetricAsSeriesLabel(metricCount: number): boolean {
    return metricCount > 1;
  }

  private resolveColChild(row: any, resultBrands: number = 0): string | null {
    if (row.colChild) {
      return this.handleBrandName(row.colChild, resultBrands);
    }
    if (this._configService.selectedcompareacrossOption !== 'Multiple Brands') {
      return row.colChild;
    }
    const match = row.rowVariableCode?.match(/_(\d+)$/);
    if (!match) {
      return row.colChild;
    }
    const brandIndex = parseInt(match[1], 10) - 1;
    const sortedBrands = [...(this._configService.brandSortId || [])].sort(
      (a: any, b: any) => a.sortId - b.sortId
    );
    const brandName = sortedBrands[brandIndex]?.name;
    if (!brandName) {
      return row.colChild;
    }
    return this.handleBrandName(`Brands|${brandName}`, resultBrands);
  }
  @ViewChild('leftPanel', { static: true }) leftPanel!: ElementRef;
  increaseLeftpanelWidth(event: any) {
    const parentWidth = this.leftPanel.nativeElement.parentElement.offsetWidth; // Get parent width
    const currentWidth = this.leftPanel.nativeElement.offsetWidth; // Get current width in pixels
    const currentPercentage = (currentWidth / parentWidth) * 100; // Convert to percentage      if (event?.level == 3) {
    let newWidth = 0;
    if (event?.isReset) {
      this.resetLeftpanelWidth();
    } else {
      if (event?.isIncrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (80 / 100) * parentWidth; // Calculate 80% of parent
          this.renderer.setStyle(
            this.leftPanel.nativeElement,
            'width',
            `${newWidth}px`
          );
        }
        if (event?.level == 4) {
          newWidth = (100 / 100) * parentWidth; // Calculate 90% of parent
          this.renderer.setStyle(
            this.leftPanel.nativeElement,
            'width',
            `${newWidth}px`
          );
        }
      }
      if (event?.isDecrease && event?.level >= 3) {
        if (event?.level == 3) {
          newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
          this.renderer.setStyle(
            this.leftPanel.nativeElement,
            'width',
            `${newWidth}px`
          );
        }
        if (event?.level == 4) {
          newWidth = (80 / 100) * parentWidth; // Calculate 90% of parent
          this.renderer.setStyle(
            this.leftPanel.nativeElement,
            'width',
            `${newWidth}px`
          );
        }
      }
    }
  }

  resetLeftpanelWidth() {
    if (!this.isCreateCustomGroup) {
      const parentWidth =
        this.leftPanel.nativeElement.parentElement.offsetWidth; // Get parent width
      // const currentWidth = this.leftPanel.nativeElement.offsetWidth; // Get current width in pixels
      let newWidth = 0;
      newWidth = (70 / 100) * parentWidth; // Calculate 80% of parent
      this.renderer.setStyle(
        this.leftPanel.nativeElement,
        'width',
        `${newWidth}px`
      );
    }
  }

  sigTypeDropdown = false;
  onSigType(event: Event) {
    this.sigTypeDropdown = !this.sigTypeDropdown;
    event.stopPropagation();
  }
  ShowOutput() {
    this.pageDetailsForSectionSubsection();
    this._loaderService.hideLoader();
    this.showLeftPanel = false;
    const outputViewDiv = document.querySelector('.output-view');
    if (outputViewDiv) {
      outputViewDiv?.classList.remove('DN');
    }
    //this.pageDetailsForSectionSubsection();
    // this.afterSubmit();//false trigerring
    this._loaderService.showLoader();
    // this.isSubmitClicked = true;
    this.isLoadSelection = false;
    this.showSaveSelectionButton =
      this._configService.outputSnapshotData?.saveselection != null
        ? this._configService.outputSnapshotData?.saveselection?.find(
            (m: any) => m.key == 'Save/Load'
          )?.value ?? false
        : false;
    this.y1 = this._configService.passdata;
    this.updateBaseAvailabilityForCustomPctMeanVariables();
    this.selectedBrandFromConfig = this._configService.outputSnapshotData?.selectedBrand || null;
    this.thresholdIndex = this._configService.thresholdIndex;
    this.higherIndexValue = 100 + this.thresholdIndex;
    this.lowerIndexValue = 100 - this.thresholdIndex;
    this.indexText = `Note: The indexed value greater than ${this.higherIndexValue} are denoted by green and in Red for values less than ${this.lowerIndexValue}`;

    const ti = this._configService.thresholdIndex;
    const thresholdNum = ti === null || ti === undefined ? NaN : Number(ti);
    this.is_indexing = Number.isFinite(thresholdNum) && thresholdNum > 0;
    this.is_indexingShow = this.is_indexing;

    //--------Show and hide index based on threshold index value------------------
    var ele = document.querySelector('.indexArea');
    if (this.thresholdIndex > 0) {
      if (ele) {
        // Check if the element exists
        ele.classList.remove('DN');
      }
    } else {
      ele?.classList.add('DN');
    }

    //------------------------------------------------------------

    //for sig - Populate with audience data when Audience Snapshot
    if (this._configService.selectedcompareacrossOption === 'Audience Snapshot' && this.child && this.child.variableList) {
      // Find Audience section in variableList
      const audienceSection = this.child.variableList.find((item: any) =>
        item.Level0 && item.Level0.toLowerCase() === 'audience'
      );
      
      if (audienceSection && audienceSection.Level1) {
        // Helper function to map audience data with deep copy of Level2_children
        const mapAudienceData = (level1Items: any[]) => level1Items.map((level1Item: any) => ({
          MetricOption: level1Item.Level1_value,
          Level1: 'Audience',
          Level2: level1Item.Level1_value,
          Level1_value: level1Item.Level1_value,
          Level2_children: level1Item.Level2 ? JSON.parse(JSON.stringify(level1Item.Level2)) : [],
          isSelected: false,
          hasNextLevel: level1Item.Level2 && level1Item.Level2.length > 0,
          isExpanded: false,
          calculation_type: level1Item.calc_type,
          customGroupId: level1Item.customGroupId,
          dataYearCode: level1Item.dataYearCode,
          date: level1Item.date,
          is_CustomGroup: level1Item.isCustomGrpPresent,
          is_brandanalysis: level1Item.is_brand_analysis,
          is_derived_variable: level1Item.is_derived,
          is_dimension: level1Item.is_dimension,
          is_multi_punch: level1Item.is_multi_punch,
          is_time_Period_Present: level1Item.is_time_Period_Present,
          response_code: level1Item.response_code,
          sort_id: level1Item.sort_id,
          variable_code: level1Item.data_variable_code,
          year_code: level1Item.year_code,
        }));

        // Create separate arrays for sig and index to avoid cross-contamination
        this.allSigBrands = mapAudienceData(audienceSection.Level1);
        this.allIndexBrands = mapAudienceData(audienceSection.Level1); // Separate deep copy for index
      } else {
        // Fallback to brand data
        this.allSigBrands = _.cloneDeep(this._configService.brandData);
        this.allSigBrands = _.filter(this.allSigBrands, (item: any) => item.is_snapshot != 0);
        this.allSigBrands = this.allSigBrands.map((item: any) => {
          item.isSelected = false;
          item.hasNextLevel = false;
          item.isExpanded = false;
          return item;
        });
        this.allIndexBrands = _.cloneDeep(this.allSigBrands); // Separate copy for index
      }
    } else {
      // Normal brand data for non-Audience snapshots
      this.allSigBrands = _.cloneDeep(this._configService.brandData);
      this.allSigBrands = _.filter(
        this.allSigBrands,
        (item: any) => item.is_snapshot != 0
      );
      this.allSigBrands = this.allSigBrands.map((item: any) => {
        item.isSelected = false;
        item.hasNextLevel = false;
        item.isExpanded = false;
        return item;
      });
      this.allIndexBrands = _.cloneDeep(this.allSigBrands); // Separate copy for index
    }
    
    //for custom base
    this.allCustomBaseBrands = _.cloneDeep(this._configService.brandData);
    this.allCustomBaseBrands = _.filter(
      this.allCustomBaseBrands,
      (item: any) => !item.is_derived_variable
    );
    this.allCustomBaseBrands = this.allCustomBaseBrands.map((item: any) => {
      item.isSelected = false;
      return item;
    });

    //for index
    let selectedBrandRef =
      this.output_data?.indexVsBrandReference?.[0]?.Data[0]?.Child;
    if (selectedBrandRef)
      this.displayReference = selectedBrandRef?.split('|')[1].trim();

    // Check if Audience Snapshot is selected
    if (this._configService.selectedcompareacrossOption === 'Audience Snapshot' && this.child && this.child.variableList) {
      // Find Audience section in variableList
      const audienceSection = this.child.variableList.find((item: any) =>
        item.Level0 && item.Level0.toLowerCase() === 'audience'
      );
      
      if (audienceSection && audienceSection.Level1) {
        // Use the same helper function to create deep copy
        const mapAudienceData = (level1Items: any[]) => level1Items.map((level1Item: any) => ({
          MetricOption: level1Item.Level1_value,
          Level1: 'Audience',
          Level2: level1Item.Level1_value,
          Level1_value: level1Item.Level1_value,
          Level2_children: level1Item.Level2 ? JSON.parse(JSON.stringify(level1Item.Level2)) : [],
          isSelected: false,
          hasNextLevel: level1Item.Level2 && level1Item.Level2.length > 0,
          isExpanded: false,
          calculation_type: level1Item.calc_type,
          customGroupId: level1Item.customGroupId,
          dataYearCode: level1Item.dataYearCode,
          date: level1Item.date,
          is_CustomGroup: level1Item.isCustomGrpPresent,
          is_brandanalysis: level1Item.is_brand_analysis,
          is_derived_variable: level1Item.is_derived,
          is_dimension: level1Item.is_dimension,
          is_multi_punch: level1Item.is_multi_punch,
          is_time_Period_Present: level1Item.is_time_Period_Present,
          response_code: level1Item.response_code,
          sort_id: level1Item.sort_id,
          variable_code: level1Item.data_variable_code,
          year_code: level1Item.year_code,
        }));

        // Create another separate copy for allbrands (used in index dropdown)
        this.allbrands = mapAudienceData(audienceSection.Level1);
        
        this.allbrands.unshift({
          MetricOption: 'None',
          isSelected: selectedBrandRef != 'None' ? false : true,
          hasNextLevel: false,
          isExpanded: false,
        });
      } else {
        // Fallback to brand data
        this.allbrands = _.cloneDeep(this._configService.brandData);
        this.allbrands = _.filter(this.allbrands, (item: any) => item.is_snapshot != 0);
        this.allbrands = this.allbrands.map((item: any) => {
          item.isSelected = false;
          item.hasNextLevel = false;
          item.isExpanded = false;
          return item;
        });
        this.allbrands.unshift({
          MetricOption: 'None',
          isSelected: selectedBrandRef != 'None' ? false : true,
          hasNextLevel: false,
          isExpanded: false,
        });
      }
    } else {
      // Normal brand data for non-Audience snapshots
      this.allbrands = _.cloneDeep(this._configService.brandData);
      this.allbrands = _.filter(
        this.allbrands,
        (item: any) => item.is_snapshot != 0
      );
      this.allbrands = this.allbrands.map((item: any) => {
        item.isSelected = false;
        item.hasNextLevel = false;
        item.isExpanded = false;
        return item;
      });
      this.allbrands.unshift({
        MetricOption: 'None',
        isSelected: selectedBrandRef != 'None' ? false : true,
        hasNextLevel: false,
        isExpanded: false,
      });
    }

    // For "Multiple Markets" compare, the Reference dropdowns must list ONLY the
    // markets that were selected & submitted in the left panel, not every market.
    if (this._configService.selectedcompareacrossOption === 'Multiple Markets') {
      // Derive the submitted markets from the actual output data (the same source
      // that renders the market columns). Each row's colChild is "Parent|Market",
      // so collecting every '|' segment guarantees the market name is captured
      // regardless of its position or any code-vs-display naming differences.
      const outputRows =
        this._configService.standardSnapOutputData ?? this.outputData ?? [];

      const selectedMarketNames = new Set<string>();
      (outputRows ?? []).forEach((row: any) => {
        if (row?.colChild) {
          String(row.colChild)
            .split('|')
            .forEach((segment: string) => {
              const name = segment?.trim().toLowerCase();
              if (name) selectedMarketNames.add(name);
            });
        }
      });

      if (selectedMarketNames.size > 0) {
        const filterToSelectedMarkets = (list: any[]) => {
          const filtered = (list ?? []).filter(
            (item: any) =>
              item?.MetricOption === 'None' ||
              selectedMarketNames.has(
                String(item?.MetricOption ?? '').trim().toLowerCase()
              )
          );
          // Number of actual markets matched (ignoring the "None" option).
          const matchedMarkets = filtered.filter(
            (item: any) => item?.MetricOption !== 'None'
          ).length;
          // Only apply the filter when at least one market matched, otherwise
          // keep the original list to avoid an empty dropdown.
          return matchedMarkets > 0 ? filtered : list;
        };

        this.allSigBrands = filterToSelectedMarkets(this.allSigBrands);
        this.allbrands = filterToSelectedMarkets(this.allbrands);
        this.allIndexBrands = filterToSelectedMarkets(this.allIndexBrands);
      }
    }
    //Significane-------------
    // ;
    const SigVs = this._configService.outputSnapshotData?.sig_testing_vs;
    this.significance = Array.isArray(SigVs) ? SigVs : [];
    // Find the index of the item with key "None"
    const index = this.significance.findIndex(
      (item: any) => item.key === 'Reference'
    );

    if (index !== -1) {
      // Remove the item from the array
      const Item = this.significance.splice(index, 1)[0];
      // Push it to the end of the array
      this.significance.push(Item);
    }

    this.significance = this.significance.map((item: any) => {
      if (
        item.key == this.output_data?.significance &&
        this.isSavedScenarioSelected
      ) {
        item.isSelected = true;
      } else {
        item.isSelected = false;
      }
      return item;
    });
    this.significanceVal = [];
    if (this.isSavedScenarioSelected) {
      this.significanceVal.push({
        key: 'None',
        value: true,
        isSelected: this.output_data?.significance == 'None',
      });
      this.displaySignificance = this.output_data?.significance || 'None';
      this.significanceSelectedValue = this.displaySignificance;
      this._configService.updateSignificanceValue(
        this.significanceSelectedValue
      );
    } else {
      this.significanceVal.push({ key: 'None', value: true, isSelected: true });
    }
    for (let i = 0; i < this.significance.length; i++) {
      this.significanceVal.push(this.significance[i]);
    }
    if (this.isSavedScenarioSelected) {
      this.selectedSignificance = this.significanceVal.find(
        (item: any) => item.key == this.output_data?.significance
      );
    }

    this.is_sigtesting =
      Array.isArray(this.significance) && this.significance.length > 0;

    //Confidence Level-----------------
    this.confidenceLevel =
      (this._configService.outputSnapshotData?.confidence_level).filter(
        (item: any) => item.value == true
      );
    this.configuredDefaultConfidenceLevel =
      this._configService.outputSnapshotData?.default_confidence_level ||
      this.configuredDefaultConfidenceLevel ||
      '';
    this.confidenceLevel.sort((a: any, b: any) => {
      // Extract the numerical value from the key
      const numA = parseFloat(a.key.replace('%', ''));
      const numB = parseFloat(b.key.replace('%', ''));

      return numA - numB; // Sort in ascending order
      // For descending order, use: return numB - numA;
    });
    this.confidenceLevel = this.confidenceLevel.map((item: any) => {
      item.isSelected = false;
      return item;
    });

    if (this.confidenceLevel.length > 0) {
      this.applyConfiguredDefaultConfidenceSelection();
      // Keep UI as None until significance is selected
      this.displayConfidenceLevel = this.displayConfidenceLevel || 'None';
    }

    // weights
    // this.weight=[
    //   {key:"Unweighted",isSelected:true},
    //   {key:"Weight1",isSelected:false},
    //   {key:"Weight2",isSelected:false},
    // ]
    
    this.weight = this._configService.weights;
    if (this.isSavedScenarioSelected && this.output_data?.selectedWeight) {
      // Match saved weight by key first, then by variable_code/variable_label as fallback
      const savedWeightObj = this.weight.find((w: any) => w.key === this.output_data.selectedWeight)
        || this.weight.find((w: any) => w.variable_code === this.output_data.selectedWeight)
        || this.weight.find((w: any) => w.variable_label === this.output_data.selectedWeight);
      if (savedWeightObj) {
        this.weightSelectedValue = savedWeightObj.key;
        this._configService.weightSelected = savedWeightObj.variable_code === '' ? 'Unweighted' : savedWeightObj.variable_code;
      } else {
        this.weightSelectedValue = this.output_data.selectedWeight;
        this._configService.weightSelected = this.output_data.selectedWeight;
      }
      if (this.y1) {
        this.y1.selectedWeight = this._configService.weightSelected;
      }
    } else {
      this.weightSelectedValue = this.weight[0]?.key;
      this._configService.weightSelected = this.weight[0]?.variable_label;
    }
    //

    this.selectedSigType =
      this._configService.outputSnapshotData?.significance_type;
    this.stacticText = this._configService.outputSnapshotData?.static_text;
    this.isAnswerBase = this._configService.outputSnapshotData?.is_answer_base;




    //---Code to find which all exports needs to be displayed------
    this.exportSelected =
      this._configService.outputSnapshotData?.export_download;
    for (let i = 0; i < this.exportSelected.length; i++) {
      if (this.exportSelected[i].key == 'Editable PPT') {
        this.editablePPT = true;
      }
      if (this.exportSelected[i].key == 'Excel Export') {
        this.excelExport = true;
      }
      if (this.exportSelected[i].key == 'Non-Editable PPT') {
        this.staticPPT = true;
      }
    }

    // -----------------------------------------------------------
    this.significanceTypes = [];
    for (let i = 0; i < this.selectedSigType.length; i++) {
      this.significanceTypes.push({
        id: i + 1,
        selected: false,
        name: this.selectedSigType[i].key,
        value: this.selectedSigType[i].key,
      });
    }

    let moduleAccessBasedOnRole = localStorage.getItem('role');
    if (moduleAccessBasedOnRole != null) {
      let userData = JSON.parse(atob(moduleAccessBasedOnRole));
      this._configService.userRole = userData.super_admin ? 'superadmin' : '';
    }

    this._configService.setDropdownValue(
      'userRole',
      this._configService.userRole
    );
    this.MainResult = this._configService.standardSnapOutputData;

    //Reseting the values
    const isBaseTypeReload =
      this.baseTypeSelected === 'baseType' || this.previusParameters?.isBaseType === 'baseType';
    if (
      !this.isSavedScenarioSelected &&
      Object.keys(this.innerSelection).length === 0 &&
      !isBaseTypeReload
    ) {
      this.resetValues();
    } else {
      if (Object.keys(this.innerSelection).length > 0) {
        if (this.output_data === null || this.output_data === undefined) {
          this.output_data = {};
        }
        this.output_data.DefaultConfidenceLevel =
          this.innerSelection.displayConfidenceLevel;
        this.output_data.significanceVsReference =
          this.innerSelection.significanceVsReference;
        this.output_data.indexVsBrandReference =
          this.innerSelection.indexVsBrandReference;
        this.output_data.isTotalBase = this.innerSelection.isTotalBase;
        this.y1.isTotalBase = this.innerSelection.isTotalBase;
        this.output_data.selectedWeight = this.innerSelection.selectedWeight;
        this.output_data.significanceVsBrandReference =
          this.innerSelection.significanceVsBrandReference;
        this.output_data.significance = this.innerSelection.significance;
        this.displaySignificance = this.innerSelection.significance || 'None';
        this.significanceSelectedValue = this.displaySignificance;
        this.selectedSignificance = this.significanceVal.find(
          (item: any) => item.key === this.significanceSelectedValue
        );
        this._configService.weightSelected = this.innerSelection.selectedWeight;
        this.y1.selectedWeight = this.innerSelection.selectedWeight;
        this.weightSelectedValue = this.innerSelection.weightSelectedValue;
        this.selectedSigBrand = this.innerSelection.brand;
        this.selectedReference = this.innerSelection.selectedReference;
        this.innerSelection.customBaseMetric = this.selectedCustomBaseReference;
        if (
          (this.output_data.significanceVsReference ||
            this.displaySignificance) &&
          !this._configService.isIndexSelected
        ) {
          let sigRfe =
            this.output_data.significanceVsReference ??
            this.displaySignificance;
          for (let i = 0; i < this.significanceVal.length; i++) {
            if (this.significanceVal[i].key == sigRfe) {
              this.significanceVal[i].isSelected = true;
            } else {
              this.significanceVal[i].isSelected = false;
            }
          }
          if (
            this.output_data.significanceVsReference &&
            this.innerSelection.brand
          ) {
            this.brandSelection(this.allSigBrands, this.innerSelection.brand);
          }
        }

        if (
          this._configService.isIndexSelected &&
          this.innerSelection.selectedReference
        ) {
          this.brandSelection(
            this.allSigBrands,
            this.innerSelection.selectedReference
          );
        }
      }

      this.innerSelection = {};
      // this.isSigSelected = this.output_data.indexVsBrandReference.length <= 0;
      // this.isIndexSelected = !this.isSigSelected;
   
// const mode = this.output_data?.sigIndex;
// this.isSigSelected = mode === 'sig';
// this.isIndexSelected = mode === 'index';
const mode = this.output_data?.sigIndex;

if (mode === 'sig' || mode === 'index') {
  this.isSigSelected = mode === 'sig';
  this.isIndexSelected = mode === 'index';
} else {
  // For old saves without sigIndex: significance != 'None' unambiguously means Sig mode
  const savedSig = this.output_data?.significance ?? 'None';
  const isIndexMode = savedSig === 'None' && (this.output_data?.isIndexSelected === true || this.output_data?.indexVsBrandReference?.length > 0);
  this.isIndexSelected = isIndexMode;
  this.isSigSelected = !isIndexMode;
}
this._configService.isIndexSelected = this.isIndexSelected === true;
this._configService.IndexSelected = this.isIndexSelected === true;
if (this.isIndexSelected && this.y1 &&
    (!this.y1.indexVsBrandReference || this.y1.indexVsBrandReference.length === 0) &&
    this.output_data?.indexVsBrandReference?.length) {
  this.y1.indexVsBrandReference = this.output_data.indexVsBrandReference;
}
      if (this.isSigSelected) {
        this.sigConBaseToggle = true;
        if (this.displaySignificance !== 'None') {
          const selectedConfidenceLevel = this.applyConfidenceLevelSelection(
            this.output_data?.DefaultConfidenceLevel
          );
          this.displayConfidenceLevel = selectedConfidenceLevel;
          this.y1.DefaultConfidenceLevel = selectedConfidenceLevel;
          this._configService.setDropdownValue(
            'confidenceLevel',
            selectedConfidenceLevel
          );
          this._configService.updateConfedenceValue(selectedConfidenceLevel);
        } else {
          this.confidenceLevel.forEach((item: any) => {
            item.selected = false;
            item.isSelected = false;
          });
          this.displayConfidenceLevel = 'None';
          this.confidenceLevelSelectedValue = 'None';
          this.y1.DefaultConfidenceLevel = 'None';
          this._configService.updateConfedenceValue('None');
        }

        // when you apply a saved selection which has significance selected,
        // the brand reference should be get updated in the sig ref dropdown
        const savedSigReferenceChild =
          this.output_data?.significanceVsBrandReference?.[0]?.Data?.[0]?.Child;
        if (this.displaySignificance === 'Reference' && savedSigReferenceChild) {
          const savedReferenceBrandName = savedSigReferenceChild.includes('|')
            ? savedSigReferenceChild.split('|').pop()?.trim()
            : savedSigReferenceChild;
          const matchedSigBrand = this.allSigBrands?.find(
            (option: any) => option.MetricOption === savedReferenceBrandName
          );
          if (matchedSigBrand) {
            this.selectedSigBrand = matchedSigBrand;
            this.brandSelection(this.allSigBrands, matchedSigBrand);
          }
          this.referenceBrand = savedReferenceBrandName;

          // // filter out reference brand from output data if it is not selected in main brands in left panel
          const mainSelectedBrands: string[] = this.y1?.LeftPanelSelectedBrand ?? [];
          const isReferenceOnlyBrand =
            !!savedReferenceBrandName &&
            !mainSelectedBrands.some((brand: string) => brand === savedReferenceBrandName);
          if (isReferenceOnlyBrand) {
            this._configService.standardSnapOutputData =
              this._configService.standardSnapOutputData.filter(
                (row: any) => !row.colChild?.includes(savedReferenceBrandName)
              );
          }
        }
      } else {
        this.sigConBaseToggle = false;
        // this.allbrands.find(
        //   (option: any) => option.MetricOption == this.displayReference
        // ).isSelected = true;
        const matchedOption = this.allbrands.find(
          (option: any) => option.MetricOption === this.displayReference
        );

        if (matchedOption) {
          matchedOption.isSelected = true;
        }
        this._configService.setDropdownValue(
          'selectedIndex',
          this.displayReference
        );
        if (this._configService.saveSelectionLoad &&
            this.displayReference &&
            this.displayReference !== 'None' &&
            this.y1?.indexVsBrandReference?.length) {
          this.getOutputData('reference', '', this.pageCounter).catch((error) => {
            console.error('Error in getOutputData:', error);
          });
        } else {
          this.referenceCalculation(
            this._configService.standardSnapOutputData,
            false
          );
        }
      }


      if(!this.isCustomBaseSelected){
      const fromOutput = this.output_data.isTotalBase ? 'Total Base' : 'Answer Base';
      const userSelectedBase = (
        this._configService.getDropdownValues()?.baseType
        || this.baseselected
        || ''
      ).toString().trim();
      const hasExplicitUserBase =
        userSelectedBase === 'Total Base' || userSelectedBase === 'Answer Base';

      // Keep the user's base dropdown choice across output reload; API isTotalBase may not match requested base.
      this.baseselected = hasExplicitUserBase ? userSelectedBase : fromOutput;
      this.baseLevelSelectedValue = this.baseselected;
      const isTotalBaseSelected = this.baseselected.toLowerCase() === 'total base';
      this.isTotalBase = isTotalBaseSelected;
      if (this.y1) {
        this.y1.isTotalBase = isTotalBaseSelected;
      }
      this._configService.setDropdownValue('baseType', this.baseselected);
      this.base = [
        { key: 'Total Base', selected: isTotalBaseSelected },
        { key: 'Answer Base', selected: !isTotalBaseSelected },
      ];
      this.base2 = [
        { key: 'Total Base', selected: isTotalBaseSelected },
      ];
    } else {
     const isAnswerBaseConfigured =
          !(this.output_data?.isTotalBase) && (this._configService.outputSnapshotData?.is_answer_base ?? false);
      this.base = [
          { key: 'Total Base', selected: true },
          { key: 'Base', selected: false },       
        ];

       this.base2 = isAnswerBaseConfigured ? [{ key: 'Answer Base', selected: true }] : [{ key: 'Total Base', selected: true }];
       
       if(!isAnswerBaseConfigured) {
         this.selectedCustomBaseReference = [];
       }

      //  if (isAnswerBaseConfigured && !this.selectedCustomBaseReference.includes("Answer Base")){
      //       this.selectedCustomBaseReference.push('Answer Base');        
      //  }
       this.baseselected = this.selectedCustomBaseReference.length == 1 ? this.selectedCustomBaseReference[0] :  (isAnswerBaseConfigured ? "Multiple" : "Total Base");

        // Set default isTotalBase to true (Total Base)
        if (this.y1) {
          this.y1.isTotalBase = isAnswerBaseConfigured ? false : true;
          this.y1.customBaseMetric = this.selectedCustomBaseReference;
        }
    }
    this.updateBaseAvailabilityForCustomPctMeanVariables();
  }

    // If filters contain a custom variable, default base to Total Base and disable other options
    const _customFilterData = this._configService.finalLeftPanelSubmitObject?.previewData?.Filter;
    const _hasCustomVariableFilter = (_customFilterData ?? []).some((f: any) =>
      (f?.Data ?? []).some((d: any) => d?.isCustomGroup === true || (d?.kibanaFilterScript && d.kibanaFilterScript.trim() !== ''))
    );
    if (_hasCustomVariableFilter) {
      if (this.baseselected !== 'Total Base') {
        this.applyTotalBaseLockedStateSnapshot();
      }
      this.enableSnapshotNonTotalBaseOptions = false;
    }

    setTimeout(() => {
      this._loaderService.hideLoader();
    }, 500);

    this.afterSubmit();
    // Cache aggregation flags so the template uses a local field instead of the service
    this.showBaseDropdown = !this._configService.isSemiAggregatedData && !this._configService.isAggregatedData;

    if (this._configService.standardSnapOutputData.length > 0) {
      setTimeout(() => {
        this.showOutputView = true;
        this.isInitialLoading = false;
        // Expand AskMe target widget â€” this fires when the view becomes visible
        if (this._askMeTargetWidgetName) {
          const targetName = this._askMeTargetWidgetName;
          this._askMeTargetWidgetName = '';
          const targetWidget = (this.itemWithoutTrendItems || []).find(
            (w: any) => (w.widget_name || '').toLowerCase() === targetName.toLowerCase()
          );
          if (targetWidget) {
            targetWidget._autoExpand = true;
          }
        }
      }, 100);
    } else {
      this.showOutputView = false;
      this.showDefaultPanel = false;
      this.isInitialLoading = false;
    }

    this.refreshSelectionSummaryFromLeftPanel();
    this.isSubmitClicked = true;

    const _baseDisplay = (this.baseselected === 'Multiple' && this.selectedCustomBaseReference.length > 1)
      ? 'Multiple (' + this.selectedCustomBaseReference.join(', ') + ')'
      : this.baseselected;
    const _sigDisplay = this.displaySignificance === 'Reference'
      ? (() => {
          if (this.selectedSigBrand?.MetricOption) return `Reference: ${this.selectedSigBrand.MetricOption}`;
          const m = (this.selectionSummary || '').match(/Significance:\s*<\/span>\s*Reference:\s*([^<|]+)/);
          return m ? `Reference: ${m[1].trim()}` : 'Reference';
        })()
      : this.displaySignificance;
    if (
      this.isSigSelected &&
      !this._configService.isSemiAggregatedData &&
      !this._configService.isAggregatedData&&
      !this._configService.selectionSummaryText.includes('Significance:')
    ) {
      // add this.displaySignificance and this.baseselected in the this._configService.selectionSummaryText and its string in this._configService.selectionSummaryTextTitle
      this._configService.selectionSummaryTextTitle =
        this._configService.selectionSummaryTextTitle +
        ' || Significance: ' +
        _sigDisplay +
        ' || Base: ' +
        _baseDisplay +
        ' || Weight: ' +
        this.weightSelectedValue;
      this._configService.selectionSummaryText =
        this._configService.selectionSummaryText +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Significance: </span>` +
        _sigDisplay +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Base: </span>` +
        _baseDisplay +
        `<span class="grey-separator"> ||  </span>` +
        `<span class="summary-label">Weight: </span>` +
        this.weightSelectedValue;
    } else {
      if (!this._configService.selectionSummaryText.includes('Index') &&
          !this._configService.isSemiAggregatedData &&
          !this._configService.isAggregatedData) {
        this._configService.selectionSummaryText =
          this._configService.selectionSummaryText +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Index: </span>` +
          this.displayReference +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Base: </span>` +
          _baseDisplay +
          `<span class="grey-separator"> ||  </span>` +
          `<span class="summary-label">Weight: </span>` +
          this.weightSelectedValue;
        this._configService.selectionSummaryTextTitle =
          this._configService.selectionSummaryTextTitle +
          ' || Index: ' +
          this.displayReference +
          ' || Base: ' +
          _baseDisplay +
          ' || Weight: ' +
          this.weightSelectedValue;
      }
    }

    this.UpdateSelectionSummary();

    if (this.significance.length == 0) {
      const sigArea = document.querySelector('.sigArea') as HTMLElement;
      if (sigArea) {
        sigArea.style.display = 'none';
      }

      const significanceDropdown = document.querySelector(
        '.significanceDropdown'
      ) as HTMLElement;
      if (significanceDropdown) {
        significanceDropdown.style.display = 'none';
      }

      const confidenceLeveldropdown = document.querySelector(
        '.confidenceLeveldropdown'
      ) as HTMLElement;
      if (confidenceLeveldropdown) {
        confidenceLeveldropdown.style.display = 'none';
      }
    }

    const baseObj = document.querySelector('.baseDropdown') as HTMLElement;
    if (baseObj) {
      // Check if the element exists
      baseObj.style.marginLeft =
        this.significance.length === 0 && this.thresholdIndex === 0
          ? '0%'
          : '0%';
    }
  }

  //------------------ Reference Calculation Logic---------------
  selectedBrands: any[] = [];
  selectedAudience: any[] = [];
  referenceBrand: string = '';
  referenceAudiencecode: string = '';
  totalSampleSelectedAudience:any[]=[];
  referenceCalculation(output: any, selectedSig: boolean) {
    this.referenceBrand = '';
    this.selectedBrands = [];
    this.selectedBrands = this.y1.LeftPanelSelectedBrand;
    this.selectedAudience = this.y1.LeftPanelSelectedAudience;
    this.totalSampleSelectedAudience = this.y1.LeftPanelAudienceTotalSample;
    // const sampleVariableCode = this.totalSampleSelectedAudience[0]?.variable_code?.split('|')[1].trim();
    const audiencevariableCodes = this.getAudienceVariableCodes(
      this.allSigBrands,
      this.selectedAudience
    );
    
    if(this.totalSampleSelectedAudience.length >0  && this.selectedBrands.length ==0){
      this.selectedBrands = [output[0]?.colChild];
    }

    if (selectedSig) {
      if (this._configService.selectedcompareacrossOption != 'Audience Snapshot') {
        this._configService.isIndexSelected = false;
        for (let i = 0; i < this.allSigBrands.length; i++) {
          if (this.allSigBrands[i].isSelected == true) {
            this.referenceBrand = this.allSigBrands[i].MetricOption;
          }
        }
      } else {
        this._configService.isIndexSelected = false;
        for (let i = 0; i < this.allSigBrands.length; i++) {
          if (this.allSigBrands[i].isSelected == true) {
            this.referenceBrand = this.allSigBrands[i].MetricOption;
          }
        }
        for (let i = 0; i < this.allSigBrands.length; i++) {
          const level2Children = this.allSigBrands[i]?.Level2_children;
          if (level2Children.length === 0) {
            if (this.allSigBrands[i].isSelected == true) {
              this.referenceBrand = this.allSigBrands[i].Level1_value;
              this.referenceAudiencecode = this.allSigBrands[i].data_variable_code;
              break;
            }
          }
          else {
            if (Array.isArray(level2Children)) {
              for (let j = 0; j < level2Children.length; j++) {
                if (level2Children[j].is_selected === true) {
                  this.referenceBrand = level2Children[j].Level2_value;
                  break; // remove if you want multiple matches
                }
              }
            }
          }
        }
      }
    }
    else {
      if ((!this.y1?.indexVsBrandReference || this.y1.indexVsBrandReference.length === 0) &&
          this.output_data?.indexVsBrandReference?.length) {
        this.y1.indexVsBrandReference = this.output_data.indexVsBrandReference;
      }
      this._configService.isIndexSelected =
        this.isIndexSelected === true ||
        (this.y1?.indexVsBrandReference?.length > 0) ||
        (this.displayReference && this.displayReference !== 'None');
      this._configService.IndexSelected = this._configService.isIndexSelected;
      this.referenceBrand = this.findSelectedBrandInHierarchy(this.allbrands);
    }

    // Find the reference brand's data for each metric
 let referenceDataMap: any = {};
let count = 0;

if (this._configService.selectedcompareacrossOption != 'Audience Snapshot') {

  output.forEach((item: any) => {
    if (item.colChild.includes(this.referenceBrand)) {

      let key = '';

      if (item.isCustomGroup || item.isCustomCalculation) {
        key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      } else {
        key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      }

      count++;

      referenceDataMap[key] =
        this._configService.weightSelected === 'Unweighted'
          ? (this.baseselected.toLowerCase() !== 'total base'
              ? item.answerUnweightedShare
              : item.totalUnweightedShare)
          : (this.baseselected.toLowerCase() !== 'total base'
              ? item.answerWeightedShare
              : item.totalWeightedShare);
    }
  });

}
else {

  output.forEach((item: any) => {
     if (item.colChild.includes(this.referenceBrand)) {

      let key = '';

      if (item.isCustomGroup || item.isCustomCalculation) {
        key = `${item.rowChild}_${item.colChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      } else {
        key = `${item.rowChild}_${item.colChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      }

      count++;

      referenceDataMap[key] =
        this._configService.weightSelected === 'Unweighted'
          ? (this.baseselected.toLowerCase() !== 'total base'
              ? item.answerUnweightedShare
              : item.totalUnweightedShare)
          : (this.baseselected.toLowerCase() !== 'total base'
              ? item.answerWeightedShare
              : item.totalWeightedShare);
     }
  });

}
  // For Audience Snapshot, all items must look up against the reference brand's colChild.
  // Pre-compute it once so every row uses the same colChild when building the referenceDataMap key.
  const isAudienceSnap = this._configService.selectedcompareacrossOption == 'Audience Snapshot';
  const audienceRefColChild: string = isAudienceSnap
    ? (output.find((item: any) => item.colChild?.includes(this.referenceBrand))?.colChild ?? '')
    : '';


    // Create a new array with the divided data
    let newArr = output.map((item: any) => {
      // Construct the key from rowVariableCode and widgetName
      if (item.widgetName == 'Awarenesss') {
        let x = 1;
      }
  let key = '';
      if (isAudienceSnap) {
        if (item.isCustomGroup || item.isCustomCalculation) {
          key = `${item.rowChild}_${audienceRefColChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        } else {
          key = `${item.rowChild}_${audienceRefColChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        }
      } else if (item.isCustomGroup || item.isCustomCalculation) {
        key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      } else {
        key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      }

      const referenceValue = referenceDataMap[key];

      if (referenceValue !== undefined) {
        if (
          this._configService.weightSelected === 'Weighted' ||
          this._configService.weightSelected == 'Weight 1' ||
          this._configService.weightSelected == 'weightB' ||
          this._configService.weightSelected =="Weight"
        ) {
          return {
            ...item,
            totalWeightedShareIndex:
              referenceValue === 'NA'
                ? null
                : this.baseselected.toLowerCase() === 'total base'
                ? (item.totalWeightedShare / referenceValue) * 100
                : item.totalWeightedShare,
            answerWeightedShareIndex:
              referenceValue === 'NA'
                ? null
                : this.baseselected.toLowerCase() !== 'total base'
                ? (item.answerWeightedShare / referenceValue) * 100
                : item.answerWeightedShare,
            ...(this.isIndexSelected && { CalculationTypeIndex: 'index' }),
          };
        } else if (this._configService.weightSelected === 'Unweighted') {
          return {
            ...item,
            totalWeightedShareIndex:
              referenceValue === 'NA'
                ? null
                : this.baseselected.toLowerCase() === 'total base'
                ? (item.totalUnweightedShare / referenceValue) * 100
                : item.totalUnweightedShare,
            answerWeightedShareIndex:
              referenceValue === 'NA'
                ? null
                : this.baseselected.toLowerCase() !== 'total base'
                ? (item.answerUnweightedShare / referenceValue) * 100
                : item.answerUnweightedShare,
            ...(this.isIndexSelected && { CalculationTypeIndex: 'index' }),
          };
        }
      }

      return item;
    });
   let updatedSelecetedBrandData: any[] = [];
   const nonEmptyAudience = this.selectedAudience.filter(val => val.trim() !== '');
   const isAudienceSnapFilter =
     this._configService.selectedcompareacrossOption == 'Audience Snapshot' &&
     nonEmptyAudience.length > 0;
   const hasTotalSample =
     Array.isArray(this.totalSampleSelectedAudience) &&
     this.totalSampleSelectedAudience.length > 0;
  if(isAudienceSnapFilter){
     // Audience rows match on colVariableCode (e.g. S1). Total Sample has empty
     // colVariableCode, so keep it explicitly when LeftPanelAudienceTotalSample is selected.
     updatedSelecetedBrandData = newArr.filter((item: any) => {
      const matchesAudience = audiencevariableCodes.some(
        (brand: any) => item.colVariableCode?.includes(brand)
      );
      const isTotalSampleRow =
        hasTotalSample &&
        String(item.colChild || '')
          .toLowerCase()
          .includes('total sample');
      return matchesAudience || isTotalSampleRow;
    });
    }
    //   else if(this._configService.selectedcompareacrossOption == 'Audience Snapshot' && nonEmptyAudience.length==0){
  //    updatedSelecetedBrandData = newArr.filter((item: any) =>
    //     item?.rowChild?.includes(sampleVariableCode)
    // );}
  else {
    updatedSelecetedBrandData = newArr.filter((item: any) =>
      this.selectedBrands.some((brand: any) => item.colChild.includes(brand))
    );
  }
    // Explicit Total Sample presence check in final result
    const totalSampleInResult = updatedSelecetedBrandData.filter(
      (i: any) =>
        String(i.colChild || '').toLowerCase().includes('total sample') ||
        String(i.rowChild || '').toLowerCase().includes('total sample')
    );
    
    
    this._configService.standardSnapOutputData = updatedSelecetedBrandData;
    this._configService.referenceData = updatedSelecetedBrandData;

    if (typeof window !== undefined) {
      (window as any)['jsonObjectForIndex'] = updatedSelecetedBrandData;
    }

    this.afterSubmit();
  }

  /**
   * Finds the selected reference brand value across all hierarchy levels.
   * Used in referenceCalculation to determine referenceBrand.
   */
  private findSelectedBrandInHierarchy(brands: any[]): string {
    const levelConfig = [
      { childrenKey: 'Level2_children', valueKey: 'Level2_value', nextChildrenKey: 'Level3', nextValueKey: 'Level3_value' },
      { childrenKey: 'Level3', valueKey: 'Level3_value', nextChildrenKey: 'Level4', nextValueKey: 'Level4_value' },
      { childrenKey: 'Level4', valueKey: 'Level4_value', nextChildrenKey: 'Level5', nextValueKey: 'Level5_value' },
      { childrenKey: 'Level5', valueKey: 'Level5_value', nextChildrenKey: null, nextValueKey: null },
    ];

    for (const brand of brands) {
      const children = brand.Level2_children;
      if (!children || children.length === 0) {
        if (brand.isSelected === true) {
          return brand.MetricOption;
        }
      } else {
        const found = this.findSelectedInChildrenRecursive(children, levelConfig, 0, '');
        if (found) return found;
      }
    }
    return '';
  }

  /**
   * Recursively finds the deepest selected child's value.
   */
  private findSelectedInChildrenRecursive(
    children: any[], levelConfig: any[], levelIndex: number, parentPath: string
  ): string | null {
    if (!Array.isArray(children) || levelIndex >= levelConfig.length) return null;

    const config = levelConfig[levelIndex];

    for (const child of children) {
      if (child.is_selected === true) {
        const currentValue = child[config.valueKey];
        const currentPath = parentPath ? `${parentPath}|${currentValue}` : currentValue;

        // Check if there's a deeper selected child first
        const nextChildren = config.nextChildrenKey ? child[config.nextChildrenKey] : null;
        if (Array.isArray(nextChildren) && nextChildren.length > 0) {
          const deeperFound = this.findSelectedInChildrenRecursive(
            nextChildren, levelConfig, levelIndex + 1, currentPath
          );
          if (deeperFound) return deeperFound;
        }
        return currentPath;
      }
    }
    return null;
  }

  resetValues() {
    this.isSigSelected = true;
    this.isIndexSelected = false;
    this.sigConBaseToggle = true;
    //reset indexing serach box
    this.searchQuery = '';
    //reseting reference Dropdown
    this.displayReference = 'None';
    this.selectedReference = 'None';
    //reseting AnswerBase dropdown

    this._configService.isIndexSelected = false; //So that in chart dataLabelStyle==index should not be true;

    //reseting Total/Answer Base dropdown
    // Check if Answer Base is configured, if not default to Total Base
    const isAnswerBaseConfigured = this._configService.outputSnapshotData?.is_answer_base !== false;
    this.isCustomBaseSelected = this._configService.outputSnapshotData?.isCustomBaseSelected !== false;
    if(this.isCustomBaseSelected){
        this.base = [
          { key: 'Total Base', selected: true },
          { key: 'Base', selected: false },       
        ];

       this.base2 = isAnswerBaseConfigured ? [{ key: 'Answer Base', selected: true }] : [{ key: 'Total Base', selected: true }];
       if (this.selectedCustomBaseReference.length === 0) {
         if (isAnswerBaseConfigured){
              this.selectedCustomBaseReference.push('Answer Base');        
         }       
       }       
       this.baseselected = this.selectedCustomBaseReference.length == 1 ? this.selectedCustomBaseReference[0] :  (this.selectedCustomBaseReference.length > 1 ? "Multiple" : (isAnswerBaseConfigured ? "Multiple" : "Total Base"));

        // Set default isTotalBase to true (Total Base)
        if (this.y1) {
          this.y1.isTotalBase = isAnswerBaseConfigured ? false : true;
          this.y1.customBaseMetric = this.selectedCustomBaseReference;         
        }

    }else{
      if (isAnswerBaseConfigured) {
        this.baseselected = 'Answer Base';
        this.baseLevelSelectedValue = 'Answer Base';
        this.base = [
          { key: 'Total Base', selected: false },
          { key: 'Answer Base', selected: true },       
        ];
        this.base2 = [{ key: 'Answer Base', selected: true }];

        // Set default isTotalBase to false (Answer Base)
        if (this.y1) {
          this.y1.isTotalBase = false;
        }
      } else {
        // Default to Total Base when Answer Base is not configured
        this.baseselected = 'Total Base';
        this.baseLevelSelectedValue = 'Total Base';
        this.base = [
          { key: 'Total Base',  selected: true },
          { key: 'Answer Base', selected: false }
        ];
        this.base2 = [{ key: 'Total Base', selected: true }];

        // Set default isTotalBase to true (Total Base)
        if (this.y1) {
          this.y1.isTotalBase = true;
        }
      }
  }
    this._configService.setDropdownValue('baseType', this.baseselected);
    //reseting reference Dropdown
    this.displaySignificance = 'None';
    this.displayConfidenceLevel = 'None';
    this.significanceDropdownToggle = false;
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.selectedSignificance = 'None';
    this.significanceSelectedValue = 'None';
    this.y1.significance = 'None';
    this.y1.DefaultConfidenceLevel = 'None';
    this._configService.updateSignificanceValue('None');
    this._configService.updateConfedenceValue('None');
    this.y1.SignificanceVsReference = '';
    this.y1.significanceVsBrandReference = [];
    this.displayBrand = false;
    // this.allSigBrands = this.allSigBrands.map((item: any) => {
    //   item.isSelected = false
    //   return item;
    // })

  }

  closeSigDropdown() {
    this.sigTypeDropdown = false;
  }

  onSigTypeClick(type: any, event: Event) {
    this._configService.setDropdownValue('significance', type.name);
    for (let i = 0; i < this.significanceTypes.length; i++) {
      if (this.significanceTypes[i] == type) {
        this.significanceTypes[i].selected = true;
      } else {
        this.significanceTypes[i].selected = false;
      }
    }
    event.stopPropagation();
  }

  onSignificanceDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.significanceDropdownToggle = !this.significanceDropdownToggle;
    // Auto-expand if dropdown reopens with brand panel already visible
    if (this.significanceDropdownToggle && this.displayBrand && this.selectedSigBrand) {
      this.autoExpandSigReference();
    }
  }
  closeSignificance() {
    this.significanceDropdownToggle = false;
    this.selectedSigAudienceLevel1 = null;
    this.selectedSigAudienceLevel2 = null;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
    this.sigSearchLevel2Query = '';
    this.sigSearchLevel3Query = '';
    this.sigSearchLevel4Query = '';
    this.sigSearchLevel5Query = '';
  }

  autoExpandSigReference() {
    if (!this.selectedSigBrand || !this.allSigBrands) return;
    const brand = this.selectedSigBrand;
    // Find the parent Level1 item in allSigBrands
    const parentLevel1 = this.allSigBrands.find((item: any) =>
      item.hasNextLevel && item.Level1_value === brand.Level2
    );
    if (!parentLevel1) return;
    this.selectedSigAudienceLevel1 = parentLevel1;
    if (!parentLevel1.Level2_children) return;

    // Check if the selected brand is a Level2 child
    const matchingLevel2 = parentLevel1.Level2_children.find((l2: any) =>
      l2.Level2_value === brand.MetricOption
    );
    if (matchingLevel2) return;

    // Find the exact Level2 parent
    const level2Parent = brand._level2ParentValue
      ? parentLevel1.Level2_children.find((l2: any) => l2.Level2_value === brand._level2ParentValue)
      : null;

    if (level2Parent) {
      this.selectedSigAudienceLevel2 = level2Parent;
      // Check if it's a direct Level3 selection
      if (level2Parent.Level3) {
        const matchingLevel3 = level2Parent.Level3.find((l3: any) => l3.Level3_value === brand.MetricOption);
        if (matchingLevel3) return;

        // Find Level3 parent for Level4/Level5
        const level3Parent = brand._level3ParentValue
          ? level2Parent.Level3.find((l3: any) => l3.Level3_value === brand._level3ParentValue)
          : null;

        if (level3Parent) {
          this.selectedSigAudienceLevel3 = level3Parent;
          // Check if it's a direct Level4 selection
          if (level3Parent.Level4) {
            const matchingLevel4 = level3Parent.Level4.find((l4: any) => l4.Level4_value === brand.MetricOption);
            if (matchingLevel4) return;

            // Find Level4 parent for Level5
            const level4Parent = brand._level4ParentValue
              ? level3Parent.Level4.find((l4: any) => l4.Level4_value === brand._level4ParentValue)
              : null;

            if (level4Parent) {
              this.selectedSigAudienceLevel4 = level4Parent;
              return;
            }
          }
        }
      }
      return;
    }

    // Fallback: search by value through hierarchy
    for (const l2 of parentLevel1.Level2_children) {
      if (l2.hasNextLevel && l2.Level3) {
        const matchingLevel3 = l2.Level3.find((l3: any) =>
          l3.Level3_value === brand.MetricOption
        );
        if (matchingLevel3) {
          this.selectedSigAudienceLevel2 = l2;
          return;
        }
      }
    }
  }

  displayBrandToggleClick() {
    this.displayBrand = !this.displayBrand;
  }
  sortToggle: boolean = true; //variable to make default sort
  significanceSelected1(item: any, event: any) {
    this._loaderService.showLoader();
    if(this._configService?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table").length>0){
      let isBIPs =  JSON.parse(this._configService?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table")[0]?.customizationProperties)?.CalculationLogic;
      if(isBIPs == "BIPS"  && item?.key != "None" && this.output_details?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table").length>0){
        this.BIPSelected = true;
        this.widgetString = "Significance";
        setTimeout(() => {
          this.BIPSelected = false;
        }, 3000);
        event.stopPropagation();
      }
    }
    // If reference is selected, dropdown is open, and no brand is selected, reset significance

    //reseting sorting condition
    if (item.key != 'None') {
      this.sortToggle = !this.sortToggle;
    }

    if (this.displaySignificance == item.key && item.key !== 'Reference') {
      this.sortToggle = !this.sortToggle;
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      event.stopPropagation();
      this._loaderService.hideLoader();
      return;
    }
    this.y1.SignificanceVsReference = '';
    this.y1.significanceVsBrandReference = [];
    this.selectedSignificance = item;

    for (let i = 0; i < this.significanceVal.length; i++) {
      // ;
      if (this.significanceVal[i].key == item.key) {
        this.significanceVal[i].isSelected = true;
      } else {
        this.significanceVal[i].isSelected = false;
      }
    }

    if (item.key != 'Reference' ) {
      this.significanceDropdownToggle = false;
      this.ConfidenceLevelDropDownToggle = false;
      this.BaseDropDownToggle = false;
      this.weightDropDownToggle = false;
      this.displayBrand = false;
      this.displaySignificance = item.key;
      this.significanceSelectedValue = item.key;
      this.y1.significance = item.key;
      // Enable selectedBrandKey if significance is selected and not Reference
      this.selectedBrandKey = true;
      this.brandSelection(this.allSigBrands, '');
      // Reset reference panel state
      this.selectedSigAudienceLevel1 = null;
      this.selectedSigAudienceLevel2 = null;
      this.selectedSigAudienceLevel3 = null;
      this.selectedSigAudienceLevel4 = null;
      this.selectedSigBrand = null;
      this.selectedReference = 'None';
      this.sigSearchLevel2Query = '';
      this.sigSearchLevel3Query = '';
      this.sigSearchLevel4Query = '';
      this.sigSearchLevel5Query = '';
      this.searchQuery = '';
    }
     if(item.key == 'None'){
      this.selectedBrandKey = false;
      this.selectedBrandKeyRef=false;
    }
    else if (item.key == 'Reference') {
      this.displayBrand = !this.displayBrand;
      // Disable selectedBrandKey for Reference
      this.selectedBrandKey = false;
      // Auto-open previously selected levels when reopening
      if (this.displayBrand && this.selectedSigBrand) {
        this.autoExpandSigReference();
      }
      this._loaderService.hideLoader();
      return;
    }

    this._configService.updateSignificanceValue(item.key);

    //Handling confidence level as per significance
    if (item.key == 'None') {
      for (let i = 0; i < this.confidenceLevel.length; i++) {
        this.confidenceLevel[i].isSelected = false;
      }
      this.applyConfiguredDefaultConfidenceSelection();
      this.confidenceLevelSelectedValue = 'None';
      this.displayConfidenceLevel = 'None';
      this.y1.DefaultConfidenceLevel = 'None';
      this._configService.updateConfedenceValue('None');
    } else {
      const defaultCl = this.applyConfiguredDefaultConfidenceSelection();
      this.y1.DefaultConfidenceLevel = defaultCl;
      this.displayConfidenceLevel = defaultCl;
      this.confidenceLevelSelectedValue = defaultCl;
      this._configService.updateConfedenceValue(defaultCl);
    }
    this._configService.setDropdownValue('SignificanceVsReference', item.key);
    //API Call
    //-----------------------------------------------------------

    if (this.y1.significance != 'None') {
      this._configService.isIndexSelected = false;
      this.displayBrand = false;
      this.getOutputData('significance', '', this.pageCounter).catch(
        (error) => {
          this._loaderService.hideLoader();
          console.error('Error in getOutputData:', error);
        }
      );
    } else {
      this.displayBrand = false;
      this.y1.confidenceLevel = 'None';
      this.getOutputData('', '', this.pageCounter).catch((error) => {
        this._loaderService.hideLoader();
        console.error('Error in getOutputData:', error);
      });
    }
    if (this.displaySignificance != 'Reference')
      this.UpdateSignificanceSummary();
  }
  brandSelection(allBrands: any, brand: any) {
    if (brand == '') {
      for (let i = 0; i < allBrands.length; i++) {
        allBrands[i].isSelected = false;
      }
      this.selectedBrandKeyRef = false;
    } else {
      if(this._configService.selectedcompareacrossOption != 'Audience Snapshot'){
      for (let i = 0; i < allBrands.length; i++) {
        if (allBrands[i].MetricOption == brand.MetricOption) {
          allBrands[i].isSelected = true;
          this.selectedBrandKeyRef = true;
        } else {
          allBrands[i].isSelected = false;
        }
      }
    }else{
      for (let i = 0; i < allBrands.length; i++) {
      let isAnyChildSelected = false;
      if(allBrands[0].MetricOption === brand.MetricOption){
          allBrands[0].isSelected = true;
          this.selectedBrandKeyRef = true;
        } else {
          allBrands[0].isSelected = false;
        }

      if (Array.isArray(allBrands[i]?.Level2_children)) {
        for (let j = 0; j < allBrands[i].Level2_children.length; j++) {
          if (
            allBrands[i].Level2_children[j].Level2_value === brand.MetricOption
          ) {
            allBrands[i].Level2_children[j].is_selected = true;
            isAnyChildSelected = true;
            this.selectedBrandKeyRef = true;
          } else {
            allBrands[i].Level2_children[j].is_selected = false;
          }
        }
      }

      // Optional: reflect selection on parent
      allBrands[i].isSelected = isAnyChildSelected;
}

    }
    }
  }

  searchBoxClick(event: Event) {
    event.stopPropagation();
  }

  brandSig(brand: any, event: Event) {
    this._loaderService.showLoader();
    this.displaySignificance = this.selectedSignificance.key;
    this.significanceSelectedValue = this.selectedSignificance.key;
    this.y1.significance = this.selectedSignificance.key;
    this._configService.updateSignificanceValue(this.significanceSelectedValue);
    this._configService.isIndexSelected = false;
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.confidenceLevel[i].isSelected == true) {
        this.y1.DefaultConfidenceLevel = this.confidenceLevel[i].key;
        this.displayConfidenceLevel = this.confidenceLevel[i].key;
        this._configService.updateConfedenceValue(this.confidenceLevel[i].key);
      }
    }
    // If nothing selected yet, fall back to configured default
    if (!this.displayConfidenceLevel || this.displayConfidenceLevel === 'None') {
      const defaultCl = this.applyConfiguredDefaultConfidenceSelection();
      this.y1.DefaultConfidenceLevel = defaultCl;
      this.displayConfidenceLevel = defaultCl;
      this._configService.updateConfedenceValue(defaultCl);
    }
    this._configService.setDropdownValue(
      'SignificanceVsReference',
      this.significanceSelectedValue
    );

    this.selectedSigBrand = brand;
    this.brandSelection(this.allSigBrands, brand);

    this.onSignificanceDropdown();
    event.stopPropagation();

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.y1.indexVsBrandReference = [];
    this.y1.significanceVsBrandReference = [];
    this.y1.SignificanceVsReference = 'Reference';
    this.vsBrandArray.push({
      Level0: this.selectedSigBrand.Level1,
      Level1: this.selectedSigBrand.Level2,
      Level2: this.selectedSigBrand._level2ParentValue || this.selectedSigBrand.MetricOption,
      Level3: this.selectedSigBrand._level2ParentValue ? (this.selectedSigBrand._level3ParentValue || this.selectedSigBrand.MetricOption) : '',
      Level4: this.selectedSigBrand._level3ParentValue ? (this.selectedSigBrand._level4ParentValue || this.selectedSigBrand.MetricOption) : '',
      Level5: this.selectedSigBrand._level4ParentValue ? this.selectedSigBrand.MetricOption : '',
      calc_type: this.selectedSigBrand.calculation_type,
      customGroupId: this.selectedSigBrand.customGroupId,
      dataYearCode: this.selectedSigBrand.dataYearCode,
      date: this.selectedSigBrand.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedSigBrand.is_CustomGroup,
      is_brand_analysis: this.selectedSigBrand.is_brandanalysis,
      is_derived: this.selectedSigBrand.is_derived_variable,
      is_dimension: this.selectedSigBrand.is_dimension,
      is_multi_punch: this.selectedSigBrand.is_multi_punch,
      is_time_Period_Present: this.selectedSigBrand.is_time_Period_Present,
      kibanaFilterScript: '',
      response_code: this.selectedSigBrand.response_code,
      sort_id: this.selectedSigBrand.sort_id,
      variable_code: this.selectedSigBrand.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedSigBrand.year_code,
    });
    if (this.vsBrandArray) {
      this.vsBrandArray = this._configService.updatedDataForSubmit(
        this.vsBrandArray
      );
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      if (x !== undefined) {
        this.y1.significanceVsBrandReference.push(x);
      }
    }
    this.getOutputData('reference', '', this.pageCounter).catch((error) => {
      this._loaderService.hideLoader();
      console.error('Error in getOutputData:', error);
    });

    this.UpdateSignificanceSummary();
  } 
  
  tempSelectedCustomBase: string[] = [];
  tempRemovedCustomBase: string[] = [];

  toggleCustomBase(customBase: string, event: Event) {
  if (!this.enableSnapshotNonTotalBaseOptions) {
    event.stopPropagation();
    return;
  }
  event.stopPropagation();
  const isOriginallySelected =
    this.selectedCustomBaseReference.includes(customBase);

  const isTempAdded =
    this.tempSelectedCustomBase.includes(customBase);

  const isTempRemoved =
    this.tempRemovedCustomBase.includes(customBase);

  const isCurrentlySelected =
    (isOriginallySelected && !isTempRemoved) || isTempAdded;

  if (isCurrentlySelected) {
    if (isOriginallySelected) {
      if (!isTempRemoved) {
        this.tempRemovedCustomBase.push(customBase);
      }
    } else {
      this.tempSelectedCustomBase =
        this.tempSelectedCustomBase.filter(x => x !== customBase);
    }
  } else {
    if (isOriginallySelected) {
      this.tempRemovedCustomBase =
        this.tempRemovedCustomBase.filter(x => x !== customBase);
    } else {
      this.tempSelectedCustomBase.push(customBase);
    }
  }
  this.isApplyBase = !((this.tempRemovedCustomBase.length == this.selectedCustomBaseReference.length) && this.tempSelectedCustomBase.length == 0);
}

applyBaseSelection() {
  if (!this.enableSnapshotNonTotalBaseOptions) {
    return;
  }
  this.selectedCustomBaseReference =
    this.selectedCustomBaseReference.filter(
      base => !this.tempRemovedCustomBase.includes(base)
    );

  this.selectedCustomBaseReference = [
    ...new Set([
      ...this.selectedCustomBaseReference,
      ...this.tempSelectedCustomBase
    ])
  ];
  
  // reset temp lists
  this.tempSelectedCustomBase = [];
  this.tempRemovedCustomBase = [];

  this.displayCustomBaseBrand = false;
  this.BaseDropDownToggle = false;
  this.customBaseBrandSelect();
}

  cancelBaseSelection() {
    this.tempSelectedCustomBase = [...this.selectedCustomBaseReference];
    this.displayCustomBaseBrand = false;
    this.BaseDropDownToggle = false;
  }

  customBaseBrandSelect(){
    this.displayCustomBaseBrand = false;
    this.BaseDropDownToggle = false;
    
    // Update the base display to show selected custom base
    // const displayValue = typeof customBase === 'string' ? customBase : customBase.MetricOption || customBase;
    //     this.selectedCustomBaseReference.length == 1
     this.baseselected = this.selectedCustomBaseReference.length == 1 ? this.selectedCustomBaseReference[0] : "Multiple";
     this.y1.customBaseMetric = this.selectedCustomBaseReference;
     this.y1.isTotalBase = false;   

    if (this.isIndexSelected && this.displayReference != 'None') {
      this.getOutputData('reference', '', this.pageCounter).catch(
        (error) => {
          console.error('Error in getOutputData:', error);
        }
      );
    } else if (this.isIndexSelected && this.displayReference == 'None') {
      this.getOutputData('sig', '', this.pageCounter).catch(
        (error) => {
          console.error('Error in getOutputData:', error);
        }
      );
    } else if (this.isSigSelected) {
      this.getOutputData('reference', '', this.pageCounter).catch(
        (error) => {
          console.error('Error in getOutputData:', error);
        }
      );
    }

    this.UpdateBaseSummary();
  }

  // --- trackBy functions for ngFor performance ---
  trackByIndex(index: number): number {
    return index;
  }

  trackByName(index: number, col: any): string {
    return col?.name ?? index;
  }

  trackBySelectionName(index: number, row: any): string {
    return row?.selection_name ?? index;
  }

  trackByValue(index: number, item: any): string {
    return item?.value ?? item?.key ?? index;
  }

  trackByKey(index: number, item: any): string {
    return item?.key ?? index;
  }

  trackByMetricOption(index: number, item: any): string {
    return item?.MetricOption ?? index;
  }

  trackByLevel2Value(index: number, item: any): string {
    return item?.Level2_value ?? index;
  }

  // --- cached config flags to avoid service property access in template on every CD cycle ---
  globalDefaultSelectionFlag: boolean = false;  // mirrors _configService.globalDefaultSelectionFlag
  showBaseDropdown: boolean = true;             // true when neither semi- nor fully-aggregated

  // --- cached filtered results to avoid repeated function calls in template ---
  _cachedFilteredCustomBaseOptions: any[] = [];
  _cachedCustomBaseSearchQuery: string | null = null;

  get filteredCustomBaseOptions(): any[] {
    if (this._cachedCustomBaseSearchQuery !== this.customBaseSearchQuery) {
      this._cachedFilteredCustomBaseOptions = this.getFilteredCustomBaseOptions();
      this._cachedCustomBaseSearchQuery = this.customBaseSearchQuery;
    }
    return this._cachedFilteredCustomBaseOptions;
  }

  _cachedFilteredBrandList: any[] = [];
  _cachedBrandSearchQuery: string | null = null;

  get filteredBrandList(): any[] {
    // if (this._cachedBrandSearchQuery !== this.brandSearchQuery) {
      return this.getFilteredBrandList();
    //   this._cachedBrandSearchQuery = this.brandSearchQuery;
    // }
    // return this._cachedFilteredBrandList;
  }

  getFilteredCustomBaseOptions(): any[] {

    if (!this.CustomBaseOptions) {
      return [];
    }

    if(this.isAnswerBase && !this.CustomBaseOptions.includes("Answer Base")){
        this.CustomBaseOptions.unshift("Answer Base");
    }
    
    if (!this.customBaseSearchQuery || this.customBaseSearchQuery.trim() === '') {
      return this.CustomBaseOptions;
    }

    const searchLower = this.customBaseSearchQuery.toLowerCase();
    return this.CustomBaseOptions.filter((option: any) => {
      if (typeof option === 'string') {
        return option.toLowerCase().includes(searchLower);
      } else if (option && typeof option === 'object') {
        // Handle if it's an object with properties
        return Object.values(option).some(val =>
          val && val.toString().toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  }

  onCLclick() {
    this.significanceDropdownToggle = false;
    //this.sortToggle=!this.sortToggle;
  }

  /** Snapshot config default confidence; falls back to first enabled level. */
  getConfiguredDefaultConfidenceLevel(): string {
    const configured = (this.configuredDefaultConfidenceLevel || '').toString().trim();
    if (
      configured &&
      configured !== 'None' &&
      this.confidenceLevel?.some((c: any) => c.key === configured)
    ) {
      return configured;
    }
    return this.confidenceLevel?.length > 0 ? this.confidenceLevel[0].key : '95%';
  }

  /** Mark configured default as selected in the confidence dropdown list. */
  applyConfiguredDefaultConfidenceSelection(): string {
    return this.applyConfidenceLevelSelection(
      this.getConfiguredDefaultConfidenceLevel()
    );
  }

  /** Select a confidence level, falling back to the configured default. */
  applyConfidenceLevelSelection(value: any): string {
    const requestedValue = (value || '').toString().trim();
    const selectedValue = this.confidenceLevel?.some(
      (item: any) => item.key === requestedValue
    )
      ? requestedValue
      : this.getConfiguredDefaultConfidenceLevel();
    if (this.confidenceLevel?.length) {
      this.confidenceLevel.forEach((item: any) => {
        item.selected = item.key === selectedValue;
        item.isSelected = item.key === selectedValue;
      });
    }
    this.confidenceLevelSelectedValue = selectedValue;
    return selectedValue;
  }

  onConfidenceLevelDropdown() {
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.ConfidenceLevelDropDownToggle = !this.ConfidenceLevelDropDownToggle;
  }

  confidenceLevelSelected(event: any) {
    this._loaderService.showLoader();
    this.displayConfidenceLevel = event.target.textContent;
    this._configService.setDropdownValue(
      'confidenceLevel',
      event.target.textContent
    );
    this.confidenceLevel.forEach((p: any) => {
      if (p.key == event.target.textContent) {
        p.selected = true;
        p.isSelected = true;
      } else {
        p.selected = false;
        p.isSelected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;
    this.y1.DefaultConfidenceLevel = event.target.textContent;
    this._configService.updateConfedenceValue(event.target.textContent);
    for (let i = 0; i < this.confidenceLevel.length; i++) {
      if (this.significanceVal[i].isSelected == true) {
        this.y1.significance = this.significanceVal[i].key;
      }
    }
    this._configService.setDropdownValue(
      'confidenceLevel',
      event.target.textContent
    );
    //API Call

    //   this.getOutputData('confidence', '', this.pageCounter).catch((error) => {
    //   this._loaderService.hideLoader();
    //   console.error('Error in getOutputData:', error);
    // });
    this._loaderService.hideLoader();
    // update the summary text
    if (
      this._configService.selectionSummaryText.includes('Confidence Level:')
    ) {
      let temp = this._configService.selectionSummaryText.split(
        'Confidence Level: </span>'
      );

      let temp1 = temp[1]?.split('%');
      temp1[0] = this.y1.DefaultConfidenceLevel.replace('%', '');
      this._configService.selectionSummaryText =
        temp[0] + 'Confidence Level: </span>' + temp1.join('%');

      let tempTitle =
        this._configService.selectionSummaryTextTitle.split(
          'Confidence Level: '
        );

      let tempTitle1 = tempTitle[1]?.split('%');
      tempTitle1[0] = this.y1.DefaultConfidenceLevel.replace('%', '');
      this._configService.selectionSummaryTextTitle =
        tempTitle[0] + 'Confidence Level: ' + tempTitle1.join('%');
    }
    this.UpdateSelectionSummary();
    this.ConfidenceLevelDropDownToggle = false;
  }

  onReferenceDropdown() {
    this.referenceDropdownToggle = !this.referenceDropdownToggle;
    // If opening reference dropdown and no brand is selected, reset significance
    if (this.referenceDropdownToggle) {
      const noBrandSelected = !this.allbrands.some((b: any) => b.isSelected);
      if (noBrandSelected) {
        this.selectedSignificance = 'None';
        this.displaySignificance = 'None';
        this.significanceSelectedValue = 'None';
        this.y1.significance = 'None';
      }
      // Auto-open previously selected levels when reopening
      if (this.selectedReference && this.selectedReference !== 'None') {
        this.autoExpandRefReference();
      }
    }
  }

  autoExpandRefReference() {
    if (!this.selectedReference || !this.allbrands) return;
    const ref = this.selectedReference;
    // Find the parent Level1 item in allbrands
    const parentLevel1 = this.allbrands.find((item: any) =>
      item.hasNextLevel && item.Level1_value === ref.Level2
    );
    if (!parentLevel1) return;
    this.selectedAudienceLevel1 = parentLevel1;
    if (!parentLevel1.Level2_children) return;

    // Check if the selected reference is a Level2 child
    const matchingLevel2 = parentLevel1.Level2_children.find((l2: any) =>
      l2.Level2_value === ref.MetricOption
    );
    if (matchingLevel2) return;

    // Find the exact Level2 parent
    const level2Parent = ref._level2ParentValue
      ? parentLevel1.Level2_children.find((l2: any) => l2.Level2_value === ref._level2ParentValue)
      : null;

    if (level2Parent) {
      this.selectedAudienceLevel2 = level2Parent;
      // Check if it's a direct Level3 selection
      if (level2Parent.Level3) {
        const matchingLevel3 = level2Parent.Level3.find((l3: any) => l3.Level3_value === ref.MetricOption);
        if (matchingLevel3) return;

        // Find Level3 parent for Level4/Level5
        const level3Parent = ref._level3ParentValue
          ? level2Parent.Level3.find((l3: any) => l3.Level3_value === ref._level3ParentValue)
          : null;

        if (level3Parent) {
          this.selectedAudienceLevel3 = level3Parent;
          // Check if it's a direct Level4 selection
          if (level3Parent.Level4) {
            const matchingLevel4 = level3Parent.Level4.find((l4: any) => l4.Level4_value === ref.MetricOption);
            if (matchingLevel4) return;

            // Find Level4 parent for Level5
            const level4Parent = ref._level4ParentValue
              ? level3Parent.Level4.find((l4: any) => l4.Level4_value === ref._level4ParentValue)
              : null;

            if (level4Parent) {
              this.selectedAudienceLevel4 = level4Parent;
              return;
            }
          }
        }
      }
      return;
    }

    // Fallback: search by value through hierarchy
    for (const l2 of parentLevel1.Level2_children) {
      if (l2.hasNextLevel && l2.Level3) {
        const matchingLevel3 = l2.Level3.find((l3: any) =>
          l3.Level3_value === ref.MetricOption
        );
        if (matchingLevel3) {
          this.selectedAudienceLevel2 = l2;
          return;
        }
      }
    }
  }

  closeReferenceDropdown() {
    this.referenceDropdownToggle = false;
    this.selectedAudienceLevel1 = null;
    this.selectedAudienceLevel2 = null;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
    this.refSearchLevel2Query = '';
    this.refSearchLevel3Query = '';
    this.refSearchLevel4Query = '';
    this.refSearchLevel5Query = '';
  }

  referenceSelected(item: any) {
    this._loaderService.showLoader();
    if(this._configService?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table").length>0){
      let isBIPs =  JSON.parse(this._configService?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table")[0]?.customizationProperties)?.CalculationLogic;
        if(isBIPs == "BIPS" && item?.MetricOption!="None" && this.output_details?.widgetData?.filter((obj:any) => obj?.widgetchart_name?.toLowerCase() === "table").length>0){
          this.BIPSelected = true;
          this.widgetString = "Index";
          setTimeout(() => {
            this.BIPSelected = false;
          }, 3000);
        }
    }
    this.sortToggle = !this.sortToggle; //To reset sorting option to default;
    this.selectedReference = item;
    let oldReference = this.displayReference;
    this.displayReference = item.MetricOption;
    this._configService.setDropdownValue(
      'selectedIndex',
      this.displayReference
    );

    // ;
    const isAudienceSnapshot =
      this._configService.selectedcompareacrossOption === 'Audience Snapshot' ||
      this._configService.selectedSnapshotType?.toLowerCase().includes('audience');

    this.markBrandSelectionInHierarchy(this.allbrands, item, isAudienceSnapshot);

    this.referenceDropdownToggle = false; //Closing the referenece dropdown

    //Creating object for brand selected in reference similar as left panel submit object----------
    this.vsBrandArray = [];
    this.y1.indexVsBrandReference = [];
    this.y1.significanceVsBrandReference = [];
    this.y1.SignificanceVsReference = 'Reference';
    this.vsBrandArray.push({
      Level0: this.selectedReference.Level1,
      Level1: this.selectedReference.Level2,
      Level2: this.selectedReference._level2ParentValue || this.selectedReference.MetricOption,
      Level3: this.selectedReference._level2ParentValue ? (this.selectedReference._level3ParentValue || this.selectedReference.MetricOption) : '',
      Level4: this.selectedReference._level3ParentValue ? (this.selectedReference._level4ParentValue || this.selectedReference.MetricOption) : '',
      Level5: this.selectedReference._level4ParentValue ? this.selectedReference.MetricOption : '',
      calc_type: this.selectedReference.calculation_type,
      customGroupId: this.selectedReference.customGroupId,
      dataYearCode: this.selectedReference.dataYearCode,
      date: this.selectedReference.date,
      hasNextLevel: false,
      is_CustomGroup: this.selectedReference.is_CustomGroup,
      is_brand_analysis: this.selectedReference.is_brandanalysis,
      is_derived: this.selectedReference.is_derived_variable,
      is_dimension: this.selectedReference.is_dimension,
      is_multi_punch: this.selectedReference.is_multi_punch,
      is_time_Period_Present: this.selectedReference.is_time_Period_Present,
      kibanaFilterScript: '',
      response_code: this.selectedReference.response_code,
      sort_id: this.selectedReference.sort_id,
      variable_code: this.selectedReference.variable_code,
      variable_label: null, //No data available
      year_code: this.selectedReference.year_code,
    });
    if (this.vsBrandArray && item.MetricOption != 'None') {
      this.vsBrandArray = this._configService.updatedDataForSubmit(
        this.vsBrandArray
      );
      // ;
      const x = this._configService.previewDataCreation(this.vsBrandArray);
      if (x !== undefined) {
        this.y1.indexVsBrandReference.push(x);
      }
    }
    if (item.MetricOption == 'None') {
      this.getOutputData('sig', '', this.pageCounter) // for a blank output
        .catch((error) => {
          this._loaderService.hideLoader();
          console.error('Error in getOutputData:', error);
        });
      this._configService.isIndexSelected = false;
    } else {
      this.getOutputData('reference', '', this.pageCounter).catch((error) => {
        this._loaderService.hideLoader();
        console.error('Error in getOutputData:', error);
      });
    }

    this._configService.selectionSummaryText =
      this._configService.selectionSummaryText.replace(
        'Index: </span>' + oldReference,
        'Index: </span>' + this.displayReference
      );
    this._configService.selectionSummaryTextTitle =
      this._configService.selectionSummaryTextTitle.replace(
        'Index: ' + oldReference,
        'Index: ' + this.displayReference
      );
    this.UpdateSelectionSummary();
  }

  /**
   * Marks the selected brand across all hierarchy levels (up to 5).
   * Used in referenceSelected to update allbrands selection state.
   */
  private markBrandSelectionInHierarchy(brands: any[], item: any, isAudienceSnapshot: boolean): void {
    const levelConfig = [
      { childrenKey: 'Level2_children', valueKey: 'Level2_value', nextChildrenKey: 'Level3', nextValueKey: 'Level3_value' },
      { childrenKey: 'Level3', valueKey: 'Level3_value', nextChildrenKey: 'Level4', nextValueKey: 'Level4_value' },
      { childrenKey: 'Level4', valueKey: 'Level4_value', nextChildrenKey: 'Level5', nextValueKey: 'Level5_value' },
      { childrenKey: 'Level5', valueKey: 'Level5_value', nextChildrenKey: null, nextValueKey: null },
    ];

    // Build the exact navigation path: [parent2, parent3, parent4, leaf]
    const targetPath: string[] = [];
    if (item._level2ParentValue) targetPath.push(item._level2ParentValue);
    if (item._level3ParentValue) targetPath.push(item._level3ParentValue);
    if (item._level4ParentValue) targetPath.push(item._level4ParentValue);
    targetPath.push(item.MetricOption);

    for (const brand of brands) {
      // Always clear all child selections first
      this.clearSelectionsRecursive(brand.Level2_children, levelConfig, 0);

      if (isAudienceSnapshot && item.MetricOption !== 'None') {
        // Navigate the exact path to mark only the correct node
        const found = this.selectByPath(brand.Level2_children, targetPath, levelConfig, 0);
        brand.isSelected = found;
      } else {
        brand.isSelected = brand.MetricOption === item.MetricOption;
      }
    }
  }

  /**
   * Navigates the exact path through the hierarchy, marking each node along
   * the way as is_selected. Only the nodes on the specified path get selected.
   */
  private selectByPath(children: any[], path: string[], levelConfig: any[], levelIndex: number): boolean {
    if (!Array.isArray(children) || levelIndex >= levelConfig.length || path.length === 0) return false;

    const config = levelConfig[levelIndex];
    const targetValue = path[0];

    for (const child of children) {
      if (child[config.valueKey] === targetValue) {
        child.is_selected = true;

        if (path.length === 1) {
          return true; // Reached the leaf target
        }

        // Navigate deeper along the path
        const nextChildren = config.nextChildrenKey ? child[config.nextChildrenKey] : null;
        if (Array.isArray(nextChildren) && nextChildren.length > 0) {
          return this.selectByPath(nextChildren, path.slice(1), levelConfig, levelIndex + 1);
        }
        return true;
      }
    }
    return false;
  }

  /**
   * Recursively clears is_selected on all children at all levels.
   */
  private clearSelectionsRecursive(children: any[], levelConfig: any[], levelIndex: number): void {
    if (!Array.isArray(children) || levelIndex >= levelConfig.length) return;
    const config = levelConfig[levelIndex];

    for (const child of children) {
      child.is_selected = false;
      const nextChildren = config.nextChildrenKey ? child[config.nextChildrenKey] : null;
      if (Array.isArray(nextChildren)) {
        this.clearSelectionsRecursive(nextChildren, levelConfig, levelIndex + 1);
      }
    }
  }

  toggleAudienceLevel1Expansion(item: any, event: any) {
    event.stopPropagation();
    this.selectedAudienceLevel1 = this.selectedAudienceLevel1 === item ? null : item;
    this.selectedAudienceLevel2 = null;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
    this.refSearchLevel2Query = '';
    this.refSearchLevel3Query = '';
    this.refSearchLevel4Query = '';
    this.refSearchLevel5Query = '';
  }

  selectAudienceLevel2(level1Item: any, level2Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level2Item.Level2_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level2Item.Level2_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level2Item.calc_type,
      customGroupId: level2Item.customGroupId,
      dataYearCode: level2Item.dataYearCode,
      date: level2Item.date,
      is_CustomGroup: level2Item.isCustomGrpPresent,
      is_brandanalysis: level2Item.is_brand_analysis,
      is_derived_variable: level2Item.is_derived,
      is_dimension: level2Item.is_dimension,
      is_multi_punch: level2Item.is_multi_punch,
      is_time_Period_Present: level2Item.is_time_Period_Present,
      response_code: level2Item.response_code,
      sort_id: level2Item.sort_id,
      variable_code: level2Item.data_variable_code,
      year_code: level2Item.year_code,
    };
    this.referenceSelected(combinedItem);
    this.selectedAudienceLevel1 = null;
    this.selectedAudienceLevel2 = null;
  }

  toggleAudienceLevel2Expansion(level2Item: any, event: any) {
    event.stopPropagation();
    this.selectedAudienceLevel2 = this.selectedAudienceLevel2 === level2Item ? null : level2Item;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
    this.refSearchLevel3Query = '';
    this.refSearchLevel4Query = '';
    this.refSearchLevel5Query = '';
  }

  selectAudienceLevel3(level1Item: any, level2Item: any, level3Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level3Item.Level3_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level3Item.Level3_value,
      _level2ParentValue: level2Item.Level2_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level3Item.calc_type,
      customGroupId: level3Item.customGroupId,
      dataYearCode: level3Item.dataYearCode,
      date: level3Item.date,
      is_CustomGroup: level3Item.isCustomGrpPresent,
      is_brandanalysis: level3Item.is_brand_analysis,
      is_derived_variable: level3Item.is_derived,
      is_dimension: level3Item.is_dimension,
      is_multi_punch: level3Item.is_multi_punch,
      is_time_Period_Present: level3Item.is_time_Period_Present,
      response_code: level3Item.response_code,
      sort_id: level3Item.sort_id,
      variable_code: level3Item.data_variable_code,
      year_code: level3Item.year_code,
    };
    this.referenceSelected(combinedItem);
    this.selectedAudienceLevel1 = null;
    this.selectedAudienceLevel2 = null;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
  }

  toggleAudienceLevel3Expansion(level3Item: any, event: any) {
    event.stopPropagation();
    this.selectedAudienceLevel3 = this.selectedAudienceLevel3 === level3Item ? null : level3Item;
    this.selectedAudienceLevel4 = null;
    this.refSearchLevel4Query = '';
    this.refSearchLevel5Query = '';
  }

  selectAudienceLevel4(level1Item: any, level2Item: any, level3Item: any, level4Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level4Item.Level4_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level4Item.Level4_value,
      _level2ParentValue: level2Item.Level2_value,
      _level3ParentValue: level3Item.Level3_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level4Item.calc_type,
      customGroupId: level4Item.customGroupId,
      dataYearCode: level4Item.dataYearCode,
      date: level4Item.date,
      is_CustomGroup: level4Item.isCustomGrpPresent,
      is_brandanalysis: level4Item.is_brand_analysis,
      is_derived_variable: level4Item.is_derived,
      is_dimension: level4Item.is_dimension,
      is_multi_punch: level4Item.is_multi_punch,
      is_time_Period_Present: level4Item.is_time_Period_Present,
      response_code: level4Item.response_code,
      sort_id: level4Item.sort_id,
      variable_code: level4Item.data_variable_code,
      year_code: level4Item.year_code,
    };
    this.referenceSelected(combinedItem);
    this.selectedAudienceLevel1 = null;
    this.selectedAudienceLevel2 = null;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
  }

  toggleAudienceLevel4Expansion(level4Item: any, event: any) {
    event.stopPropagation();
    this.selectedAudienceLevel4 = this.selectedAudienceLevel4 === level4Item ? null : level4Item;
    this.refSearchLevel5Query = '';
  }

  selectAudienceLevel5(level1Item: any, level2Item: any, level3Item: any, level4Item: any, level5Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level5Item.Level5_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level5Item.Level5_value,
      _level2ParentValue: level2Item.Level2_value,
      _level3ParentValue: level3Item.Level3_value,
      _level4ParentValue: level4Item.Level4_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level5Item.calc_type,
      customGroupId: level5Item.customGroupId,
      dataYearCode: level5Item.dataYearCode,
      date: level5Item.date,
      is_CustomGroup: level5Item.isCustomGrpPresent,
      is_brandanalysis: level5Item.is_brand_analysis,
      is_derived_variable: level5Item.is_derived,
      is_dimension: level5Item.is_dimension,
      is_multi_punch: level5Item.is_multi_punch,
      is_time_Period_Present: level5Item.is_time_Period_Present,
      response_code: level5Item.response_code,
      sort_id: level5Item.sort_id,
      variable_code: level5Item.data_variable_code,
      year_code: level5Item.year_code,
    };
    this.referenceSelected(combinedItem);
    this.selectedAudienceLevel1 = null;
    this.selectedAudienceLevel2 = null;
    this.selectedAudienceLevel3 = null;
    this.selectedAudienceLevel4 = null;
  }

  toggleSigAudienceLevel1Expansion(item: any, event: any) {
    event.stopPropagation();
    this.selectedSigAudienceLevel1 = this.selectedSigAudienceLevel1 === item ? null : item;
    this.selectedSigAudienceLevel2 = null;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
    this.selectedSigBrand = null;
    this.sigSearchLevel2Query = '';
    this.sigSearchLevel3Query = '';
    this.sigSearchLevel4Query = '';
    this.sigSearchLevel5Query = '';
  }

  selectSigAudienceLevel2(level1Item: any, level2Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level2Item.Level2_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level2Item.Level2_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level2Item.calc_type,
      customGroupId: level2Item.customGroupId,
      dataYearCode: level2Item.dataYearCode,
      date: level2Item.date,
      is_CustomGroup: level2Item.isCustomGrpPresent,
      is_brandanalysis: level2Item.is_brand_analysis,
      is_derived_variable: level2Item.is_derived,
      is_dimension: level2Item.is_dimension,
      is_multi_punch: level2Item.is_multi_punch,
      is_time_Period_Present: level2Item.is_time_Period_Present,
      response_code: level2Item.response_code,
      sort_id: level2Item.sort_id,
      variable_code: level2Item.data_variable_code,
      year_code: level2Item.year_code,
    };
    this.brandSig(combinedItem, event);
    this.selectedSigAudienceLevel1 = null;
    this.selectedSigAudienceLevel2 = null;
  }

  toggleSigAudienceLevel2Expansion(level2Item: any, event: any) {
    event.stopPropagation();
    this.selectedSigAudienceLevel2 = this.selectedSigAudienceLevel2 === level2Item ? null : level2Item;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
    this.selectedSigBrand = null;
    this.sigSearchLevel3Query = '';
    this.sigSearchLevel4Query = '';
    this.sigSearchLevel5Query = '';
  }

  selectSigAudienceLevel3(level1Item: any, level2Item: any, level3Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level3Item.Level3_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level3Item.Level3_value,
      _level2ParentValue: level2Item.Level2_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level3Item.calc_type,
      customGroupId: level3Item.customGroupId,
      dataYearCode: level3Item.dataYearCode,
      date: level3Item.date,
      is_CustomGroup: level3Item.isCustomGrpPresent,
      is_brandanalysis: level3Item.is_brand_analysis,
      is_derived_variable: level3Item.is_derived,
      is_dimension: level3Item.is_dimension,
      is_multi_punch: level3Item.is_multi_punch,
      is_time_Period_Present: level3Item.is_time_Period_Present,
      response_code: level3Item.response_code,
      sort_id: level3Item.sort_id,
      variable_code: level3Item.data_variable_code,
      year_code: level3Item.year_code,
    };
    this.brandSig(combinedItem, event);
    this.selectedSigAudienceLevel1 = null;
    this.selectedSigAudienceLevel2 = null;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
  }

  toggleSigAudienceLevel3Expansion(level3Item: any, event: any) {
    event.stopPropagation();
    this.selectedSigAudienceLevel3 = this.selectedSigAudienceLevel3 === level3Item ? null : level3Item;
    this.selectedSigAudienceLevel4 = null;
    this.selectedSigBrand = null;
    this.sigSearchLevel4Query = '';
    this.sigSearchLevel5Query = '';
  }

  selectSigAudienceLevel4(level1Item: any, level2Item: any, level3Item: any, level4Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level4Item.Level4_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level4Item.Level4_value,
      _level2ParentValue: level2Item.Level2_value,
      _level3ParentValue: level3Item.Level3_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level4Item.calc_type,
      customGroupId: level4Item.customGroupId,
      dataYearCode: level4Item.dataYearCode,
      date: level4Item.date,
      is_CustomGroup: level4Item.isCustomGrpPresent,
      is_brandanalysis: level4Item.is_brand_analysis,
      is_derived_variable: level4Item.is_derived,
      is_dimension: level4Item.is_dimension,
      is_multi_punch: level4Item.is_multi_punch,
      is_time_Period_Present: level4Item.is_time_Period_Present,
      response_code: level4Item.response_code,
      sort_id: level4Item.sort_id,
      variable_code: level4Item.data_variable_code,
      year_code: level4Item.year_code,
    };
    this.brandSig(combinedItem, event);
    this.selectedSigAudienceLevel1 = null;
    this.selectedSigAudienceLevel2 = null;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
  }

  toggleSigAudienceLevel4Expansion(level4Item: any, event: any) {
    event.stopPropagation();
    this.selectedSigAudienceLevel4 = this.selectedSigAudienceLevel4 === level4Item ? null : level4Item;
    this.selectedSigBrand = null;
    this.sigSearchLevel5Query = '';
  }

  selectSigAudienceLevel5(level1Item: any, level2Item: any, level3Item: any, level4Item: any, level5Item: any, event: any) {
    event.stopPropagation();
    const combinedItem = {
      MetricOption: level5Item.Level5_value,
      Level1: 'Audience',
      Level2: level1Item.Level1_value,
      Level3: level5Item.Level5_value,
      _level2ParentValue: level2Item.Level2_value,
      _level3ParentValue: level3Item.Level3_value,
      _level4ParentValue: level4Item.Level4_value,
      isSelected: false,
      hasNextLevel: false,
      calculation_type: level5Item.calc_type,
      customGroupId: level5Item.customGroupId,
      dataYearCode: level5Item.dataYearCode,
      date: level5Item.date,
      is_CustomGroup: level5Item.isCustomGrpPresent,
      is_brandanalysis: level5Item.is_brand_analysis,
      is_derived_variable: level5Item.is_derived,
      is_dimension: level5Item.is_dimension,
      is_multi_punch: level5Item.is_multi_punch,
      is_time_Period_Present: level5Item.is_time_Period_Present,
      response_code: level5Item.response_code,
      sort_id: level5Item.sort_id,
      variable_code: level5Item.data_variable_code,
      year_code: level5Item.year_code,
    };
    this.brandSig(combinedItem, event);
    this.selectedSigAudienceLevel1 = null;
    this.selectedSigAudienceLevel2 = null;
    this.selectedSigAudienceLevel3 = null;
    this.selectedSigAudienceLevel4 = null;
  }

  onBaseDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.BaseDropDownToggle = !this.BaseDropDownToggle;
    if (this.isCustomBaseSelected && !this.enableSnapshotNonTotalBaseOptions) {
      this.displayCustomBaseBrand = this.BaseDropDownToggle;
    } else {
      this.displayCustomBaseBrand =
        this.BaseDropDownToggle && this.enableSnapshotNonTotalBaseOptions;
    }
  }

  closeBaseDropdown() {
    this.tempSelectedCustomBase = [];
    this.tempRemovedCustomBase = [];
    this.BaseDropDownToggle = false;
    this.displayCustomBaseBrand = false;
  }

  baseSelected(event: any) {
    this.CustomBaseOptions = this._configService.outputSnapshotData.selectedCustomBaseMetric;
    this.sortToggle = !this.sortToggle; //reseting sorting dropdown value to default

    const selectedText = event.target.textContent.trim();

    if (
      !this.enableSnapshotNonTotalBaseOptions &&
      selectedText !== 'Total Base'
    ) {
      return;
    }

    // Handle Custom Base selection - keep dropdown open
    if (selectedText == 'Base') {
      if (!this.enableSnapshotNonTotalBaseOptions) {
        event.stopPropagation();
        return;
      }
      this.displayCustomBaseBrand = !this.displayCustomBaseBrand;
      if (this.displayCustomBaseBrand && this.baseselected !== 'Multiple' && this.selectedCustomBaseReference.length === 0) {
        if (this.isAnswerBase && this.baseselected === 'Answer Base') {
          this.selectedCustomBaseReference = ['Answer Base'];
        }
      }
      // Don't close the dropdown and don't trigger API call
      event.stopPropagation();
      return;
    }

    // For non-Custom Base selections, proceed normally
    this._loaderService.showLoader();
    this._configService.setDropdownValue('baseType', selectedText);
    this.y1.isTotalBase = selectedText != 'Answer Base';
    this.isTotalBase = selectedText != 'Answer Base';

    if(this.y1.isTotalBase && this.isCustomBaseSelected) {
        this.tempSelectedCustomBase = [];
        this.tempRemovedCustomBase = [];
        this.selectedCustomBaseReference = [];  
        this.y1 && 'customBaseMetric' in this.y1 && (this.y1.customBaseMetric = []);
    }
    this.base.forEach((p: any) => {
      if (p.key == selectedText) {
        p.selected = true;
        this.baseselected = p.key;
        this.displayCustomBaseBrand = false;

        // this.afterSubmit();
        // For Audience Snapshot, always make a fresh API call when base type changes
        if (this._configService.selectedcompareacrossOption == 'Audience Snapshot') {
          this.getOutputData('sig', !this.isCustomBaseSelected ? 'baseType' : '', this.pageCounter).catch(
            (error) => {
              this._loaderService.hideLoader();
              console.error('Error in getOutputData:', error);
            }
          );
        } else if (this.isIndexSelected && this.displayReference != 'None') {
            this.getOutputData('reference', !this.isCustomBaseSelected ? 'baseType' : '', this.pageCounter).catch(
            (error) => {
              this._loaderService.hideLoader();
              console.error('Error in getOutputData:', error);
            }
          );
        } else if (this.isIndexSelected && this.displayReference == 'None') {
          this.getOutputData('sig', !this.isCustomBaseSelected ? 'baseType' : '', this.pageCounter).catch(
            (error) => {
              this._loaderService.hideLoader();
              console.error('Error in getOutputData:', error);
            }
          );
        } else if (this.isSigSelected) {
          this.getOutputData('reference', !this.isCustomBaseSelected ? 'baseType' : '', this.pageCounter).catch(
            (error) => {
              this._loaderService.hideLoader();
              console.error('Error in getOutputData:', error);
            }
          );
        } else {
          // Fallback case: ensure getOutputData is called when base type changes
          this.getOutputData('sig', 'baseType', this.pageCounter).catch(
            (error) => {
              this._loaderService.hideLoader();
              console.error('Error in getOutputData:', error);
            }
          );
        }
        //  this.showOutput = false;
        //  setTimeout(() => {
        this.showOutput = true;
        // }, 100);
      } else {
        p.selected = false;
      }
    });

    // ;
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }
  base2Selected(event: any) {
    this.sortToggle = !this.sortToggle; //reseting sorting dropdown value to default
this.CustomBaseOptions=this._configService.outputSnapshotData.selectedCustomBaseMetric;
    const label = (event.target.textContent || '').trim();
    if (!this.enableSnapshotNonTotalBaseOptions && label !== 'Total Base') {
      return;
    }
    this._configService.setDropdownValue('baseType', event.target.textContent);
    this.y1.isTotalBase = event.target.textContent != 'Answer Base';
    this.isTotalBase = event.target.textContent != 'Answer Base';
    this.base2.forEach((p: any) => {
      if (p.value == event.target.textContent) {
        p.selected = true;
        this.baseselected = p.key;
        this.afterSubmit();
        // For Audience Snapshot, always make a fresh API call when base type changes
        if (this._configService.selectedcompareacrossOption == 'Audience Snapshot') {
          this.getOutputData('sig', !this.isCustomBaseSelected ? 'baseType' : '', this.pageCounter).catch(
            (error) => {
              console.error('Error in getOutputData:', error);
            }
          );
        } else if (this.isIndexSelected) {
          this.getOutputData('reference', 'baseType', this.pageCounter).catch(
            (error) => {
              console.error('Error in getOutputData:', error);
            }
          );
        } else if (this.isSigSelected) {
          this.getOutputData('sig', 'baseType', this.pageCounter).catch(
            (error) => {
              console.error('Error in getOutputData:', error);
            }
          );
        } else {
          // Fallback case: ensure getOutputData is called when base type changes
          this.getOutputData('sig', 'baseType', this.pageCounter).catch(
            (error) => {
              console.error('Error in getOutputData:', error);
            }
          );
        }
        // this.showOutput = false;
        // setTimeout(() => {
        this.showOutput = true;
        //  }, 100);
      } else {
        p.selected = false;
      }
    });
    //this.dropdown.nativeElement.selectedIndex = 0;

    this.UpdateBaseSummary();
    this.BaseDropDownToggle = false;
  }

  onWeightDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = !this.weightDropDownToggle;
  }

  onBrandDropdown() {
    this.ConfidenceLevelDropDownToggle = false;
    this.BaseDropDownToggle = false;
    this.weightDropDownToggle = false;
    this.brandDropDownToggle = !this.brandDropDownToggle;
  }

  closeBrandDropdown() {
    this.brandDropDownToggle = false;
  }
  brandSelected(item: any) {
    this.brandSelectedValue = item.value;
    this.brandDropDownToggle = false;

    const isAudienceSnapshot = this._configService.selectedcompareacrossOption?.includes?.('Audience Snapshot') || 
                               this._configService.selectedcompareacrossOption === 'Audience Snapshot';
    
    if (isAudienceSnapshot) {
      
      // Transform the selected brand into the widget format
      const formattedBrandObject = {
        option: item.response_label || item.value,
        is_selected: true,
        selectOrder: 1,
        value: item.value ? `${item.value}_${item.value}` : '',
        index: 0,
        data: {
          variable_label: item.variable_label || 'Brands',
          Is_snapshot: item.is_snapshot || 1,
          response_label: item.response_label || item.value,
          metric_group: item.metric_group || ''
        }
      };
      
      this.selectedAudienceBrandObj = formattedBrandObject;
      
      // Create Audience brand array format for the API
      const audienceBrandArray = [formattedBrandObject];
      
      // ensure previewData contains the selected brand object so getOutputData picks it up
      this.y1.previewData = {
        ...(this.y1.previewData || {}),
        'Audiencebrand': audienceBrandArray,
      };
      // optional: also expose via config service dropdowns if other parts rely on it
      this._configService.setDropdownValue('audienceSelectedBrand', JSON.stringify(audienceBrandArray));

      // Trigger API call so payload (including audienceSelectedBrand) is sent.
      // Choose request type depending on current mode (index vs sig)
      const callType = this._configService.isIndexSelected ? 'reference' : 'sig';
      this.getOutputData(callType, '', this.pageCounter).catch((error) => {
        console.error('Error in getOutputData:', error);
      });
    }

    // Optionally keep a lightweight selection state for downstream consumers
    if (item?.response_label || item?.value) {
      this._configCustomService.updateSelectedBrand('global', item.response_label || item.value);
    }
    // Soft refresh view so any listeners tied to selected brand can react
    if (this.hasBrandDependentCharts) {
      this.showOutput = false;
      setTimeout(() => (this.showOutput = true), 100);
    }
  }

  closeWeightDropdown() {
    this.weightDropDownToggle = false;
  }
  
  weightSelected(event: any) {
    this._loaderService.showLoader();
    let weight_variable = this.weight.find(
      (w: any) => w.key == event.target.textContent
    );
    this._configService.weightSelected =
      weight_variable.variable_code == ''
        ? 'Unweighted'
        : weight_variable.variable_code;
    this.y1.selectedWeight =
      weight_variable.variable_code == ''
        ? 'Unweighted'
        : weight_variable.variable_code;
    this.weightSelectedValue = event.target.textContent;
    // this.afterSubmit();
    // this.ShowOutput();
    // this.getOutputData('sig');
    this.weightDropDownToggle = false;
    this.UpdateWeightSummary();
    if (this._configService.isIndexSelected) {
      this.getOutputData('reference', '', this.pageCounter).catch((error) => {
        this._loaderService.hideLoader();
        console.error('Error in getOutputData:', error);
      });
    } else {
      this.getOutputData('weight', '', this.pageCounter).catch((error) => {
        this._loaderService.hideLoader();
        console.error('Error in getOutputData:', error);
      });
    }
    this.showOutput = false;
    setTimeout(() => {
      this.showOutput = true;
    }, 100);
  }

checkAndSetupBrandDropdown() {
  const isAudienceSnapshot =
    this._configService.selectedcompareacrossOption === 'Audience Snapshot';

  if (isAudienceSnapshot && this.items && this.items.length > 0) {
    this.hasBrandDependentCharts = this.items.some((item: any) => {
      if (item.audience == null) {
        return true;
      }
      if (item.brand && Array.isArray(item.brand) && item.brand.length > 0) {
        return true;
      }
      if (item.metric && Array.isArray(item.metric)) {
        return item.metric.some((metric: any) => {
          if (metric.metric_value && Array.isArray(metric.metric_value)) {
            try {
              const metricData = JSON.parse(metric.metric_value[0] || '[]');
              return (
                Array.isArray(metricData) &&
                metricData.some((m: any) => m.typeofmetric === 'BRAND')
              );
            } catch (e) {
              return false;
            }
          }
          return false;
        });
      }
      return false;
    });

    if (this.hasBrandDependentCharts) {
      let brandData = (this._configCustomService.uniqueBrandData && this._configCustomService.uniqueBrandData.length > 0)
        ? this._configCustomService.uniqueBrandData
        : (this._configService.brandData || []);

      const filteredBrands = brandData.filter(
        (brand: any) => brand.is_snapshot === 1 || brand.is_snapshot === true
      );

      this.brandList = filteredBrands.map((brand: any) => ({
        key:
          brand.response_label ||
          brand.variable_label ||
          brand.MetricOption ||
          brand.key,
        value:
          brand.response_label ||
          brand.variable_label ||
          brand.MetricOption ||
          brand.key,
        variable_label: brand.variable_label || '',
        response_label: brand.response_label || '',
        metric_group: brand.metric_group || brand.metric_group_snapshot || '',
        is_snapshot: brand.is_snapshot,
      }));
        // If a configured selectedBrand exists, prefer it (and try to normalize)
        if (this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand?.[0]?.option) {
          const selectedBrandLabel =this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand[0]?.option
            || '';
          const selectedBrandValue = selectedBrandLabel.includes('|')
            ? selectedBrandLabel.split('|').pop()?.trim() ?? selectedBrandLabel
            : selectedBrandLabel;

          const brandExists = this.brandList.some(b => (b.value || '').toString() === selectedBrandValue.toString());
          if (brandExists) {
            this.brandSelectedValue = selectedBrandValue;
          } else if (this.brandList.length > 0) {
            this.brandSelectedValue = this.brandList[0].value;  
            this.brandSelected(this.brandList[0]);
          } else {
            this.brandSelectedValue = '';
          }
        } else {
          this.brandSelectedValue = this.brandList.length > 0 ? this.brandList[0].value : '';
        }
    } else {
      this.brandList = [];
      this.brandSelectedValue = '';
      this.hasBrandDependentCharts = false;
    }
  } else {
    this.hasBrandDependentCharts = false;
    this.brandList = [];
    this.brandSelectedValue = '';
  }
}

  snapHeaderNameFun(data: any) {}
  brandLogo(data: any) {}
  toggleLeftPanel(data: any = '') {
    // From child: data is the new left_panel_collapse value (true = collapsed, false = expanded)
    if (typeof data === 'boolean') {
      const shouldShow = !data;            // expanded => show panel
      if (this.showLeftPanel === shouldShow) {
        return;                            // already in sync, do nothing
      }
      this.showLeftPanel = shouldShow;
    } else {
      // Called from the template close-icon (no payload) â€“ keep toggle behavior
      this.showLeftPanel = !this.showLeftPanel;
    }

    this.isTriggerFromButton = true;
    
    if (this.isfilterSelected) {
      this.isfilterSelected = false;
      setTimeout(() => {
        this.isfilterSelected = true;
      });
    }
    if (this.isSavedSelectionSelected) {
      this.isSavedSelectionSelected = false;
      // Only reload saved-selection data when opening the panel, not on close.
      // Deferred to next tick so the panel toggle renders first.
      if (this.showLeftPanel) {
        setTimeout(() => {
          this.sectionSelected('savedSelection');
          this.isSavedSelectionSelected = true;
        });
      } else {
        setTimeout(() => {
          this.isSavedSelectionSelected = true;
        });
      }
    }

    // Let the browser paint the toggle before running change detection
    requestAnimationFrame(() => this.cdr.detectChanges());
  }
  onBaseValuesChanged(data: any) {}
  //original
  // LoadSelection(isDefaultLoad:any) {
  //   this.isDefaultLoad = isDefaultLoad;
  //   this._configService.loadSelectionData(
  //     this.selected_client,
  //     this._configService.outputSnapshotData.snapshot_name,
  //     this.existingData[0]?.snapshotType,
  //     this.existingData[0]?.subsection,
  //     this.existingData[0]?.sections,
  //     this._configService.selectedStudy,
  //     COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
  //     'userDefined'
  //   ).subscribe((result: results) => {
  //     if (result.HasValidData) {
  //       var JsonData = JSON.parse(result.Data);
  //       this.loadDefaultSavedScenarioData = JsonData.find((x:any) => x.is_default == true);
  //       if(this.loadDefaultSavedScenarioData != null && this.isDefaultLoad){
  //         this.getDefaultSelectedLoadData(this.loadDefaultSavedScenarioData,'userDefined');
  //       }
  //       //sort custom groups based on sort_id
  //       this.loadUserDefinedSavedScenarioData = JsonData.sort(
  //         (a: any, b: any) => b.sortid - a.sortid
  //       );
  //       this.isLoadSelection = true;

  //     }
  //     this._configService.setloadSelecVariable(this.isLoadSelection);

  //     this.Loader.hideLoader();
  //   });
  // }
  LoadSelection(isDefaultLoad: any) {
    this.isDefaultLoad = isDefaultLoad;
    // adding below if block so that default load only works once
    if (!this._configService.defaultload) {
      this._configService.defaultload = this.isDefaultLoad;
    } else {
      this.isDefaultLoad = false;
    }
    // Cancel any previous in-flight load to prevent response stacking on rapid toggling
    if (this.loadSelectionSub) {
      this.loadSelectionSub.unsubscribe();
      this.loadSelectionSub = null;
    }
    const _loadSub = new Subscription();
    this.loadSelectionSub = _loadSub;
    _loadSub.add(this._configService
      .loadSelectionData(
        this.selected_client,
        this._configService.outputSnapshotData.snapshot_name,
        this.existingData[0]?.snapshotType,
        this.existingData[0]?.subsection,
        this.existingData[0]?.sections,
        this._configService.selectedStudy,
        COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
        'userDefined'
      )
      .subscribe((result: results) => {
        if (result.HasValidData) {
          var JsonData = JSON.parse(result.Data);
          this.saveSelectionGlobalDefault = JsonData.filter(
            (item: any) => item.selection_name == 'Global Default Selection'
          );
          if (!this._isAskMeGlobalDefaultForced) {
            if (
              this._configService.globalDefaultSelectionFlag &&
              this.saveSelectionGlobalDefault &&
              this.saveSelectionGlobalDefault.length > 0
            ) {
              this.isGlobalDefaultSelected =
                this.saveSelectionGlobalDefault[0].isGlobalDefaultSelectionEnabled;
              this._configService.isGlobalDefaultSelectionEnabled =
                this.saveSelectionGlobalDefault[0].isGlobalDefaultSelectionEnabled;
            } else {
              this.isGlobalDefaultSelected =
                this._configService.globalDefaultSelectionFlag;
              this._configService.isGlobalDefaultSelectionEnabled =
                this._configService.globalDefaultSelectionFlag;
            }
          }
          JsonData = JsonData.filter(
            (item: any) => item.selection_name !== 'Global Default Selection'
          );
          this.loadDefaultSavedScenarioData = JsonData.find(
            (x: any) =>
              x.is_default == true &&
              x.section == this._configService.selectedSection &&
              x.snapshotType == this._configService.snapshotSelectedName &&
              (this._configService.selectedSubSection !== 'NA' &&
              this._configService.selectedSubSection !== '' &&
              this._configService.selectedSubSection !== null &&
              this._configService.snapshotTypeSelectedName == x.snapshotType &&
              this._configService.selectedSection == x.section  &&
              this._configService.selectedSubSection !== undefined
                ? x.subSection === this._configService.selectedSubSection
                : true
              )
          );

          if (this.loadDefaultSavedScenarioData) {
            this.hasUserDefineSaveSelection = true;
            this._configService.isSetDefault = true;
          } else {
            this.hasUserDefineSaveSelection = false;
            this._configService.isSetDefault = false;
          }
          if (
            !this.isGlobalDefaultSelected &&
            this.loadDefaultSavedScenarioData != null &&
            isDefaultLoad
          ) {
            this.getDefaultSelectedLoadData(
              this.loadDefaultSavedScenarioData,
              'userDefined'
            );

            this._configService.setHasDefaultSelection(true);
          }
          if (this._configService.askMePreselection) {
            this._isAskMeGlobalDefaultForced = true;
            this.isGlobalDefaultSelected = true;
            this._configService.isGlobalDefaultSelectionEnabled = true;
            this._configService.globalDefaultSelectionFlag = true;
          }
          if (!this.isTriggerFromButton && !this._configService.saveSelectionLoad) {
            this.showLeftPanel =
              !this.hasUserDefineSaveSelection &&
              !this.loadDefaultSavedScenarioData &&
              !this.isGlobalDefaultSelected;
          }
          //sort custom groups based on sort_id
          // this.loadUserDefinedSavedScenarioData = JsonData.sort(
          //   (a: any, b: any) => b.sortid - a.sortid
          // );
          this.loadUserDefinedSavedScenarioData = JsonData.sort(
            (a: any, b: any) => (Number(b.sortid) || 0) - (Number(a.sortid) || 0)
          );
          // this.isLoadSelection = true;
        }
        this._configService.setloadSelecVariable(this.isLoadSelection);
        if (
          !this._configService.isGlobalDefaultSelectionEnabled &&
          !this.hasUserDefineSaveSelection
        ) {
          this._loaderService.hideLoader();
        }
      }));

    _loadSub.add(this._configService
      .loadSelectionData(
        this.selected_client,
        this._configService.outputSnapshotData.snapshot_name,
        this.existingData[0]?.snapshotType,
        this.existingData[0]?.subsection,
        this.existingData[0]?.sections,
        this._configService.selectedStudy,
        COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
        'sharedWithMe'
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          var JsonData = JSON.parse(result.Data);
          JsonData = JsonData.filter(
            (item: any) => item.selection_name !== 'Global Default Selection'
          );
          this.loadDefaultSavedScenarioData = JsonData.find(
            (x: any) => x.shared_details[0]?.is_Shared_default == true
          );

           this.loadDefaultSavedScenarioData =
            JsonData.find((x: any) => x.shared_details[0]?.is_Shared_default == true
              && x.snapshotType == this._configService.snapshotTypeSelectedName
              && x.section == this._configService.selectedSection)


          if (!this._configService.isSetDefault) {
            if (this.loadDefaultSavedScenarioData) {
              this._configService.isSetDefault = true;
            } else {
              this._configService.isSetDefault = false;
            }
          }
          if (
            !this.isGlobalDefaultSelected &&
            this.loadDefaultSavedScenarioData != null &&
            isDefaultLoad
          ) {
            this.getDefaultSelectedLoadData(
              this.loadDefaultSavedScenarioData,
              'sharedWithMe'
            );
            this._configService.setHasDefaultSelection(true);
          }
          //sort custom groups based on sort_id

          // this.loadSharedWithMeSavedScenarioData = JsonData.sort(
          //   (a: any, b: any) => b.sortid - a.sortid
          // );
          if (!this.isTriggerFromButton && !this._configService.saveSelectionLoad) {
            this.showLeftPanel =
              !this.hasUserDefineSaveSelection &&
              !this.loadDefaultSavedScenarioData &&
              !this.isGlobalDefaultSelected;
          }
          this.loadSharedWithMeSavedScenarioData = JsonData.sort(
            (a: any, b: any) => (Number(b.sortid) || 0) - (Number(a.sortid) || 0)
          );
        }
        if (
          !this.loadDefaultSavedScenarioData &&
          !this._configService.isGlobalDefaultSelectionEnabled &&
          !this.hasUserDefineSaveSelection
        ) {
          this._loaderService.hideLoader();
        }
      }));
  }

  getDefaultSelectedLoadData(
    DefaultSavedScenarioData: any,
    scenarioType: string
  ) {
    this.isSubmitClicked = true;
    sessionStorage.setItem(
      'snapshotType',
      DefaultSavedScenarioData.snapshotType
    );
    this._configService.snapshotTypeSelectedName =
      DefaultSavedScenarioData.snapshotType;
    // sessionStorage.setItem('sectionName', DefaultSavedScenarioData.section);
    //sessionStorage.setItem('subsectionName', DefaultSavedScenarioData.subsection != undefined ? DefaultSavedScenarioData.subsection : 'NA');
    this.subscriptions.add(this._configService
      .getSavedScenarioData(
        DefaultSavedScenarioData.study,
        DefaultSavedScenarioData.client_name,
        DefaultSavedScenarioData.snapshotName,
        DefaultSavedScenarioData.snapshotType,
        DefaultSavedScenarioData.section,
        DefaultSavedScenarioData.subSection,
        DefaultSavedScenarioData.selection_name,
        scenarioType,
        DefaultSavedScenarioData.module_id,
        
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          this.bindSelectedScenario({
            selectedScenarioData: JSON.parse(result.Data),
            columnName: '',
          });
        } else {
          this._loaderService.hideLoader();
        }
        //hide the loader
      }));
  }

  handleShareSelectionPopUp(eventData: {
    isClose: boolean;
    isShared: boolean;
  }): void {
    if (eventData.isShared) {
      // Update shared object
      this.updateSharedListAndObject(
        this.selectedLoadSelectionObj,
        this.selectedEmailsToShare,
        this.loadSharedWithMeSavedScenarioData,
        this.loadUserDefinedSavedScenarioData,
        'loadSelection'
      );
    }

    this.isShareSelectionClick = eventData.isClose;
  }

  updateSharedListAndObject(
    selectedObj: any,
    selectedEmailsToShare: string[],
    sharedWithData: any[],
    userDefinedData: any[],
    type: string
  ): void {
    //check wether the same selection is shared already then need not update the existing object
    var filteredObj = _.filter(sharedWithData, (element) => {
      if (
        element.selection_name === selectedObj.selection_name &&
        element.study === selectedObj.study &&
        element.client_name === selectedObj.client_name
      ) {
        return element;
      }
    });

    // Update shared list if the object is shared with the current user
    if (
      selectedEmailsToShare.includes(selectedObj.user_name) &&
      filteredObj.length == 0
    ) {
      sharedWithData.unshift(selectedObj);
    }

    // Update shared object
    userDefinedData = _.map(userDefinedData, (element) => {
      if (
        element.selection_name === selectedObj.selection_name &&
        element.study === selectedObj.study &&
        element.client_name === selectedObj.client_name
      ) {
        return {
          ...element,
          is_shared: true,
          shared_with: selectedEmailsToShare.toString(),
        };
      }
      return element;
    });

    //updating original objects to rebind data
    if (type == 'customGroup') {
      this.loadCustomGroupUserDefinedData = userDefinedData;
      this.loadCustomGroupSharedWithMeData = sharedWithData;
    } else if (type == 'loadSelection') {
      this.loadUserDefinedSavedScenarioData = userDefinedData;
      this.loadSharedWithMeSavedScenarioData = sharedWithData;
    } else if (type == 'customCalculation') {
      this.loadCustomCalculationUserDefinedData = userDefinedData;
      this.loadCustomCalculationSharedWithMeData = sharedWithData;
    }
  }

  onConfirmation(operation: number) {
    if (operation === 1) {
      //if confirmation is to share the selection
      if (this.loadSelectionType == 'share_customGroup') {
        this.isShowDialog = false;
        //display sharing popup
        this.bindShareSelection(
          this.currentSavedScenarioData.selection_name,
          'userDefined',
          this.currentSavedScenarioData
        );
      } else {
        this._loaderService.showLoader();
        this.subscriptions.add(this._configService
          .deleteSavedScenario(
            this.currentSavedScenarioData.client_name,
            this.currentSavedScenarioData.study,
            this.currentSavedScenarioData.snapshotName,
            this.currentSavedScenarioData.module_id,
            this.currentSavedScenarioData.selection_name,
            this.currentSavedScenarioData.snapshotType,
            this.currentSavedScenarioData.subSection,
            this.currentSavedScenarioData.section,
            this.loadSelectionType
          )
          .subscribe((result: results) => {
            this.showLoaderPopUp = false;

            // Response is valid
            if (result.HasValidData) {
              if (this.loadSelectionType == 'userDefined') {
                // //rebind load selection
                this.loadUserDefinedSavedScenarioData =
                  this.loadUserDefinedSavedScenarioData.filter((x: any) => {
                    return (
                      x.selection_name !==
                      this.currentSavedScenarioData.selection_name
                    );
                  });
              } else {
                this.loadSharedWithMeSavedScenarioData =
                  this.loadSharedWithMeSavedScenarioData.filter((x: any) => {
                    return (
                      x.selection_name !==
                      this.currentSavedScenarioData.selection_name
                    );
                  });
              }

              this.isShowDialog = false;
              const alertObj: AlertMessageModel = {
                header: 'Deletion info',
                message: 'Selected Scenario is deleted successfully',
                show: true,
              };
              // Show the alert popup using the alert service
              this._alertService.showAlert(alertObj);
              //show deleted successfully popup
            } else {
              this.isShowDialog = false;
              const alertObj: AlertMessageModel = {
                header: 'Deletion info',
                message: 'Deletion Failed',
                show: true,
              };
              // Show the alert popup using the alert service
              this._alertService.showAlert(alertObj);
            }
            this._loaderService.hideLoader();
          }));
      }
    } else {
      this.isShowDialog = false;
    }
  }
  additionalCheck(event: any) {
    this.additionalCheckList = event;

    this.is_AI_Integration =
      this.additionalCheckList.find(
        (item: { key: string; value: boolean }) =>
          item.key ===
          CheckboxSelectionModel.additionalCheckBoxSelection[4].name
      )?.value ?? false;
  }

  showSampleSizePopup() {
    // this._loaderService.showLoader();
    // this.getOutputDataForSampleSize(this.pageCounter);
    this.prepareSampleSizePopup();
  }

  prepareSampleSizePopup() {
    this.opobject = {
      Column: [],
      Row: [],
    };

    this.TrendToggleContainer = true;
    this.TrendToggleOn = false;

    let trendDataAvailable =
      this._configService.itemWithTrendData != null &&
      this._configService.itemWithTrendData.length > 0
        ? true
        : false;
    let TrendData =
      this._configService.itemWithTrendData != null &&
      this._configService.itemWithTrendData.length > 0
        ? this._configService.itemWithTrendData[0]
        : [];

    let TrendSelectedWidgets: any = [];

    if (TrendData != null && TrendData.length > 0) {
      TrendSelectedWidgets = TrendData.map((t: any) => t.widget_name);
    }

    if (!this.TrendToggleContainer) {
      this.TrendToggleOn = true;
    }

    this.pageData;
    this.pageCounter;
    this.widgetData;

    let totalPage = 0;

    this.widgetData = _.sortBy(this.widgetData, 'previewChartPostion');

    let widgetDummyData = JSON.parse(JSON.stringify(this.widgetData));

    // let index = 1;
    // widgetDummyData.map((m: any) => {
    //   m.previewChartPostion = index;
    //   index++;
    // });

    let prev = 0;
    this.pageData.map((pg: any, index: any) => {
      if (index == 0) {
        pg.start = 0;
        pg.end = pg.value;
        prev = pg.end;
      } else {
        pg.start = prev + 1;
        pg.end = prev + pg.value;
        prev = pg.end;
      }
    });

    let previousPageStart = _.filter(this.pageData, (page) =>
      page.key.toString().includes((this.pageCounter - 1).toString())
    );
    let previousPageNumber = 0;
    if (previousPageStart.length > 0) {
      previousPageNumber = previousPageStart[0].value;
    }

    let totalWidgetInParticularPage = _.filter(this.pageData, (page) =>
      page.key.toString().includes(this.pageCounter.toString())
    );
    let widgetDetailsInParticularPage = _.sortBy(
      _.filter(
        widgetDummyData,
        (widget) =>
          totalWidgetInParticularPage[0].start <= widget.previewChartPostion &&
          widget.previewChartPostion <= totalWidgetInParticularPage[0].end
      ),
      (x) => x.previewChartPostion
    ).map((x) => x.widget_name);

    let pagedetails = _.cloneDeep(
      this.outputData.filter(
        (i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1
      )
    );

    let uniqueObjects = [
      ...new Map(
        this.outputData
          .filter(
            (i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1
          )
          .map((item: any) => [
            this._configService.multiCohort ? item.widgetName + '||' + item.colChild : item.widgetName, 
            item
          ])
      ).values(),
    ];

    let pageOffset = 0;
    for (let p = 0; p < this.pageCounter - 1; p++) {
      pageOffset += (this.pageData[p]?.value ?? 0);
    }

    const widgetNameToMetric: { [widgetName: string]: { metric: string; metricdropdownOutput: any } } = {};
    widgetDetailsInParticularPage.forEach((widgetName: string, index: number) => {
      const widgetObj = widgetDummyData.find((w: any) => w.widget_name === widgetName);
      const metricdropdownOutput = widgetObj?.metricdropdownOutput;
      const metric = metricdropdownOutput == 1 
        ? this._configCustomService.getSelectedMetricSync((pageOffset + index).toString())
        : '';
      widgetNameToMetric[widgetName] = { metric, metricdropdownOutput };
    });

    uniqueObjects.forEach((i: any) => {
      const isMultipleBrands = this._configService.selectedcompareacrossOption?.includes('Multiple Brands');
      let nestedArray1 = pagedetails
        .filter((p: any) => {
          if (p.widgetName !== i.widgetName) return false;
          if (this._configService.multiCohort && p.colChild !== i.colChild) return false;
          const widgetMetricEntry = widgetNameToMetric[p.widgetName];
          const selectedMetricForWidget = widgetMetricEntry?.metricdropdownOutput == 1 ? widgetMetricEntry?.metric?.trim() : '';
          if (isMultipleBrands && selectedMetricForWidget) {
            const rowName = p.rowChild?.includes('|') ? p.rowChild.split('|')[1].trim() : p.rowChild;
            return rowName === (selectedMetricForWidget.includes('|') ? selectedMetricForWidget.split('|')[1].trim() : selectedMetricForWidget);
          }
          return true;
        })
        .map((p: any) => {
          return {
            CalculationType: p.CalculationType,
            Child: p.rowChild ,
            Level1ColChild: p.Level1ColChild,
            NestedArray: [],
            customCalculationId: p.customCalculationId || null,
            customGroupId: p.customGroupId || null,
            isCustomCalculation: p.isCustomCalculation || false,
            isCustomGroup: p.isCustomGroup || false,
            isDerived: p.isDerived || false,
            isShowDerived: p.isShowDerived || false,
            responsecode:
              p.rowResponseCode == null
                ? p.rowResponseCode
                : p.rowResponseCode.toString(),
            variablecode: p.rowVariableCode,
            unweightedBase:
              this.baseselected.toLowerCase() == 'total base'
                ? p.totalUnweightedBase
                : p.answerUnweightedBase,
            weightedBase:
              this.baseselected.toLowerCase() == 'total base'
                ? p.totalWeightedBase
                : p.answerWeightedBase,
            WeightedNumerator:
              this.baseselected.toLowerCase() == 'total base'
                ? p.totalWeightedNumerator
                : p.answerWeightedNumerator,
            UnweightedNumerator:
              this.baseselected.toLowerCase() == 'total base'
                ? p.CurrentNumeratorUnWeighted_Total
                : p.CurrentNumeratorUnWeighted_Answer,
            trend:
              TrendSelectedWidgets.indexOf(p.widgetName) > -1 ? true : false,
            brand: this._configService.multiCohort 
              ? i.colChild?.split('|').pop() 
              : p.colChild?.split('|')[1],
            ChildName: p.rowChild?.includes('|')
              ? p.rowChild?.split('|')[1].trim()
              : p.rowChild,
          };
        });

      this.opobject.Row.push({
        Data: [
          {
            CalculationType: i.CalculationType || 'share',
            Child: widgetNameToMetric[i.widgetName] && widgetNameToMetric[i.widgetName].metricdropdownOutput!=0 ?  i.widgetName + '_' + widgetNameToMetric[i.widgetName].metric.trim() : i.widgetName,
            Level1ColChild: i.Level1ColChild,
            NestedArray: nestedArray1,
            customCalculationId: i.customCalculationId || null,
            customGroupId: i.customGroupId || null,
            isCustomCalculation: i.isCustomCalculation || false,
            isCustomGroup: i.isCustomGroup || false,
            isDerived: i.isDerived || false,
            isShowDerived: i.isShowDerived || false,
            responsecode: '1',
            variablecode: 'MO_MOb_2b_DAYPART',
            //ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|")[1].trim() : i.Level1ColChild
            ChildName: i.Level1ColChild?.includes('|')
              ? i.Level1ColChild.split('|')[1].trim()
              : i.Level1ColChild || '',
          },
        ],
        Data1: [{ NestedArray: [] }],
        Parent: i.colChild,
        customCalculationId: i.customCalculationId || null,
        customGroupId: i.customGroupId || null,
        isCustomCalculation: i.isCustomCalculation || false,
        isCustomGroup: i.isCustomGroup || false,
      });
    });

    let uniqueColObjects = Object.values(
      this.outputData.reduce((acc: any, obj: any) => {
        acc[obj.Level1ColChild] = obj;
        return acc;
      }, {})
    );

    // Sort the unique objects based on Level1ColResponseCode
    uniqueColObjects.sort((a: any, b: any) => {
      const aCode = this.parseResponseCode(a.Level1ColResponseCode);
      const bCode = this.parseResponseCode(b.Level1ColResponseCode);

      // Compare year first, then number if years are equal
      if (!Number.isNaN(aCode.year) && !Number.isNaN(bCode.year)) {
        if (aCode.year !== bCode.year) {
          return aCode.year - bCode.year;
        }
      }
      return aCode.num - bCode.num;
    });

    uniqueColObjects.sort((a: any, b: any) => {
      let firstData = a.Level1ColChild;
      let secondData = b.Level1ColChild;
      if (firstData?.includes('|')) {
        firstData = firstData.split('|')[1];
        secondData = secondData.split('|')[1];

        if (firstData?.includes('_')) {
          firstData = firstData.split('_')[1];
          secondData = secondData.split('_')[1];
        }

        firstData = parseInt(firstData);
        secondData = parseInt(secondData);
      } else {
        firstData = parseInt(firstData);
        secondData = parseInt(secondData);
      }
      return firstData - secondData;
    });
    uniqueColObjects.forEach((i: any) => {
      let col = {
        Data: [
          {
            CalculationType: i.CalculationType,
            Child: i.Level1ColChild,
            NestedArray: [],
            customCalculationId: null,
            customGroupId: null,
            isCustomCalculation: false,
            isCustomGroup: false,
            isDerived: false,
            responsecode: i.Level1ColResponseCode,
            variablecode: i.Level1NestColVariableCode,
            //ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|")[1].trim() : i.Level1ColChild
            ChildName: i.Level1ColChild?.includes('|')
              ? i.Level1ColChild.split('|')[1].trim()
              : i.Level1ColChild || '',
          },
        ],
        Parent: 'Month',
        customCalculationId: null,
        isCustomCalculation: false,
        isCustomGroup: false,
      };
      if (!this.opobject.Column.includes(col)) {
        this.opobject.Column.push(col);
      }
    });

    //     Level1ColChild
    // :
    // "Month|May_2023"
    // Level1ColResponseCode
    // :
    // "5 2023"
    // Level1NestColVariableCode
    // :
    // "Month_code"

    this.sampleSizeOutputData = JSON.parse(JSON.stringify(this.outputData));
    this.sampleSizeOutputData = this.sampleSizeOutputData.filter(
      (m: any) => widgetDetailsInParticularPage.indexOf(m.widgetName) > -1
    );

    if (Object.keys(widgetNameToMetric).length > 0) {
      this.sampleSizeOutputData = this.sampleSizeOutputData.filter((m: any) => {
        const entry = widgetNameToMetric[m.widgetName];
        // if (!entry || entry.metricdropdownOutput != 1) return true;
        if (!entry) return true;
        const selectedMetric = entry.metric?.trim();
        if (!selectedMetric) return true;
        const rowName = m.rowChild?.includes('|') ? m.rowChild.split('|')[1].trim() : m.rowChild;
        return rowName === selectedMetric;
      });
    }

    this.widgetNameToMetricForPopup = widgetNameToMetric;

    this.showsamplesizepopup = true;
    this.OutputdataObject = this.opobject;
    this.isSampleSize = true;

    this.showSampleSizePop = false;
    setTimeout(() => {
      this.showSampleSizePop = true;
    }, 50);
  }

  parseResponseCode(code: any) {
    const [num, year] = code.split(' ');
    return { num: parseInt(num, 10), year: parseInt(year, 10) };
  }

  onCloseIconClick(closePopUp: any): void {
    if (closePopUp == 'false') {
      // this.errorheaderTitle = '';

      this.popUpTitle = '';
      this.showsamplesizepopup = false;
      this.showErrorPopUp = false;
      this.isLoadSelection = false;
      //this.usageDataLog("Sample Size Pop up");

      // if (this.popUpMessage == "Record already exists") {
      //   this.saveSelection();
      // }
    } else if (closePopUp?.isLoadClickOutput == false) {
      this.isLoadSelection = false;
    }
  }
  isSaveSelectionClick: boolean = false;
  showSelectionSummary: boolean = false;
  showSaveSelectionPopup = false;
  errorheaderTitle: any;
  panelState: string = 'closed';
  saveSelection() {
    this.isSaveSelectionClick = true;
    this.showSelectionSummary = true;
    this.showSaveSelectionPopup = false;
    this.errorheaderTitle = 'SaveSelection';
    this.panelState = this.panelState === 'closed' ? 'open' : 'closed';
  }

  closeShowSelectionSummary() {
    setTimeout(() => {
      this.showSelectionSummary = false;
    }, 400);
  }

  SaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string; //userdefined or shared with me
  }): void {
    this.isSaveSelectionClick = false;
    this.closeShowSelectionSummary();
    this.showSaveSelectionPopup = false;
    this.errorheaderTitle = '';
    if (eventData.isShareSelection) {
      //display sharing popup
      // this.bindShareSelection(
      //   eventData.selectionName,
      //   eventData.selectionType,
      //   this.currentSavedScenarioData
      // );
    } else this.bindSaveSelection(eventData);
  }

  bindSaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string;
  }) {
    if (eventData.isValidationPass) {
      // Call the function with the provided dataObject
      const is_customGroup = false;
      // this.UpdateSelectionSummary();
      this._loaderService.showLoader();
      // To add trend data in save selection
      let checked = this._configService.checkTrendEnabled(this.existingData);
      this.getOutputData(this.typeSelected, '', this.pageCounter, '', checked)
        .then(() => {
          const inputObject =
            this._configService.finalLeftPanelInputSelectedObject;
          const outputObject = this._configService.finalLeftPanelSubmitObject;
          outputObject.sigIndex = this.sigIndex;
          outputObject.isIndexSelected = this.isIndexSelected;
          this.saveSelectedSelection(
            eventData,
            inputObject,
            is_customGroup,
            outputObject
          );
        })
        .catch((error) => {
          console.error('Error in getOutputData:', error);
        });
    }
  }

  getExcelData() {
    let excelData = this._configService.getDropdownValues();
    excelData.isAggregatedData = this._configService.isAggregatedData;
    excelData.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    excelData.isRespondentLevel = this._configService.isRespondentLevel;

    if (
      excelData.compareAcross == 'Multiple Brands' ||
      excelData.compareAcross == 'Multiple Markets' ||
      excelData.compareAcross == 'Audience Snapshot'
    ) {
      excelData = this.preapreexceldata(excelData);
    } else {
      excelData = this.preapreexceldata1(excelData);
    }
    if (this.significanceSelectedValue != 'None') {
      excelData.confidenceLevel = this.confidenceLevelSelectedValue;
    } else {
      excelData.confidenceLevel = 'None';
    }

    excelData.custumview = true;
    excelData.compareacrossmultiplesection = excelData.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');
    return JSON.parse(JSON.stringify(excelData));
  }

  // Ensure "Trend as Widget" widgets carry full trend data into outputArray and outputTrendArray
  // (mirrors the merge performed in editablePPTClicked)
  mergeTrendIntoTrendAsWidget(widgets: any[]) {
    const withTrend = this.getTrendWidgets(this.trendDataResult);
    const trendMap = new Map(withTrend.map(w => [w.widget_name, w]));

    widgets.forEach((pageWidget: any) => {
        const trendWidget = trendMap.get(pageWidget.widget_name);
        if (
          trendWidget &&
          pageWidget.widgetchart_name?.toLowerCase() === 'trend as widget' &&
          pageWidget.metric?.[0] &&
          trendWidget.metric?.[0]
        ) {
          pageWidget.metric[0].metric_value = _.cloneDeep(
            trendWidget.metric[0].metric_value
          );
        }
      });
  }
  
  getPPTData() {
    const _allPageOutputDataClone = _.cloneDeep(this._configService.allPageOutputData);
    let allpageOutputData = (Array.isArray(_allPageOutputDataClone?.[0]) ? _allPageOutputDataClone[0] : []).sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    const _allPageOutputDataWithoutTrendClone = _.cloneDeep(this._configService.allPageOutputDataWithoutTrend);
    let allpageOutputDataWithoutTrend = (Array.isArray(_allPageOutputDataWithoutTrendClone?.[0]) ? _allPageOutputDataWithoutTrendClone[0] : []).sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    
    // Ensure "Trend as Widget" widgets carry full trend data into outputArray
    // (mirrors the merge performed in editablePPTClicked)
    this.mergeTrendIntoTrendAsWidget(allpageOutputDataWithoutTrend);

    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(allpageOutputDataWithoutTrend)
    );
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(allpageOutputData)
    );
    this._configService.setDropdownValue('product', 'custom');
    // outputTrendArrayforExcel

    this._configService.getDropdownValues().staticText =
      this._configService.staticText;
    let data = _.cloneDeep(this._configService.getDropdownValues());

    data.custumview = true;
    data.isAggregatedData = this._configService.isAggregatedData;
    data.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    data.isRespondentLevel = this._configService.isRespondentLevel;

    if (
      data.compareAcross == 'Multiple Brands' ||
      data.compareAcross == 'Multiple Markets' ||
      data.compareAcross == 'Audience Snapshot'
    ) {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
      let formetterdata = [];
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        let custumization = JSON.parse(
          currentwightdat.customizationProperties || '{}'
        );
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let currentmetricdata = currentwightdat.metric[x].metric_value[j];
            for (let k = 0; k < currentmetricdata.data.length; k++) {
              let obj: any = {};
              obj.widget_name = currentwightdat.widget_name;
              obj.widgetchart_name = currentwightdat.widgetchart_name;
              obj.roundoffvalue = custumization.decimalRoundOff;
              obj.option = currentmetricdata.option;
              _.extend(obj, currentmetricdata.data[k]);
              formetterdata.push(obj);
            }
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify(formetterdata);
    } else {
      let outputTrendArray = JSON.parse(data.outputTrendArray);
      let formetterdata = [];
      for (let i = 0; i < outputTrendArray.length; i++) {
        let currentwightdat = outputTrendArray[i];
        for (let x = 0; x < currentwightdat.metric.length; x++) {
          for (
            let j = 0;
            j < currentwightdat.metric[x].metric_value.length;
            j++
          ) {
            let currentmetricdata = currentwightdat.metric[x].metric_value[j];
            outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(
              outputTrendArray[i].metric[x].metric_value[j].data,
              _.isEqual
            );
          }
        }
      }
      data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray]);
    }

    if (this.significanceSelectedValue != 'None') {
      data.confidenceLevel = this.confidenceLevelSelectedValue;
    } else {
      data.confidenceLevel = 'None';
    }
    data.colorpalate = JSON.stringify(this.commonchartmodules.color1);
    data.globalColorMap = JSON.stringify(this.globalColorMap);
    data.brandcolors = JSON.stringify(this.barService.commonchartmodules.brandcolors);
    data.isMultiCohort = this._configService?.multiCohort; 
    return JSON.parse(JSON.stringify(data));
  }

  /**
   * Filters this.widgetData (all widgets configured for the current subsection, across
   * every page) down to only the widgets that belong to the currently active page
   * (this.pageCounter). Widget-to-page membership is derived from previewChartPostion
   * ranges computed from this.pageData (mirrors the same range logic used in
   * prepareSampleSizePopup).
   */
  private getCurrentPageWidgetData(): any[] {
    if (!Array.isArray(this.widgetData) || this.widgetData.length === 0) {
      return this.widgetData;
    }
    if (!Array.isArray(this.pageData) || this.pageData.length === 0) {
      return this.widgetData;
    }

    let prev = 0;
    const pagesWithRange = this.pageData.map((pg: any, index: number) => {
      const start = index === 0 ? 0 : prev + 1;
      const end = index === 0 ? pg.value : prev + pg.value;
      prev = end;
      return { ...pg, start, end };
    });

    const currentPageRange = pagesWithRange.find((pg: any) =>
      pg.key?.toString().includes(this.pageCounter.toString())
    );

    if (!currentPageRange) {
      return this.widgetData;
    }

    return this.widgetData.filter(
      (widget: any) =>
        widget.previewChartPostion >= currentPageRange.start &&
        widget.previewChartPostion <= currentPageRange.end
    );
  }

  $unSubscribeSubmitData6!: Subscription;
  saveSelectedSelection(
    eventData: {
      isValidationPass: boolean;
      selectionName: string;
      isShareSelection: boolean;
    },
    inputObject: any,
    is_customGroup: boolean,
    outputObject: any
  ) {
    let finalObject = {
      module_id: COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
      selection_name: eventData.selectionName,
      client_name: this.clientDetails.clientDetails.client_code,
      study: this._configService.widgetConfigDetails.study,
      snapshotName: this.clientDetails.clientDetails.study,
      snapshotType: this._configService.widgetConfigDetails.snapshotType,
      leftpanel_input_data: JSON.stringify(inputObject),
      output_selection_data: JSON.stringify(outputObject),
      selection_summary: this._configService.selectionSummaryText,
      is_active: true,
      is_shared: false,
      modified_by: '',
      shared_with: '',
      is_CustomGroup: is_customGroup,
    };

    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(this._configService.allPageOutputDataWithoutTrend)
    );
    this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(this._configService.allPageOutputData)
    );
    let excelData = this.getExcelData();
    let pptData = this.getPPTData();

    this.$unSubscribeSubmitData6 = this._configService
      .saveSelectionData(
        COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
        eventData.selectionName,
        this.clientDetails.clientDetails.client_code,
        this._configService.widgetConfigDetails.study, // contains study
        this.clientDetails.clientDetails.study, //this contains snapshot name
        this._configService.widgetConfigDetails.snapshotType,
        this._configService.widgetConfigDetails.section,
        this._configService.widgetConfigDetails.subSection,
        JSON.stringify(inputObject),
        JSON.stringify(outputObject),
        this._configService.selectionSummaryText,
        true,
        false,
        '',
        '',
        JSON.stringify(this._configService.entryPointData),
        is_customGroup,
        JSON.stringify(excelData),
        JSON.stringify(pptData),
        this._configService.selectedcompareacrossOption,
        JSON.stringify(this._configService.brandSortId),
        JSON.stringify(this.getCurrentPageWidgetData()),
        this.baseselected,
        this._configService.weightSelected,
        this._configService.selectedTPforNonTrendView,
        this.isGlobalDefaultSelected,
        this.selectedCustomBaseReference.length > 0 ? JSON.stringify(this.selectedCustomBaseReference) : "",
        this._configService.finalLeftPanelSubmitObject?.previewData?.Audiencebrand || null
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);
          if (JsonData == 'Record already exists') {
            //this.showErrorPopUp = true;
            this.popUpTitle = 'Alert';
            this.popUpMessage = 'Record already exists';
            this.buttonText = 'Ok';
            this.errorPopup(this.popUpMessage, this.popUpTitle);
            this.isSaveSelectionClick = false;
            this.closeShowSelectionSummary();
            this.panelState = this.panelState === 'closed' ? 'open' : 'closed';
          } else if (JsonData == 'Saved Successfully') {
            //this.showErrorPopUp = true;
            this.popUpTitle = 'Alert';
            this.popUpMessage = 'Saved Successfully.';
            this.buttonText = 'Ok';
            this.errorPopup(this.popUpMessage, this.popUpTitle);
            this.panelState = this.panelState === 'closed' ? 'open' : 'closed';
            this.isSaveSelectionClick = false;
            this.closeShowSelectionSummary();
          }
        }
        //hide the loader
        this._loaderService.hideLoader();

        // thipreviewData?.s.usageDataLog(Feature.SaveQuery);
      });
  }
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  handleSavePopUP(eventData: { isClose: boolean }): void {
    this.isSelectionSummaryClick = true;
    this.isSaveSelectionClick = eventData.isClose;
    this.summaryViewHeader = 'Save Selections';
    this.panelState = this.panelState === 'closed' ? 'open' : 'closed';
    this.closeShowSelectionSummary();
  }

  bindSelectedScenario(eventData: {
    selectedScenarioData: any;
    columnName: string;
  }) {
    this.selectedScenarioData = eventData.selectedScenarioData;
    this.isSavedScenarioSelected = true;
    this.bindSavedSelectionDetails();
    //bind leftpanel data
    this.dataArray = JSON.parse(
      this.selectedScenarioData[0].entry_point_selection_data
    );
    this.updateBaseAvailabilityForCustomPctMeanVariables();
  }

  bindSavedSelectionDetails() {
    this.selectionSummary = this.selectedScenarioData[0].selection_summary;
    this._configService.selectedSection = this.selectedScenarioData[0].section;
    this._configService.selectedSubSection =
      this.selectedScenarioData[0].subSection;

    // Keep header/session snapshot type aligned with the loaded selection.
    // Without this, switching Single Brand â†’ Multiple Brands after a save
    // load can read a stale sessionStorage value and skip remount.
    const loadedSnapshotType = this.selectedScenarioData[0]?.snapshotType;
    if (loadedSnapshotType) {
      sessionStorage.setItem('snapshotType', loadedSnapshotType);
      this._configService.snapshotTypeSelectedName = loadedSnapshotType;
      this._configService.snapshotSelectedName = loadedSnapshotType;
      this._configService.selectedSnapshotType = loadedSnapshotType;
      this._configService.selectedcompareacrossOption = loadedSnapshotType;
    }

    var leftpanel_input_data = JSON.parse(
      this.selectedScenarioData[0].leftpanel_input_data
    );
    this._configService.saveSelectionLoad = true;
    this.output_data = JSON.parse(
      this.selectedScenarioData[0].output_selection_data
    );
    if (
  this.output_data?.sigIndex === 'index' ||
  this.output_data?.isIndexSelected === true ||
  (this.output_data?.significance === 'None' && this.output_data?.indexVsBrandReference?.length > 0)
) {
  this.isIndexSelected = true;
  this.isSigSelected = false;
  this._configService.isIndexSelected = true;
  this._configService.IndexSelected = true;
} else {
  this.isIndexSelected = false;
  this.isSigSelected = true;
  this._configService.isIndexSelected = false;
  this._configService.IndexSelected = false;
}


     this.isCustomBaseSelected = this._configService.outputSnapshotData?.isCustomBaseSelected !== false;
    if (this.isCustomBaseSelected && this.selectedScenarioData[0].selectedCustomBaseReference)
    {
      this.selectedCustomBaseReference = JSON.parse(this.selectedScenarioData[0].selectedCustomBaseReference);      
    }

    // let item = {
    //   isSelected : false,
    //   key: this.output_data.significance,
    //   value:true
    // }
    //   if(this.isSavedScenarioSelected){
    //   this.significanceSelected1(item,'');
    // }

    this.pageDetailsForSectionSubsection();
  }

  updateShowDialog(eventData: { isShowDialog: boolean }): void {
    this.isShowDialog = eventData.isShowDialog;
  }

  bindDeleteMessage(eventData: {
    deleteMessage: string;
    selectionType: string;
  }): void {
    this.deleteMessage = eventData.deleteMessage;
    this.loadSelectionType = eventData.selectionType;
  }

  bindcurrentSavedScenarioData(eventData: {
    currentSavedScenarioData: string;
  }): void {
    this.currentSavedScenarioData = eventData.currentSavedScenarioData;
    this._configService.currentSavedScenarioData =
      this.currentSavedScenarioData;
  }

  ShareSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isShareSelection: boolean;
    selectionType: string; //userdefined or shared with me
    is_CustomGroup: boolean;
  }): void {
    if (
      //share and if custom group is involved
      eventData.is_CustomGroup &&
      eventData.isShareSelection
    ) {
      //generte current selected obj
      this.generateSelectedScenarioObj(
        eventData.selectionType,
        eventData.selectionName
      );
      this.bindDeleteMessage({
        deleteMessage:
          eventData.selectionName +
          ' contains custom content. Are you sure you want to share the selection?',
        selectionType: 'share_customGroup',
      });

      this.isShowDialog = true;
    } else if (eventData.isShareSelection) {
      //display sharing popup
      this.bindShareSelection(
        eventData.selectionName,
        eventData.selectionType,
        this.currentSavedScenarioData
      );
    } //else this.bindSaveSelection(eventData);
  }

  bindShareSelection(
    selectionName: string,
    selectionType: string,
    selectedScenarioObj: any
  ) {
    //get user list to share based on module,client and study
    this.subscriptions.add(this._usermanagementService
      .getUsersBasedonStudy(
        this.selected_client,
        this.clientDetails.clientDetails.main_study,
        this.selected_module
      )
      .subscribe((result: results) => {
        // Check if the response has valid data
        if (result.HasValidData) {
          this.shareSelectionUserList = JSON.parse(result.Data);
        }
        this.generateSelectedScenarioObj(selectionType, selectionName);
        //users with whom this load selection is shared already
        this.selectedEmailsToShare = [];
        // this.selectedLoadSelectionObj?.shared_with?.trim().length > 0
        //   ? this.selectedLoadSelectionObj?.shared_with.split(',')
        //   : [];
        if (
          this.selectedLoadSelectionObj?.shared_with &&
          this.selectedLoadSelectionObj.shared_with.trim().length > 0
        ) {
          // Case 1: shared_with is a string (comma-separated)
          this.selectedEmailsToShare =
            this.selectedLoadSelectionObj.shared_with.split(',');
        } else if (this.selectedLoadSelectionObj?.shared_details?.length > 0) {
          // Case 2: shared_details is an array with shared_with values
          this.selectedEmailsToShare =
            this.selectedLoadSelectionObj.shared_details.map(
              (detail: any) => detail.shared_with
            );
        }
        this.isShareSelectionClick = true; //to make share user popup visible
      }));
  }

  generateSelectedScenarioObj(selectionType: string, selectionName: string) {
    var selectionData =
      selectionType == 'userDefined'
        ? this.loadUserDefinedSavedScenarioData
        : this.loadSharedWithMeSavedScenarioData;

    //get inputObj //only userdefined can be saved newly
    this.selectedLoadSelectionObj = _.filter(
      selectionData,
      (r) =>
        r.selection_name === selectionName &&
        r.client_name === this.selected_client &&
        r.study === this._configService.selectedStudy
      // r.module_id === this.selected_module
    )[0];
  }

  //-----------------------------excelexport---------------------------
  // excelexportClicked() {
  //   // this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputData));
  //   this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputDataWithoutTrend));
  //   this._configService.setDropdownValue('outputTrendArray', JSON.stringify(this._configService.allPageOutputData));
  //   this.handleExcelExportClick();
  // }

  async excelexportClicked() {
    this.showContainer = false;
    this.showExportContainer = false;
    await this._ensureDecimalConfig();
    // this._configService.setDropdownValue('outputArray', JSON.stringify(this._configService.allPageOutputData));
    let allpageOutputData = _.cloneDeep(
      this._configService.allPageOutputData
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    let allpageOutputDataWithoutTrend = _.cloneDeep(
      this._configService.allPageOutputDataWithoutTrend
    )[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    // Keep metric data from without-trend output but sync customization (e.g. TrendlineinExports) from trend output.
    allpageOutputDataWithoutTrend.forEach((widget: any) => {
      const trendWidget = allpageOutputData.find(
        (w: any) => w.widget_name === widget.widget_name
      );
      if (trendWidget?.customizationProperties) {
        widget.customizationProperties = trendWidget.customizationProperties;
      }
    });
    this._configService.setDropdownValue(
      'outputArray',
      JSON.stringify(allpageOutputDataWithoutTrend)
    );
     this._configService.setDropdownValue(
      'outputTrendArray',
      JSON.stringify(this._configService.allPageOutputData)
    );
    this.handleExcelExportClick();
  }
  private async _ensureDecimalConfig(): Promise<void> {
    if (this._configService.decimalPointConfig) return;

    const toConfig = (d: any) => ({
      tabular: d.tabular ?? 'chart',
      charts:  d.charts  ?? 'chart',
      excel:   d.excel   ?? 'chart',
      ppt:     d.ppt     ?? 'chart',
    });
    const d1 = this._configService.alreadySavedSnapshotData?.decimal_point_configuration;
    if (d1) {
      this._configService.decimalPointConfig = toConfig(d1);
      return;
    }
    const d2 = (this._configService as any).outputSnapshotData?.decimal_point_configuration;
    if (d2) {
      this._configService.decimalPointConfig = toConfig(d2);
      return;
    }
    try {
      const payload = {
        client_code: this.clientDetails.clientDetails.client_code,
        snapshot_name: this.clientDetails.clientDetails.study,
      };
      const c: any = await this._configService.getClientStudyData(payload).toPromise();
      const parsed = JSON.parse(c?.body?.Data ?? 'null');
      const d3 = parsed?.decimal_point_configuration;
      if (d3) {
        this._configService.decimalPointConfig = toConfig(d3);
      }
    } catch (e) {
      console.warn('Could not fetch decimal config for Excel export', e);
    }
  }

  handleExcelExportClick() {
    //;

    let data = this._configService.getDropdownValues();
    if (
      data.compareAcross == 'Multiple Brands' ||
      data.compareAcross == 'Multiple Markets' || data.compareAcross == 'Audience Snapshot'
    ) {
      data = this.preapreexceldata(data);
    } else {
      data = this.preapreexceldata1(data);
    }
    if (this.significanceSelectedValue != 'None') {
      // data.confidenceLevel = this.confidenceLevelSelectedValue;
      data.confidenceLevel = this.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.custumview = true;
    data.isAggregatedData = this._configService.isAggregatedData;
    data.isSemiAggregatedData = this._configService.isSemiAggregatedData;
    data.isRespondentLevel = this._configService.isRespondentLevel;
    data.compareacrossmultiplesection = data.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');
    const rawBrand =this._configService?.finalLeftPanelSubmitObject?.previewData?.Audiencebrand?.[0]?.option;
    data.audienceSelectedBrand = rawBrand ? rawBrand.substring(rawBrand.lastIndexOf('|') + 1).trim() : null;
    data.customBaseMetric = this.selectedCustomBaseReference;
    data.selectedWeight = this.weightSelectedValue;
    data.isMultiCohort = this._configService.multiCohort;
    // Include the effective Excel decimal in the top-level payload so the backend
    // formatter can apply it for all values (2, 3, 4) regardless of per-row roundoffvalue.
    const excelDecimalOverride = this._configService.decimalPointConfig?.excel;
    data.decimalPlaceExcel = (excelDecimalOverride !== undefined && excelDecimalOverride !== null && excelDecimalOverride !== 'chart')
      ? Number(excelDecimalOverride)
      : undefined;
    this._loaderService.showLoader();
    this.subscriptions.add(
      this._configData.exportToExcel(data).subscribe(
        (excelBlob: Blob) => {
          //;
          let datetimeFormat = this.getCurrentDateTime();
          let fileName =
            'Snapshot' +
            '_' +
            data.clientName +
            '_' +
            data.snapshotName +
            '_' +
            data.compareAcross +
            '_' +
            datetimeFormat +
            '.xlsx';
          // Trigger file download
          this.downloadFile(excelBlob, fileName);
          this._loaderService.hideLoader();
          this.usageDataLog('Excel Export');
          this.showExportContainer = false;
          this.showContainer = false;
        },
        (error) => {
          //this.errorPopup('Something went wrong, please try again');
          this._loaderService.hideLoader();
        }
      )
    );
  }

  downloadFile(data: Blob, filename: string) {
    try {
      // Ensure the data is a Blob
      if (!(data instanceof Blob)) {
        throw new Error('Provided data is not a Blob.');
      }

      // Use FileSaver.js to save the file
      saveAs(data, filename);
      this._loaderService.hideLoader();
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  }

  usageDataLog(feature: string) {
    let summarytext = '';
    if (
      this._configService.selectionSummaryTextTitle != undefined &&
      this._configService.selectionSummaryTextTitle != null
    ) {
      // summarytext = this.summaryText?.nativeElement.innerText;
      summarytext = this._configService.selectionSummaryTextTitle;
    }
    this._usermanagementService.UsageData(
      '3',
      this._configService.getDropdownValues().clientName,
      this._configService.getDropdownValues().studyName,
      feature,
      summarytext,
      this._configService.getDropdownValues().snapshotName
    );
  }

  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
    return formattedDateTime;
  }

  paginationCounterFun(pageNum: number) {
    // this.pageCounter = pageNum;
    this._configData.pageCounter.next(pageNum);
    this.showSampleSizePopup();
  }

  preapreexceldata(data: any) {
 let outputTrendArray = JSON.parse(data.outputTrendArray)[0];
    outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
    let formetterdata = [];
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      if (!currentwightdat) continue;
      let custumization = JSON.parse(
        currentwightdat.customizationProperties || '{}'
      );
      for (let x = 0; x < currentwightdat?.metric?.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x]?.metric_value?.length;
          j++
        ) {
          let currentmetricdata = currentwightdat.metric[x].metric_value[j];
          for (let k = 0; k < currentmetricdata.data.length; k++) {
            let obj: any = {};
            obj.widget_name = currentwightdat.widget_name;
            obj.widgetchart_name = currentwightdat.widgetchart_name;
            obj.option = currentmetricdata.option;
            _.extend(obj, currentmetricdata.data[k]);
            obj.roundoffvalue = this._configService.getEffectiveDecimal(currentwightdat.widgetchart_name, 'excel', custumization.decimalRoundOff);
            formetterdata.push(obj);
          }
        }
      }
    }
    data.outputTrendArray = JSON.stringify(formetterdata);
    return data;
  }
  preapreexceldata1(data: any) {
    let outputTrendArray = JSON.parse(data.outputTrendArray)[0];
    let formetterdata = [];
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      let custumization = JSON.parse(currentwightdat.customizationProperties || '{}');
      const effectiveDecimal = this._configService.getEffectiveDecimal(currentwightdat.widgetchart_name,'excel',custumization.decimalRoundOff);
      custumization.decimalRoundOff = this._configService.getEffectiveDecimal(currentwightdat.widgetchart_name,'excel',custumization.decimalRoundOff);
      currentwightdat.customizationProperties = JSON.stringify(custumization);
      for (let x = 0; x < currentwightdat.metric.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x].metric_value.length;
          j++
        ) {
          let currentmetricdata = currentwightdat.metric[x].metric_value[j];
          outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(
            outputTrendArray[i].metric[x].metric_value[j].data,
            _.isEqual
          ).map((d: any) => ({ ...d, roundoffvalue: custumization.decimalRoundOff }));
        }
      }
    }
    data.outputTrendArray = JSON.stringify([outputTrendArray]);

    return data;
  }

  additionalFeatures(event: any) {
    this.customGroupSelection();
    if (event == 'Custom Variable' || event == 'Custom Group') {
      this.isCustomGroupClick = true;
    }

    if (event == 'Custom Reports') {
      this.isCustomReportSnapshotClick = true;
    }
  }

  customGroupSelection() {
    // if (!this.isCustomGroups) {
    //   this.customCalculationSelection();
    // }
    // else {
    this.isShareMetric = true;
    //this.isMeanMetric = false;
    //this.showCustomMetricsPopup = false;
    //this.isMainWindow = true;
    this.isSavedScenarioSelected = false;
    //this.isCustomGroupClick = true;
    //this.isbackButton = false;
    //this.loadCustomGroupData = [];
    this.loadCustomGroupUserDefinedData = [];

    this.loadCustomGroupSharedWithMeData = [];
    this._loaderService.showLoader();
    //this.customGroupItemIndex = -1;
    this.$unSubscribeSubmitData1 = this.customVariableService
      .retriveUserDefinedCustomGroupSelectionData(
        this.selected_client,
        this.selected_study,
        true,
        COMMON_CONSTANTS.SnapshotModuleId
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);

          //sort custom groups based on sort_id
          var sortedData = JsonData.sort(
            (a: any, b: any) => b.sortid - a.sortid
          );
          this.loadCustomGroupUserDefinedData = sortedData;
        }
        //hide the loader
        this._loaderService.hideLoader();
        this.usageDataLog(Feature.SaveQuery);
      });

    this.$unSubscribeSubmitData1 = this.customVariableService
      .retriveSharedWithMeCustomGroupData(
        this.selected_client,
        this.selected_study,
        true,
        COMMON_CONSTANTS.SnapshotModuleId
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);

          //sort custom groups based on sort_id
          var sortedData = JsonData.sort(
            (a: any, b: any) => b.sortid - a.sortid
          );
          this.loadCustomGroupSharedWithMeData = sortedData;
        }
        //hide the loader
        this._loaderService.hideLoader();
        this.usageDataLog(Feature.SaveQuery);
      });
    //}
    //this.isCustomGroupClick=true;//dont hide leftpanel mean contents
  }

  SelectionSummary() {
    const disctinctRowValues = this.getDistinctChildValues(this.MainResult.Row);
    const disctinctRowNestingValues = this.getDistinctChildValues(
      this.MainResult.RowNesting
    );
    const disctinctColumnValues = this.getDistinctChildValues(
      this.MainResult.Column
    );
    const disctinctColumnNestingValues = this.getDistinctChildValues(
      this.MainResult.ColNesting
    );
    const FilterValues = this.getDistinctChildValues(this.MainResult.Filter);

    const RowValues = this.transformData(disctinctRowValues);
    const RowNestingValues = this.transformData(disctinctRowNestingValues);
    const ColumnValues = this.transformData(disctinctColumnValues);
    const ColumnNestingValues = this.transformData(
      disctinctColumnNestingValues
    );
    const FilterData = this.transformData(FilterValues);
    this.BindSelectionSummary(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      false
    );
    this.ReportIssueBindSelectionSummary(
      RowValues,
      RowNestingValues,
      ColumnValues,
      ColumnNestingValues,
      FilterData,
      false
    );
  }
  ReportIssueBindSelectionSummary(
    RowValues: string[],
    RowNestingValues: string[],
    ColumnValues: string[],
    ColumnNestingValues: string[],
    FilterData: string[],
    isSavedSelection: boolean
  ) {
    let rowNestingSection = '';
    let colNestSection = '';
    let FiltersSection = '';
    let significanceSection = '';
    let confidenceSection = '';
    let Reference = '';
    let Weight = '';
    let Base = '';
    let study = '';
    if (RowNestingValues.length > 0) {
      rowNestingSection = ` || Row Nesting: ${RowNestingValues.join(',')}`;
    }
    if (ColumnNestingValues.length > 0) {
      colNestSection = ` || Column Nesting: ${ColumnNestingValues.join(',')}`;
    }
    if (FilterData.length > 0) {
      FiltersSection = `Filters: ${FilterData.join(',')} || `;
    }
    if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
      if (this.SignificanceVsReference != '') {
        significanceSection = `Significance: ${
          this.DefaultSampleSize
        } : ${this.replacePipe(this.SignificanceVsReference)}  || `;
      } else {
        significanceSection = `Significance: ${this.DefaultSampleSize} ||`;
      }
      confidenceSection = `Confidence Level: ${this.DefaultConfidenceLevel} ||`;
    }
    if (
      this.selectedIndex != '' &&
      this.isIndex &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Reference = ` Reference: ${this.replacePipe(this.selectedIndex)} || `;
    }
    if (
      this.DefaultWeight != '' &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Weight = ` Calculation Weight: ${this.DefaultWeight} ||`;
    }
    if (this.selectedDataFormat == 'Respondent Level') {
      Base = `Calculation Base: ${
        this.isTotalBase ? 'Total Base' : 'Answer Base'
      } || `;
    }
    study = `Study Type: ${this.selected_study} || `;

    this.ReportIssueselectionSummary = `${study} ${Base} Nesting Type: ${
      this.isFilteringActive ? 'Filtering' : 'Profiling'
    }  || ${Weight} ${significanceSection} ${confidenceSection} ${Reference} ${FiltersSection} Row: ${RowValues.join(
      ','
    )} ${rowNestingSection} || Column: ${ColumnValues.join(
      ','
    )} ${colNestSection}`;

    this.ReportIssueselectionSummary =
      this.ReportIssueselectionSummary.replaceAll('@', ' , ');
  }

  BindSelectionSummary(
    RowValues: string[],
    RowNestingValues: string[],
    ColumnValues: string[],
    ColumnNestingValues: string[],
    FilterData: string[],
    isSavedSelection: boolean
  ) {
    let rowNestingSection = '';
    let colNestSection = '';
    let FiltersSection = '';
    let significanceSection = '';
    let confidenceSection = '';
    let Reference = '';
    let Weight = '';
    let Base = '';
    let study = '';
    if (RowNestingValues.length > 0) {
      rowNestingSection = ` <span class="grey-separator"> || </span> <span class="summary-label">Row Nesting:</span> ${RowNestingValues.join(
        '&nbsp;,&nbsp;'
      )}`;
    }
    if (ColumnNestingValues.length > 0) {
      colNestSection = ` <span class="grey-separator"> || </span> <span class="summary-label">Column Nesting:</span> ${ColumnNestingValues.join(
        '&nbsp;,&nbsp;'
      )}`;
    }
    if (FilterData.length > 0) {
      FiltersSection = `  <span class="summary-label">Filters:</span> ${FilterData.join(
        '&nbsp;,&nbsp;'
      )} <span class="grey-separator"> || </span> `;
    }
    if (!isSavedSelection && this.selectedDataFormat == 'Respondent Level') {
      if (this.SignificanceVsReference != '') {
        significanceSection = `  <span class="summary-label">Significance:</span> ${
          this.DefaultSampleSize
        } : ${this.replacePipe(
          this.SignificanceVsReference
        )} <span class="grey-separator"> || </span> `;
      } else {
        significanceSection = `  <span class="summary-label">Significance:</span> ${this.DefaultSampleSize} <span class="grey-separator"> || </span> `;
      }
      confidenceSection = `  <span class="summary-label">Confidence Level:</span> ${this.DefaultConfidenceLevel} <span class="grey-separator"> || </span> `;
    }
    if (
      this.selectedIndex != '' &&
      this.isIndex &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Reference = `  <span class="summary-label">Reference:</span> ${this.replacePipe(
        this.selectedIndex
      )} <span class="grey-separator"> || </span> `;
    }
    if (
      this.DefaultWeight != '' &&
      this.selectedDataFormat == 'Respondent Level'
    ) {
      Weight = `  <span class="summary-label">Calculation Weight:</span> ${this.DefaultWeight} <span class="grey-separator"> || </span> `;
    }
    if (this.selectedDataFormat == 'Respondent Level') {
      Base = `<span class="summary-label">Calculation Base:</span> ${
        this.isTotalBase ? 'Total Base' : 'Answer Base'
      } <span class="grey-separator"> || </span> `;
    }
    study = `<span class="summary-label">Study Type:</span> ${this.selected_study} <span class="grey-separator"> || </span> `;

    this.selectionSummary = `${study}  ${Base} <span class="summary-label">Nesting Type:</span> ${
      this.isFilteringActive ? 'Filtering' : 'Profiling'
    } <span class="grey-separator"> || </span> ${Weight} ${significanceSection} ${confidenceSection} ${Reference}  ${FiltersSection} <span class="summary-label">Row:</span> ${RowValues.join(
      '&nbsp;,&nbsp;'
    )}
    ${rowNestingSection} <span class="grey-separator"> || </span> <span class="summary-label">Column:</span> ${ColumnValues.join(
      '&nbsp;,&nbsp;'
    )} ${colNestSection}`;

    this.selectionSummary = this.selectionSummary.replaceAll('@', ' , ');
  }

  transformData(dataList: string[]): string[] {
    const transformedData: { [key: string]: { [subKey: string]: string[] } } =
      {};

    dataList.forEach((item) => {
      const parts = item.split('|');
      const mainKey = parts[0];

      if (parts.length > 1) {
        const subKey = parts.slice(1, -1).join('|');
        const value = parts.slice(-1)[0];

        if (!transformedData[mainKey]) {
          transformedData[mainKey] = {};
        }

        if (!transformedData[mainKey][subKey]) {
          transformedData[mainKey][subKey] = [];
        }

        transformedData[mainKey][subKey].push(value);
      } else {
        // Handle single-value case
        if (!transformedData[mainKey]) {
          transformedData[mainKey] = { '': [] };
        }

        transformedData[mainKey][''].push(parts[0]);
      }
    });

    return Object.keys(transformedData).map((mainKey) => {
      const subKeys = Object.keys(transformedData[mainKey]);
      const subStrings = subKeys.map((subKey) => {
        const subString =
          subKey === ''
            ? transformedData[mainKey][subKey]
            : `${subKey}: ${transformedData[mainKey][subKey].join(',')}`;
        return subString;
      });
      // return `${mainKey}: ${subStrings.join(' , ')}`;
      return `${mainKey}: ${subStrings.join(',').replace(/,/g, ' , ')}`; // Add space before and after the comma
    });
  }

  getDistinctChildValues(data: checkboxSelectionWithParent[]): string[] {
    const distinctChildValues: string[] = [];

    data.forEach((item) => {
      item.Data.forEach((checkbox) => {
        if (!distinctChildValues.includes(checkbox.Child)) {
          distinctChildValues.push(checkbox.Child);
        }
      });
    });

    return distinctChildValues;
  }

  replacePipe(input: string): string {
    return input.replace(/\|/g, ' : ');
  }

  closeCustomReportPop() {
    this.isCustomReportSnapshotClick = false;
  }
  handleCustomGroupPopUp(eventData: {
    isClose: boolean;
    isShareMetric: boolean;
    isMeanMetric: boolean;
  }): void {
    this.isCustomGroupClick = eventData.isClose;
  }

  bindCustomGroupFlags(eventData: {
    displayMainComponent: boolean;
    isCreateCustomGroup: boolean;
    isUpdateCustomGroup: boolean;
    isDeleteCustomGroup: boolean;
    isDuplicateCustomGroup: boolean;
    isShareCustomGroup: boolean;
    selectedCustomGroupName: string;
    selectedCustomGroupName_Bucket: string;
    customGroupId: string;
    isShareMetric: boolean;
    isMeanMetric: boolean;
  }) {
    this.isCreateCustomGroup = eventData.isCreateCustomGroup;
    this.isUpdateCustomGroup = eventData.isUpdateCustomGroup;
    this.isDeleteCustomGroup = eventData.isDeleteCustomGroup;
    this.isDuplicateCustomGroup = eventData.isDuplicateCustomGroup;
    this.isShareCustomGroupPopupClick = eventData.isShareCustomGroup;
    this.bindCustomGroupFlagsData = eventData;

    if (
      this.isCreateCustomGroup ||
      this.isUpdateCustomGroup ||
      this.isDuplicateCustomGroup
    ) {
      this.isCustomGroupClick = false;
      this.isCreateCustomGroup = true;
    }
    if (this.isDeleteCustomGroup || this.isShareCustomGroupPopupClick) {
      this.isCreateCustomGroup = false;
    }
    if (this.isCreateCustomGroup) {
      const parentWidth =
        this.leftPanel.nativeElement.parentElement.offsetWidth; // Get parent width
      // const currentWidth = this.leftPanel.nativeElement.offsetWidth; // Get current width in pixels
      let newWidth = 0;
      newWidth = (100 / 100) * parentWidth; // Calculate 80% of parent
      this.renderer.setStyle(
        this.leftPanel.nativeElement,
        'width',
        `${newWidth}px`
      );
    }
  }

  customvariable(event: any) {
    this.customGroupSelection();
    if (event == 'Custom Variable' || event == 'Custom Group') {
      this.isCustomGroupClick = true;
    }
  }

  closeCustomVariableScreen(event: any) {
    this.isCreateCustomGroup = false;
    this.isCustomGroupClick = true;
    this.resetLeftpanelWidth();
  }

  dataListChange(event: any) {
    this.dataArray = event;
    this.updateBaseAvailabilityForCustomPctMeanVariables();
  }

  private static readonly CUSTOM_PCT_MEAN_LEVEL0_SNAPSHOT: readonly string[] = [
    'Custom Percentage Variable - User Defined',
    'Custom Percentage Variable - Shared With Me',
    'Custom Mean Variable - User Defined',
    'Custom Mean Variable - Shared With Me',
  ];

  private isCustomPctOrMeanLevel0Snapshot(level0: string | undefined): boolean {
    if (!level0) {
      return false;
    }
    return (
      CustomOutputviewComponent.CUSTOM_PCT_MEAN_LEVEL0_SNAPSHOT.indexOf(
        level0
      ) !== -1
    );
  }

  /**
   * Same array the left panel puts on passdata / submit (not the parent-only dataListChange mirror).
   */
  /** Prefer local dataArray from dataListChange; passdata.dataArray can lag until Submit. */
  private getSubmittedDataArrayForCustomVarScan(): any[] {
    if (Array.isArray(this.dataArray) && this.dataArray.length > 0) {
      return this.dataArray;
    }
    const fromPass = this._configService?.passdata?.dataArray;
    if (Array.isArray(fromPass) && fromPass.length > 0) {
      return fromPass;
    }
    const fromY1 = this.y1?.dataArray;
    if (Array.isArray(fromY1) && fromY1.length > 0) {
      return fromY1;
    }
    const fromFinal = this._configService?.finalLeftPanelSubmitObject?.dataArray;
    if (Array.isArray(fromFinal) && fromFinal.length > 0) {
      return fromFinal;
    }
    const fromEntry = this._configService?.entryPointData;
    if (Array.isArray(fromEntry) && fromEntry.length > 0) {
      return fromEntry;
    }
    return [];
  }

  /** Same preview bundle the left panel puts on passdata / final submit (Filter holds filter columns). */
  private getSubmittedPreviewDataForCustomVarScan(): any {
    return (
      this._configService?.passdata?.previewData ??
      this.y1?.previewData ??
      this._configService?.finalLeftPanelSubmitObject?.previewData ??
      null
    );
  }

  /**
   * Submitted snapshot filters are in previewData.Filter (checkbox columns), not flat dataArray rows with isFilter.
   */
  private hasCustomPctOrMeanInSubmittedPreviewFilters(): boolean {
    const preview = this.getSubmittedPreviewDataForCustomVarScan();
    const filter = preview?.Filter;
    if (!Array.isArray(filter) || filter.length === 0) {
      return false;
    }
    return filter.some((col: any) => {
      if (this.rowReferencesCustomPctMeanSnapshot(col)) {
        return true;
      }
      const data = col?.Data;
      if (!Array.isArray(data)) {
        return false;
      }
      return data.some((row: any) => {
        if (!row || typeof row !== 'object') {
          return false;
        }
        return Object.values(row).some(
          (v) =>
            typeof v === 'string' &&
            this.isCustomPctOrMeanLevel0Snapshot(v)
        );
      });
    });
  }

  /** Custom %/mean can only live in filters for this module; filter rows use Level1 for parent group when Level0 is empty. */
  private rowReferencesCustomPctMeanSnapshot(item: any): boolean {
    if (!item || typeof item !== 'object') {
      return false;
    }
    const candidates = [
      item.Level0,
      item.Level1,
      item.Level2,
      item.Level3,
      (item as any).Parent,
    ];
    for (const c of candidates) {
      if (typeof c === 'string' && this.isCustomPctOrMeanLevel0Snapshot(c)) {
        return true;
      }
    }
    for (const key of Object.keys(item)) {
      const v = (item as any)[key];
      if (Array.isArray(v)) {
        if (v.some((x: any) => this.rowReferencesCustomPctMeanSnapshot(x))) {
          return true;
        }
      }
    }
    return false;
  }

  private hasCustomPctOrMeanInLeftPanelSelections(): boolean {
    if (this.hasCustomPctOrMeanInSubmittedPreviewFilters()) {
      return true;
    }
    const arr = this.getSubmittedDataArrayForCustomVarScan();
    return arr.some((r: any) => this.rowReferencesCustomPctMeanSnapshot(r));
  }

  private applyTotalBaseLockedStateSnapshot(): void {
    if (this.y1) {
      this.y1.isTotalBase = true;
    }
    this.isTotalBase = true;
    if (this.output_data) {
      this.output_data.isTotalBase = true;
    }
    this.baseselected = 'Total Base';
    this.baseLevelSelectedValue = 'Total Base';
    this._configService.setDropdownValue('baseType', 'Total Base');

    if (!this.isCustomBaseSelected) {
      this.base = [
        { key: 'Total Base', selected: true },
        { key: 'Answer Base', selected: false },
      ];
      this.base2 = [{ key: 'Total Base', selected: true }];
    } else {
      this.base = [
        { key: 'Total Base', selected: true },
        { key: 'Base', selected: false },
      ];
      this.base2 = [{ key: 'Total Base', selected: true }];
      this.selectedCustomBaseReference = [];
      if (this.y1) {
        this.y1.customBaseMetric = [];
      }
      if (this.innerSelection && 'customBaseMetric' in this.innerSelection) {
        (this.innerSelection as any).customBaseMetric = [];
      }
      this.tempSelectedCustomBase = [];
      this.tempRemovedCustomBase = [];
    }
    this.displayCustomBaseBrand = false;
    this.BaseDropDownToggle = false;
    this.isApplyBase = false;
    this.UpdateBaseSummary();
  }

  private applyAnswerBaseRestoredStateSnapshot(): void {
    const isAnswerBaseConfigured =
      this._configService.outputSnapshotData?.is_answer_base !== false;
    if (!isAnswerBaseConfigured) {
      this.applyTotalBaseLockedStateSnapshot();
      return;
    }

    if (!this.isCustomBaseSelected) {
      this.baseselected = 'Answer Base';
      this.baseLevelSelectedValue = 'Answer Base';
      this.base = [
        { key: 'Total Base', selected: false },
        { key: 'Answer Base', selected: true },
      ];
      this.base2 = [{ key: 'Answer Base', selected: true }];
      if (this.y1) {
        this.y1.isTotalBase = false;
      }
      this.isTotalBase = false;
    } else {
      this.selectedCustomBaseReference = ['Answer Base'];
      if (this.y1) {
        this.y1.customBaseMetric = ['Answer Base'];
      }
      if (this.innerSelection && 'customBaseMetric' in this.innerSelection) {
        (this.innerSelection as any).customBaseMetric = ['Answer Base'];
      }
      this.tempSelectedCustomBase = [];
      this.tempRemovedCustomBase = [];
      this.baseselected = 'Answer Base';
      this.baseLevelSelectedValue = 'Answer Base';
      this.base = [
        { key: 'Total Base', selected: false },
        { key: 'Base', selected: false },
      ];
      this.base2 = [{ key: 'Answer Base', selected: true }];
      if (this.y1) {
        this.y1.isTotalBase = false;
      }
      this.isTotalBase = false;
    }
    if (this.output_data) {
      this.output_data.isTotalBase = false;
    }
    this._configService.setDropdownValue('baseType', 'Answer Base');
    this.displayCustomBaseBrand = false;
    this.BaseDropDownToggle = false;
    this.isApplyBase = true;
    this.UpdateBaseSummary();
  }

  updateBaseAvailabilityForCustomPctMeanVariables(): void {
    const baseUiRelevant =
      !this._configService.isSemiAggregatedData &&
      !this._configService.isAggregatedData;
    if (!baseUiRelevant) {
      this.enableSnapshotNonTotalBaseOptions = true;
      return;
    }
    const wasBlocked = this._hadCustomPctMeanBlockingSnapshotBase;
    const answerBaseConfigured =
      this._configService.outputSnapshotData?.is_answer_base !== false;
    const blocked =
      answerBaseConfigured && this.hasCustomPctOrMeanInLeftPanelSelections();

    if (blocked) {
      this.enableSnapshotNonTotalBaseOptions = false;
      const isExplicitBaseChange = this.baseTypeSelected === 'baseType';
      if (!isExplicitBaseChange) {
        this.applyTotalBaseLockedStateSnapshot();
      }
    } else {
      this.enableSnapshotNonTotalBaseOptions = true;
      if (wasBlocked && answerBaseConfigured) {
        this.applyAnswerBaseRestoredStateSnapshot();
      }
    }
    this._hadCustomPctMeanBlockingSnapshotBase = blocked;
  }

  onPageCounterChange(newPageCounter: number) {
    this.pageCounter = newPageCounter;
  }

  onGlobalColorMapChanged(globalColorMap: { [key: string]: string }) {
    this.globalColorMap = { ...globalColorMap };
  }

  // updateNavigationButtonsState() {
  //   // Enable/disable navigation buttons based on pageCount
  //   this.disableLeftClick = this.pageCount <= 1; // Disable left if on the first page
  //   this.disableRightClick = this.pageCount >= this.pagesConfiguredFromLayout; // Disable right if on the last page
  // }

  disableLeftClick: boolean = true;
  disableRightClick: boolean = false;
  leftClicked: boolean = false;
  rightClicked: boolean = false;
  totalPage = 10;
  pageEvents: any;
  ispaginated: boolean = false;
  OnPageClick(events: any) {
    this.ispaginated = true;
    this.pageEvents = events;
    if (events == 'left') {
      this.pageCounter = this.pageCounter - 1;
    }
    if (events == 'right') {
      this.pageCounter = this.pageCounter + 1;
      this.disableLeftClick = false;
    }
    // if (this._configService.isIndexSelected) {
    //    this.getOutputData('reference', '') }
    // else {
    //   this.getOutputData('weight', '');
    // }
    this._configCustomService.pageCount = this.pageCounter;
    if (this.previusParameters != undefined) {
      this.getOutputData(
        this.previusParameters.type,
        this.previusParameters.isBaseType,
        this.pageCounter
      ).catch((error) => {
        console.error('Error in getOutputData:', error);
      });
    } else {
      this.getOutputData('', '', this.pageCounter).catch((error) => {
        console.error('Error in getOutputData:', error);
      });
    }
    // this.onPaginateCall(events);
  }

  onPaginateCall(events: any) {
    this.customWidgetChild.Paginate(events);
    this.disableLeftClick = this.customWidgetChild.disableLeftClick;
    this.disableRightClick = this.customWidgetChild.disableRightClick;

    if (events == 'left') {
      this.leftClicked = true;
      this.rightClicked = false;
    } else {
      this.leftClicked = false;
      this.rightClicked = true;
    }
    this.ispaginated = false;
  }

  OnSettingsSel(item: any) {
    switch (item) {
      case this.settingOptionList.ReportIssue:
        this.isReportIssue = true;
        break;
      case this.settingOptionList.ExportDownload:
        this.showExportsDownloadsPopup = true;
        break;
      case this.settingOptionList.SnapshotViews:
        window.open('https://www.figma.com/proto/7fV2UmWwIX7XJPGLDPoyk3/Explorer--Snapshot-Visuals?page-id=0%3A1&node-id=95-4612&viewport=3126%2C1977%2C0.23&t=HYEZhoeaEEp2zyIq-8&scaling=contain&content-scaling=fixed&starting-point-node-id=95%3A4612&hide-ui=1', '_blank');
        break;
      case this.settingOptionList.HelpGuide:
        window.open('assets/helpguide/index.html','_blank');
        break;
    }
  }

  onDefaultPanelChange(isDefault: boolean) {
    this._configService.selectedSection = sessionStorage.getItem('sectionName');
    this._configService.selectedSubSection =
      sessionStorage.getItem('subsectionName');
    this.snapshotselected = sessionStorage.getItem('snapshotType');
    this.pageCounter = 1;
    this._configCustomService.pageCount = 1;
    this.selectedTypeFun2(this.snapshotselected);
    this.showOutputView = false;
    this.showDefaultPanel = true;
    this.IsPPTDownloadClicked = false;
    this.SubmitClicked(isDefault);
  }

  isShowGlobalDefaultDialog: boolean = false;
  globalDefaultMessage: string = '';
  onGlobalDefaultChange(value: boolean): void {
    if (this.isGlobalDefaultSelected !== value) {
      this.isGlobalDefaultSelected = value;
      this.isShowGlobalDefaultDialog = true;
      if (this.isGlobalDefaultSelected) {
        this.globalDefaultMessage = this._configService.isSetDefault
          ? 'Your existing default selection will be switched off. Do you want to continue?'
          : 'Your Global Default Selection will be switched on.Do you want to continue?';
      } else {
        this.globalDefaultMessage =
          'Your Global Default Selection will be switched off. Do you want to continue?';
      }
      this._configService.isGlobalDefaultSelectionEnabled =
        this.isGlobalDefaultSelected;
    }
  }

  onGlobalDefaultConfirmation(operation: number) {
    if (operation === 1) {
      this._loaderService.showLoader();
      const hasExistingGlobalDefault =
        Array.isArray(this.saveSelectionGlobalDefault) &&
        this.saveSelectionGlobalDefault.length > 0;

      if (!hasExistingGlobalDefault) {
        this.subscriptions.add(this._configService
          .saveSelectionData(
            COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
            'Global Default Selection',
            this.clientDetails.clientDetails.client_code,
            this.mainStudy,
            this.clientDetails.clientDetails.study,
            '',
            '',
            '',
            '',
            '',
            '',
            true,
            false,
            '',
            '',
            '',
            false,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            this.isGlobalDefaultSelected,
            this._configService.finalLeftPanelSubmitObject?.previewData?.Audiencebrand || null
          )
          .subscribe({
            next: (result: results) => this.handleResponse(result),
            error: () => this._loaderService.hideLoader(),
          }));
      } else {
        this.subscriptions.add(this._configService
          .updateSelectionData(
            COMMON_CONSTANTS_SNAPSHOT.SnapshotModuleId,
            'Global Default Selection',
            this.clientDetails.clientDetails.client_code,
            this.mainStudy,
            this.clientDetails.clientDetails.study,
            this.isGlobalDefaultSelected
          )
          .subscribe({
            next: (result: results) => this.handleResponse(result),
            error: () => this._loaderService.hideLoader(),
          }));
      }

      this.isShowGlobalDefaultDialog = false;
    } else {
      this.isGlobalDefaultSelected = !this.isGlobalDefaultSelected;
      this.isShowGlobalDefaultDialog = false;

      const alertObj: AlertMessageModel = {
        header: 'Global default selection info',
        message: this.isGlobalDefaultSelected
          ? this._configService.isSetDefault
            ? 'Default Selection is not enabled, Global Default Selection remains.'
            : 'Global Default Selection is not disabled.'
          : this._configService.isSetDefault
          ? 'Global Default is not enabled, Default Selection remains'
          : 'Global Default Selection is not enabled',
        show: true,
      };
      this._alertService.showAlert(alertObj);
    }
    this._configService.isGlobalDefaultSelectionEnabled =
      this.isGlobalDefaultSelected;
  }

  handleResponse(result: results): void {
    try {
      if (result?.HasValidData) {
        let jsonData: any = result.Data;
        if (typeof result.Data === 'string') {
          try {
            jsonData = JSON.parse(result.Data);
          } catch {
            jsonData = result.Data;
          }
        }

        if (
          (jsonData === 'Saved Successfully' || jsonData === true) &&
          this._configService.isSetDefault
        ) {
          this.showFinalAlert(this.isGlobalDefaultSelected);
          return;
        }
      }
      this._loaderService.hideLoader();
    } catch {
      this._loaderService.hideLoader();
    }
  }

  showFinalAlert(isGlobalSelected: boolean): void {
    const alertObj: AlertMessageModel = {
      header: 'Global default selection info',
      message: isGlobalSelected
        ? 'Global Default Selection will be enabled and existing Default Selection is disabled.'
        : 'Default Selection enabled, Global Default Selection disabled',
      show: true,
    };
    this._alertService.showAlert(alertObj);
    this._loaderService.hideLoader();
  }
  checkIsUserAllowed() {
    this.subscriptions.add(this._configService.getAllowedUsers().subscribe((isAllowed) => {
      if (isAllowed) {
        this.isInsightsBtnEnabled = true;
         this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
      } else {
        this.isInsightsBtnEnabled = false;
         this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
      }
    }));
  }

  OnInsigthsbuttonClick() {
    let isFunnelChart = false;
    if (this.insightsObj['show'] == false) {
      this.insightsObj['show'] = true;
      if (this.insightsObj['message'] == '') {

        if (this.insightsObj['message'] == '') {
          const widgetDetails: any = [];

          this.outputData.forEach((item1: any) => {
            if (item1.widgetChartType === 'FUNNEL CHART') {
              isFunnelChart = true;
            }
            const matchedItem = this._configService.InsightsData.find(
              (item2: any) => item2.widget_name === item1.widgetName
            );
            if (matchedItem) {
              item1.widgetchart_name = matchedItem.widgetchart_name;

              const exists = widgetDetails.some((item: any) => item.widgetName === item1.widgetName);
              if (!exists) {
                widgetDetails.push({
                  widgetName: item1.widgetName,
                  decimalRoundOff: JSON.parse(matchedItem.customizationProperties || '{}').decimalRoundOff ?? 1
                });
              }
            }
          });

          this.arktabaccess = true;
          let brand_name = this._configService.getDropdownValues().compareAcross;
          this.InsightsResponse = [];
          

const isUnweighted =
  (this.weightSelectedValue || this.selectedWeight) === 'Unweighted';

const ShareColumn =
  this.selectedDataFormat !== 'Respondent Level'
    ? 'value'
    : this.isTotalBase
      ? isUnweighted
        ? 'totalUnweightedShare'
        : 'totalWeightedShare'
      : isUnweighted
        ? 'answerUnweightedShare'
        : 'answerWeightedShare';

const BaseColumn = this.isTotalBase
  ? 'totalUnweightedBase'
  : 'answerUnweightedBase';

const funnelChartSelectedBrand: string = isFunnelChart
  ? this._configCustomService.funnelChartSelectedItem$.value
  : '';

/*
 * Remove only blank or zero-value rows.
 * Do not validate numerator because valid custom-base rows
 * may not use the same numerator fields.
 */
const validOutputData = (this.outputData ?? []).filter((widget: any) => {
  const rawShare = this.isTotalBase
    ? isUnweighted
      ? widget.totalUnweightedShare
      : widget.totalWeightedShare
    : isUnweighted
      ? widget.answerUnweightedShare
      : widget.answerWeightedShare;

  if (rawShare === null || rawShare === undefined) {
    return false;
  }

  const share = Number(rawShare);

  return Number.isFinite(share) && share > 0;
});

console.log('AI Insights filter', {
  originalCount: this.outputData?.length ?? 0,
  filteredCount: validOutputData.length,
  selectedWeight: this.weightSelectedValue || this.selectedWeight,
  isTotalBase: this.isTotalBase
});
          this.subscriptions.add(this.apiService
            .getInsightsData(
              this.isIndexSelected,
              validOutputData,
              this.selected_study,
              this.selected_client,
              this.inforRibbon?.nativeElement.textContent,
              this.y1.DefaultConfidenceLevel,
              ShareColumn,
              BaseColumn,
              brand_name,
              funnelChartSelectedBrand,
              '',
              '',
              localStorage.getItem('useremail') ?? '',
              this.snapshotName ?? '',
              'Snapshot',
              widgetDetails
            )
            .subscribe({
              next: (result: any) => {
                this.showAiAlert = true;
                setTimeout(() => {
                  this.showAiAlert = false;
                }, 6000);

                this.isInsightspopupOpen = true;
                    this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
                this.showSnapshot = true;
                this.showOutputView = true;
                this.insightsVal = result;
                this.insightsObj['message'] = this.insightsVal;
                // Show the alert popup using the alert service
                // this._insightsSerive.showInisghts(this.InsightsResponse);
                this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
                //hide the loader
                this.arktabaccess = false;
              },
              error: (err) => {
                this.insightsObj['message'] = 'No data';
                this.insightsObj['show'] = true;
                this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
              },
            }));
        }
        if (
          this.insightsObj['message'] == '' ||
          this.insightsObj['message'] == 'loading'
        ) {
          this.insightsObj['message'] = 'loading';
          this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
        } else {
          this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
        }
      } else {
        let isSingleBrand: boolean = this._configService.getDropdownValues().compareAcross === 'Single Brand';
        if(!isSingleBrand){
          this.outputData.forEach((item1: any) => {
            if (item1.widgetChartType === 'FUNNEL CHART') {
              isFunnelChart = true;
            }
          });
          if(isFunnelChart){
            this.funeelChartInsights();
          }
        }

        this.insightsObj['show'] = true;
        this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
          this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
        if(!this.showAiAlert){
          this.showAiAlert = true;
            setTimeout(() => {
              this.showAiAlert = false;
            }, 6000);
        }
      }
    } else {
      this.insightsObj['show'] = false;
      this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
    }
  }

  funeelChartInsights() {
    localStorage.setItem('isSingleInsightsLoading', 'true');
    let brand_name = this._configService.getDropdownValues().compareAcross;
    let isFunnelChart: boolean = true;
    let funnelChartSelectedItem = isFunnelChart
    ? this._configCustomService.funnelChartSelectedItem$.value
    : '';

    let isMultipleMarkets = brand_name == 'Multiple Markets';

    let filterParam = funnelChartSelectedItem != ''? `${(isMultipleMarkets ? 'Market' : 'Brands')}|${funnelChartSelectedItem}`:'';

    let widget: any = this.outputData.find((x: any) => x.widgetChartType === 'FUNNEL CHART' && x.colChild == filterParam);
    [widget].forEach((item1: any) => {
      const matchedItem = this._configService.InsightsData.find(
        (item2: any) => item2.widget_name === item1.widgetName
      );
      if (matchedItem) {
        item1.widgetchart_name = matchedItem.widgetchart_name;
      }
    });
    this._insightsSerive.isSingleInsightsSnapshot$.next(widget);

    this.arktabaccess = true;
    this.InsightsResponse = [];
    let ShareColumn =
      this.selectedDataFormat != 'Respondent Level'
        ? 'value'
        : this.isTotalBase
        ? this.selectedWeight == 'Unweighted'
          ? 'totalUnweightedShare'
          : 'totalWeightedShare'
        : this.selectedWeight == 'Unweighted'
        ? 'answerUnweightedShare'
        : 'answerWeightedShare';
    let BaseColumn = this.isTotalBase
      ? 'totalUnweightedBase'
      : 'answerUnweightedBase';

    this.subscriptions.add(this.apiService
      .getInsightsData(
        this.isIndexSelected,
        this.outputData,
        this.selected_study,
        this.selected_client,
        this.inforRibbon?.nativeElement.textContent,
        this.y1.DefaultConfidenceLevel,
        ShareColumn,
        BaseColumn,
        brand_name,
        funnelChartSelectedItem,
        widget.widgetName,
        widget.widgetNumber,
        localStorage.getItem('useremail') ?? '',
        this.snapshotName ?? ''
      ).pipe(debounceTime(100))
      .subscribe({
        next: (result: any) => {
          // Response is valid
          this.isInsightspopupOpen = true;
           this._insightsSerive.insightsopen =  this.isInsightspopupOpen;
          this.showSnapshot = true;
          this.showOutputView = true;
          let existingInsightsVal = JSON.parse(this.insightsVal);
          existingInsightsVal[widget.widgetName] =
            JSON.parse(result)[widget.widgetName];
          this.insightsVal = JSON.stringify(Object.assign({}, existingInsightsVal));
          this.insightsObj['show'] = true;
          this.insightsObj['message'] = this.insightsVal;
          // Show the alert popup using the alert service
          // this._insightsSerive.showInisghts(this.InsightsResponse);
          this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
          //hide the loader
          this.arktabaccess = false;
        },
        error: (err) => {
          this.insightsObj['message'] = 'No data';
          this.insightsObj['show'] = true;
          this._insightsSerive.showInisghtsSnapshot(this.insightsObj);
          this._insightsSerive.isSingleInsightsSnapshot$.next(null);
        },
      }).add(()=> {
        if(widget != null) {
          this._insightsSerive.isSingleInsightsSnapshot$.next(null);
        }
      }));
  }

  private checkNegativeValuesAlert(): void {
    const outputData = this._configService.standardSnapOutputData;
    if (!Array.isArray(outputData) || outputData.length === 0) return;

    // Chart type label map: widgetchart_name (lowercase) â†’ display label
    const chartTypeLabelMap: { test: (name: string) => boolean; label: string }[] = [
      { test: (n) => n === '01/pie chart',              label: '01 pie chart' },
      { test: (n) => n === '05/pie chart',              label: '05 pie chart' },
      { test: (n) => n === '09/pie chart',              label: '09 pie chart' },
      { test: (n) => n === 'fill chart',              label: 'Fill Chart' },
      { test: (n) => n === 'vertical stack bar',      label: 'Vertical Stack Bar' },
      { test: (n) => n === 'horizontal stack bar',    label: 'Horizontal Stack Bar' },
      { test: (n) => n === 'propeller chart',         label: 'Propeller Chart' },
    ];

    // Map each eligible widget to its display label
    const widgetLabelMap = new Map<string, string>(); // widget_name â†’ display label
    (this.widgetData || []).forEach((w: any) => {
      const name = (w.widgetchart_name || '').toLowerCase();
      const entry = chartTypeLabelMap.find(e => e.test(name));
      if (entry) widgetLabelMap.set(w.widget_name, entry.label);
    });

    if (widgetLabelMap.size === 0) return;

    const isTotalBase = this.baseselected.toLowerCase() === 'total base';

    // Collect distinct chart type labels that have at least one negative row
    const labelsWithNegative = new Set<string>();
    outputData.forEach((row: any) => {
      const label = widgetLabelMap.get(row.widgetName);
      if (!label) return;
      const val = isTotalBase ? row.totalWeightedShare : row.answerWeightedShare;
      if (typeof val === 'number' && val < 0) labelsWithNegative.add(label);
    });

    if (labelsWithNegative.size > 0) {
      const chartNames = Array.from(labelsWithNegative).join(', ');
      this.negativeValuesAlertMessage = `${chartNames} - Negative valued metrics are hidden`;
      this.showNegativeValuesAlert = true;
      setTimeout(() => { this.showNegativeValuesAlert = false; }, 2000);
    }
  }

  ngOnDestroy() {
    if (this.$unSubscribeSubmitData1) {
      this.$unSubscribeSubmitData1.unsubscribe();
    }
    if (this.$unSubscribeSubmitData) {
      this.$unSubscribeSubmitData.unsubscribe();
    }
    if (this.$unSubscribeSubmitData6) {
      this.$unSubscribeSubmitData6.unsubscribe();
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Optimizes page layout by removing unnecessary pages based on precise widget count logic
   * @param pageDetails - Array of page objects with key and value properties
   * @param widgetCount - Number of widgets that need to be accommodated
   * @returns Optimized array of page details
   */
  optimizePageLayout(pageDetails: any[], widgetCount: number): any[] {

    // Validation checks
    if (!pageDetails || pageDetails.length === 0) {
      return [];
    }

    if (widgetCount <= 0) {
      return pageDetails.length > 0 ? [pageDetails[0]] : [];
    }

    // Sort pages by their natural order (Page 1, Page 2, etc.)
    const sortedPages = [...pageDetails].sort((a, b) => {
      const getPageNumber = (pageKey: string) => {
        const match = pageKey.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      };
      return getPageNumber(a.key) - getPageNumber(b.key);
    });

    // // PRECISE LOGIC: Check for exact matches first
    // const exactMatchPage = sortedPages.find(page => (page.value || 0) === widgetCount);
    // if (exactMatchPage) {
    //   return [exactMatchPage];
    // }

    // // PRECISE LOGIC: Find the smallest page that can accommodate all widgets
    // const efficientPages = sortedPages
    //   .filter(page => (page.value || 0) >= widgetCount)
    //   .sort((a, b) => (a.value || 0) - (b.value || 0));

    // if (efficientPages.length > 0) {
    //   const mostEfficientPage = efficientPages[0];
    //   return [mostEfficientPage];
    // }

    // PRECISE LOGIC: Use minimum pages with optimal combination
    const optimalCombination = this.findMinimalPageCombination(sortedPages, widgetCount);



    return optimalCombination;
  }

  /**
   * Finds the minimal combination of pages needed to accommodate the target widgets
   * Uses a greedy approach optimized for real-world scenarios
   * @param pages - Available pages sorted by order
   * @param targetWidgets - Number of widgets to accommodate
   * @returns Minimal page combination
   */
  private findMinimalPageCombination(pages: any[], targetWidgets: number): any[] {
    // Strategy 1: Greedy approach - always pick the largest capacity that doesn't exceed remaining needs
    // let greedyResult = this.greedyPageSelection(pages, targetWidgets);

    // Strategy 2: Sequential approach - take pages in order until capacity is met
    let sequentialResult = this.sequentialPageSelection(pages, targetWidgets);

    // Return the approach that uses fewer pages
    const result =  sequentialResult;



    return result;
  }

  /**
   * Greedy page selection - prioritizes larger pages first
   */
  private greedyPageSelection(pages: any[], targetWidgets: number): any[] {
    const sortedByCapacity = [...pages].sort((a, b) => (b.value || 0) - (a.value || 0));
    const selected = [];
    let remaining = targetWidgets;

    for (const page of sortedByCapacity) {
      if (remaining <= 0) break;

      const capacity = page.value || 0;
      if (capacity > 0) {
        selected.push(page);
        remaining -= capacity;
      }
    }

    // Sort back to natural order
    return selected.sort((a, b) => {
      const getPageNumber = (pageKey: string) => {
        const match = pageKey.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      };
      return getPageNumber(a.key) - getPageNumber(b.key);
    });
  }

  /**
   * Sequential page selection - takes pages in natural order
   */
  private sequentialPageSelection(pages: any[], targetWidgets: number): any[] {
    const selected = [];
    let remaining = targetWidgets;

    for (const page of pages) {
      if (remaining <= 0) break;

      const capacity = page.value || 0;
      selected.push(page);
      remaining -= capacity;
    }

    return selected;
  }

  /**
   * Calculates enhanced widget count considering actual output data
   * @param widgetDetails - Array of widget detail objects
   * @param basicCount - Basic widget count from widgetDetails.length
   * @returns Enhanced widget count for more accurate page optimization
   */
private calculateEnhancedWidgetCount(widgetDetails: any[], basicCount: number): number {
    // Always use widgetDetails for widget names, not outputData
    let enhancedCount = basicCount;

    if (Array.isArray(widgetDetails) && widgetDetails.length > 0) {
        try {
            // Get unique widget names from widgetDetails only
            const distinctWidgetNames = _.uniqBy(widgetDetails, 'widget_name').map(
                (item: any) => item.widget_name
            );

            if (distinctWidgetNames.length > 0 && distinctWidgetNames.length <= basicCount) {
                enhancedCount = distinctWidgetNames.length;
            }
        } catch (error) {
            console.log('Could not calculate enhanced widget count from widgetDetails, using basic count');
        }
    }

    // Ensure we have at least 1 widget for optimization logic
    return Math.max(enhancedCount, 1);
}


  private logOptimizationResults(originalPages: any[], optimizedPages: any[], widgetCount: number): void {


    const originalCapacity = originalPages.reduce((sum, p) => sum + (p.value || 0), 0);
    const optimizedCapacity = optimizedPages.reduce((sum, p) => sum + (p.value || 0), 0);


    if (optimizedPages.length < originalPages.length) {
      const removedPages = originalPages.filter(op =>
        !optimizedPages.some(np => np.key === op.key)
      );
    }

  }

updateDocClick(eventData: { isDocumentRepositoryClick: boolean }): void {
    this.isDocumentRepositoryClick = eventData.isDocumentRepositoryClick;
  }
getFilteredBrandList(): any[] {
    if (!this.brandList || this.brandList.length === 0) return [];
    const q = (this.brandSearchQuery || '').trim().toLowerCase();
    if (!q) return this.brandList;
    return this.brandList.filter(b => {
      const value = (b.value || b.key || '').toString().toLowerCase();
      const label = (b.key || b.response_label || b.variable_label || '').toString().toLowerCase();
      return value.includes(q) || label.includes(q);
    });
  }
handleDocumentRepo() {
    this.docStorageData = [];
    this._loaderService.showLoader();
    this.$unSubscribeSubmitData = this.crossTabService
      .getDocumentStorage(this.selected_client, this.clientDetails.clientDetails.study)
      .subscribe((result: results) => {
        if (result.HasValidData) {
          var JsonData = JSON.parse(result.Data);
          if (JsonData.documents.length > 0) {
            this.docStorageData = JsonData.documents;
             this.isDocumentRepositoryClick = true;
             this.hasDocuments = true;
          } else {
            this.errorPopup('No Document Found', 'Alert');
            this.isDocumentRepositoryClick = false;
            this.hasDocuments = false;
          }
        }
        this._loaderService.hideLoader();
      });
  }

  checkDocumentAvailability() {
    this.subscriptions.add(this.crossTabService
      .getDocumentStorage(this.selected_client, this.clientDetails.clientDetails.study)
      .subscribe((result: results) => {
        if (result.HasValidData) {
          var JsonData = JSON.parse(result.Data);
          this.hasDocuments = JsonData.documents.length > 0;
        } else {
          this.hasDocuments = false;
        }
      }));
  }
  getAudienceVariableCodes(
  audienceData: any[],
  selectedAudience: string[]
): string[] {
  const variableCodes: string[] = [];

  audienceData.forEach(level1 => {
    if (level1.Level2_children?.length) {
      level1.Level2_children.forEach((child: any) => {
        const label = child.Level2_value 

        if (selectedAudience.includes(label)) {
          variableCodes.push(child.data_variable_code);
        }
      });
    }
  });

  return variableCodes;
}

get showSignificanceDropdown(): boolean {
  return Array.isArray(this.significance) && this.significance.length > 0;
}

get showConfidenceDropdown(): boolean {
  return Array.isArray(this.confidenceLevel) && this.confidenceLevel.length > 0;
}
 getPopupWidgetName(item: any): string {
  // Safety check
  if (!item?.widget_name) {
    return '';
  }

  let widgetName = item.widget_name;

  // Append selected metric only when metric dropdown is active and has multiple options
  const metricCount = item?.metric?.[0]?.metric_value?.length ?? 0;
  if (item?.metricdropdownOutput == 1 && metricCount > 1 && item?.selectedMetric) {
    widgetName = `${widgetName} - ${item.selectedMetric}`;
  }

  const isAudienceSnapshot =
    this._configService.selectedSnapshotType
      ?.toLowerCase()
      ?.includes('audience');

  // Not an Audience snapshot â†’ return name
  if (!isAudienceSnapshot) {
    return widgetName;
  }

  // Audience present â†’ return name
  if (item?.audience != null) {
    return widgetName;
  }

  const brandLabel = this.getSelectedBrandLabel(item); // '(Brand)' or ''

  // No brand â†’ return name
  if (!brandLabel) {
    return widgetName;
  }

  // Avoid duplicate brand append
  if (widgetName.includes(brandLabel)) {
    return widgetName;
  }

  // Append brand with CSS class for styling
  return `${widgetName} <span class="itemBrandLabel">${brandLabel}</span>`;

}
 getSelectedBrandLabel(item: any): string {
  // If audience is NOT null, return empty string
  if (item?.audience != null) {
    return '';
  }

  const value =
    this._configService?.finalLeftPanelSubmitObject?.previewData
      ?.Audiencebrand?.[0]?.option;

  if (!value) {
    return '';
  }
  const rawBrandName = value.split('|').pop() ?? value;
  const brandName = `(${rawBrandName})`;
  return brandName;
}


}

